import { C as e, S as t, _ as n, a as r, b as i, c as a, d as o, f as s, g as c, h as l, i as u, l as d, m as f, n as p, o as m, p as h, r as g, s as _, u as v, v as y, x as b, y as x } from "./ui-BYUpyHph.js";
import { a as S, c as C, i as w, n as T, s as E, t as D } from "./i18n-QsyhtsgC.js";
import { createContext as O, forwardRef as k, useCallback as A, useContext as j, useEffect as M, useImperativeHandle as N, useLayoutEffect as P, useMemo as F, useReducer as I, useRef as L, useState as R } from "react";
import { Fragment as z, jsx as B, jsxs as V } from "react/jsx-runtime";
import { BuddyApiError as H, IMAGE_REF_SCHEME as U, createBuddyClient as W, isAbortError as G, isImageRef as K, memoryStore as q, normalizeReport as J, parseImageRef as ee, rolesFromToken as Y, webStore as te } from "@nycelogic/nycebuddy-api-client";
import ne from "dompurify";
import { marked as re } from "marked";
import { BarChart3 as ie, Bookmark as ae, Bot as oe, Brain as se, CalendarClock as ce, Check as le, ChevronRight as ue, CircleX as de, Copy as fe, Download as pe, Eye as me, EyeOff as he, FileDown as ge, FileSpreadsheet as _e, FileText as ve, Headphones as ye, History as be, Image as xe, Info as Se, Loader2 as X, LogOut as Ce, MessageSquareReply as we, Mic as Te, MoreVertical as Ee, Paperclip as Z, Pencil as De, Play as Oe, Plus as ke, RefreshCw as Ae, Send as je, Settings as Me, ShieldCheck as Ne, Sparkles as Pe, Square as Fe, Star as Ie, ThumbsDown as Le, ThumbsUp as Re, Trash2 as ze, Volume2 as Be, X as Ve, Zap as He } from "lucide-react";
// src/report/mdcore.ts
var Ue = (e) => String(e).replace(/[&<>"]/g, (e) => ({
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;"
})[e]), We = (e) => e.replace(/\\\\|\\(?![\\/"bfnrtu])/g, (e) => e === "\\\\" ? e : "\\\\"), Ge = [
	[/\t(?=ext\b|imes\b|heta\b|au\b|o\b)/g, "\\t"],
	[/\f(?=rac\b)/g, "\\f"],
	[/\n(?=eq\b|e\b|u\b)/g, "\\n"],
	[/\r(?=ightarrow\b|ho\b)/g, "\\r"],
	[/\x08(?=eta\b)/g, "\\b"]
], Ke = (e) => Ge.reduce((e, [t, n]) => e.replace(t, n), e), qe = null;
function Je() {
	let e = globalThis.katex;
	return e != null && e.renderToString ? Promise.resolve(e) : typeof document > "u" ? Promise.resolve(null) : (qe != null || (qe = new Promise((e) => {
		let t = "https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.16.21/";
		if (!document.querySelector("link[data-nb-katex]")) {
			let e = document.createElement("link");
			e.rel = "stylesheet", e.href = `${t}katex.min.css`, e.crossOrigin = "anonymous", e.setAttribute("data-nb-katex", ""), document.head.appendChild(e);
		}
		let n = document.createElement("script");
		n.src = `${t}katex.min.js`, n.crossOrigin = "anonymous", n.async = !0, n.onload = () => {
			var t;
			return e((t = globalThis.katex) == null ? null : t);
		}, n.onerror = () => e(null), document.head.appendChild(n);
	})), qe);
}
function Ye(e, t, n) {
	let r = Ke(e);
	if (n) try {
		return n(r, t);
	} catch {}
	let i = globalThis.katex;
	if (typeof (i == null ? void 0 : i.renderToString) == "function") try {
		return i.renderToString(r, {
			throwOnError: !1,
			displayMode: t,
			output: "html"
		});
	} catch {}
	return Ue(Qe(t ? `$$${r}$$` : `$${r}$`));
}
var Xe = {
	times: "×",
	sum: "Σ",
	approx: "≈",
	le: "≤",
	ge: "≥",
	neq: "≠",
	ne: "≠",
	pm: "±",
	cdot: "·",
	percent: "%",
	rightarrow: "→",
	to: "→",
	infty: "∞",
	ldots: "…",
	dots: "…",
	frac: ""
}, Ze = {
	0: "⁰",
	1: "¹",
	2: "²",
	3: "³",
	4: "⁴",
	5: "⁵",
	6: "⁶",
	7: "⁷",
	8: "⁸",
	9: "⁹",
	"-": "⁻"
};
function Qe(e) {
	if (!/[$\\\t^]/.test(e)) return e;
	let t = (e) => Ke(e).replace(/\\(?:text|mathrm|textbf|mathbf|operatorname)\s*\{([^}]*)\}/g, "$1").replace(/\\frac\s*\{([^}]*)\}\s*\{([^}]*)\}/g, "$1/$2").replace(/\\([%$&#])/g, "$1").replace(/\\([a-zA-Z]+)/g, (e, t) => t in Xe ? Xe[t] : t).replace(/\^\{?([0-9-]+)\}?/g, (e, t) => [...t].map((e) => {
		var t;
		return (t = Ze[e]) == null ? e : t;
	}).join("")).replace(/_\{([^}]*)\}/g, "$1").replace(/[{}]/g, "").replace(/\s*([×Σ≈≤≥≠±·→])\s*/g, " $1 ").replace(/\s{2,}/g, " ").trim();
	return e.replace(/\$\$([^$]+)\$\$/g, (e, n) => t(n)).replace(/\$([^$\n]+)\$/g, (e, n) => t(n)).replace(/\\(?:text|mathrm)\s*\{([^}]*)\}/g, "$1");
}
var $e = /\$\$([^$]+)\$\$|(?<![\\$\w])\$([^$\n]+?)\$(?![\w$])/g;
function et(e, t) {
	let n = [];
	return {
		text: String(e == null ? "" : e).replace($e, (e, r, i) => {
			var a;
			return n.push(Ye((a = r == null ? i : r) == null ? "" : a, r !== void 0, t)), `\u0001${n.length - 1}\u0001`;
		}),
		restore: (e) => e.replace(/\u0001(\d+)\u0001/g, (e, t) => n[+t])
	};
}
function tt(e, t) {
	let { text: n, restore: r } = et(String(e == null ? "" : e), t), i = (e) => r(Ue(e).replace(/`([^`]+)`/g, "<code>$1</code>").replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>").replace(/(^|[^*])\*([^*\n]+)\*/g, "$1<em>$2</em>").replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, "<a href=\"$2\" target=\"_blank\" rel=\"noopener\">$1</a>")), a = [], o = null, s = [], c = () => {
		s.length && (a.push(`<p>${i(s.join(" "))}</p>`), s = []);
	}, l = () => {
		o && (a.push(`</${o}>`), o = null);
	};
	for (let e of n.split(/\r?\n/)) {
		let t = e.trimEnd(), n = /^(#{1,4})\s+(.*)$/.exec(t), r = /^\s*(?:[-*•]|\d+[.)])\s+(.*)$/.exec(t);
		if (!t.trim()) c(), l();
		else if (n) c(), l(), a.push(`<h${n[1].length + 2}>${i(n[2])}</h${n[1].length + 2}>`);
		else if (r) {
			c();
			let e = /^\s*\d/.test(t) ? "ol" : "ul";
			o !== e && (l(), a.push(`<${e}>`), o = e), a.push(`<li>${i(r[1])}</li>`);
		} else l(), s.push(t.trim());
	}
	return c(), l(), a.join("");
}
var nt = /(<img\b[^>]*?\s)src\s*=\s*(["']?)(nyce-image:\/\/[^"'\s>]+)\2/gi;
function rt(e) {
	return e.includes(U) ? e.replace(nt, "$1data-nb-image=\"$3\"") : e;
}
var it = !1;
function at() {
	return it || (it = !0, re.use({ renderer: { image({ href: e, text: t, title: n }) {
		if (!e.startsWith(U)) return !1;
		let r = n ? ` title="${Ue(n)}"` : "";
		return `<img class="nb-img" data-nb-image="${Ue(e)}" alt="${Ue(t)}"${r}>`;
	} } })), re;
}
var ot = !1;
function st() {
	return !ot && typeof ne.addHook == "function" && (ot = !0, ne.addHook("afterSanitizeAttributes", (e) => {
		e.tagName === "A" && e.getAttribute("href") && (e.setAttribute("target", "_blank"), e.setAttribute("rel", "noopener noreferrer"));
	})), ne;
}
var ct = {
	USE_PROFILES: {
		html: !0,
		mathMl: !0
	},
	ADD_ATTR: ["target"],
	FORBID_TAGS: [
		"style",
		"iframe",
		"object",
		"embed",
		"form",
		"input"
	]
};
function lt(e) {
	return st().sanitize(e, ct);
}
function ut(e, t) {
	let n = String(e == null ? "" : e);
	if (!n.trim()) return "";
	let { text: r, restore: i } = et(rt(n), t), a;
	try {
		a = at().parse(r, {
			async: !1,
			gfm: !0,
			breaks: !1
		});
	} catch {
		a = tt(r);
	}
	return lt(i(a));
}
var dt = (e) => $e.test(String(e == null ? "" : e));
// src/report/partialReport.ts
function ft(e) {
	let t = e.indexOf("{");
	if (t < 0) return null;
	let n = !1, r = !1, i = "", a = !1, o = "", s = !1, c = "", l = [], u = !1, d = 0;
	for (let f = t; f < e.length; f++) {
		let t = e[f];
		if (n) {
			if (r) {
				r = !1, a && (i += t);
				continue;
			}
			if (t === "\\") {
				r = !0, a && (i += t);
				continue;
			}
			if (t === "\"") {
				n = !1, a && (a = !1, o = i, s = !0), c = t;
				continue;
			}
			a && (i += t);
		} else if (!/\s/.test(t)) {
			if (c = t, t === "\"") {
				n = !0;
				let e = l[l.length - 1];
				e && e.type === "{" && e.expectKey && (a = !0, i = "", e.expectKey = !1);
			} else if (t === ":") s = !1;
			else if (t === "{") l.push({
				type: "{",
				expectKey: !0
			});
			else if (t === "[") l.push({ type: "[" }), o === "rows" && l.length === 2 && (u = !0);
			else if (t === "}" || t === "]") l.pop(), t === "}" && u && l.length === 2 && d++, t === "]" && l.length === 1 && (u = !1);
			else if (t === ",") {
				let e = l[l.length - 1];
				e && e.type === "{" && (e.expectKey = !0);
			}
		}
	}
	let f = e.slice(t);
	n ? f += a ? "\":null" : "\"" : s ? f += ":null" : c === ":" ? f += "null" : c === "," && (f = f.replace(/,\s*$/, ""));
	for (let e = l.length - 1; e >= 0; e--) f += l[e].type === "{" ? "}" : "]";
	let p;
	try {
		p = JSON.parse(f);
	} catch {
		try {
			p = JSON.parse(We(f));
		} catch {
			return null;
		}
	}
	if (!p || typeof p != "object") return null;
	let m = Array.isArray(p.rows) ? p.rows : [];
	return {
		heading: typeof p.heading == "string" ? p.heading : "",
		answer: typeof p.answer == "string" ? p.answer : "",
		rows: m.slice(0, d),
		pending: m.length > d ? m[d] : null
	};
}
// src/hooks/useAskStream.ts
var pt = {
	status: "idle",
	connection: "connected",
	activities: [],
	answerText: "",
	partial: null,
	log: []
}, mt = {
	run_query: "Querying warehouse data",
	run_python: "Analyzing results",
	load_entities: "Loading more schema definitions",
	query_logs: "Searching server logs",
	search_docs: "Searching documentation",
	search_config_tool: "Searching the Configuration Tool",
	clarify: "Asking a clarifying question",
	finish: "Preparing the answer"
};
function ht(e, t, n) {
	let r = e.findIndex((e) => e.id === t);
	if (r < 0) return [...e, n(void 0)];
	let i = e.slice();
	return i[r] = n(e[r]), i;
}
function gt(e, t, n) {
	return e.map((e) => e.state === "running" ? {
		...e,
		state: t,
		endedAt: n
	} : e);
}
function _t(e, t) {
	return (n) => {
		var r, i, a, o, s, c, l, u, d, f, p, m;
		return {
			id: e.activityId,
			stage: e.stage,
			state: e.state,
			title: e.message || (n == null ? void 0 : n.title) || e.stage,
			titleKey: (r = e.titleKey) == null ? n == null ? void 0 : n.titleKey : r,
			detail: (i = e.detail) == null ? n == null ? void 0 : n.detail : i,
			step: (a = e.turn) == null ? n == null ? void 0 : n.step : a,
			data: e.data ? {
				...n == null ? void 0 : n.data,
				query: (o = e.data.query) == null ? n == null || (s = n.data) == null ? void 0 : s.query : o,
				code: (c = e.data.code) == null ? n == null || (l = n.data) == null ? void 0 : l.code : c,
				error: (u = e.data.error) == null ? n == null || (d = n.data) == null ? void 0 : d.error : u,
				preview: (f = e.data.preview) == null ? n == null || (p = n.data) == null ? void 0 : p.preview : f
			} : n == null ? void 0 : n.data,
			startedAt: (m = n == null ? void 0 : n.startedAt) == null ? t : m,
			endedAt: e.state === "running" ? void 0 : t
		};
	};
}
function vt(e, t) {
	switch (t.type) {
		case "reset": return pt;
		case "start": return {
			...pt,
			status: "queued",
			startedAt: t.at
		};
		case "partial": return t.partial ? {
			...e,
			partial: t.partial
		} : e;
		case "connection": return e.connection === t.connection ? e : {
			...e,
			connection: t.connection
		};
		case "done": {
			var n, r;
			let i = t.at;
			return {
				...e,
				status: "done",
				result: t.result,
				usage: (n = t.result.tokenUsage) == null ? e.usage : n,
				activities: gt(e.activities, "completed", i),
				endedAt: i,
				current: void 0,
				log: (r = t.result.log) != null && r.length ? t.result.log : e.log
			};
		}
		case "fail": return {
			...e,
			status: t.cancelled ? "cancelled" : "error",
			error: t.error,
			activities: gt(e.activities, "interrupted", t.at),
			endedAt: t.at,
			current: void 0
		};
		case "event": {
			let { event: n, at: r } = t;
			switch (n.event) {
				case "accepted": return {
					...e,
					turnId: n.data.turnId
				};
				case "progress": {
					var i;
					let t = n.data, a = t.stage === "answer", o = t.stage === "model" && t.state === "running";
					return {
						...e,
						status: a || e.status === "answering" && !o ? "answering" : "running",
						activities: ht(e.activities, t.activityId, _t(t, r)),
						answerText: o ? "" : e.answerText,
						partial: o ? null : e.partial,
						usage: (i = t.usage) == null ? e.usage : i,
						current: t.state === "running" ? {
							title: t.message,
							titleKey: t.titleKey,
							stage: t.stage,
							state: t.state,
							step: t.turn
						} : e.current
					};
				}
				case "function_call": {
					var a;
					let t = n.data, i = (a = t.functionArgs) == null ? {} : a, o = t.message || mt[t.functionName] || t.functionName;
					return {
						...e,
						status: "running",
						activities: ht(e.activities, t.activityId, (e) => {
							var n, a, s, c;
							return {
								id: t.activityId,
								stage: t.functionName,
								state: "running",
								title: o,
								titleKey: t.titleKey,
								tool: t.functionName,
								step: (n = t.turn) == null ? e == null ? void 0 : e.step : n,
								data: {
									...e == null ? void 0 : e.data,
									query: typeof i.query == "string" ? i.query : e == null || (a = e.data) == null ? void 0 : a.query,
									code: typeof i.code == "string" ? i.code : e == null || (s = e.data) == null ? void 0 : s.code,
									args: i
								},
								startedAt: (c = e == null ? void 0 : e.startedAt) == null ? r : c
							};
						}),
						current: {
							title: o,
							titleKey: t.titleKey,
							tool: t.functionName,
							state: "running",
							step: t.turn
						}
					};
				}
				case "function_result": {
					var o;
					let t = n.data;
					return {
						...e,
						usage: (o = t.usage) == null ? e.usage : o,
						activities: ht(e.activities, t.activityId, (e) => {
							var n, i, a, o, s, c, l, u, d;
							return {
								id: t.activityId,
								stage: (n = e == null ? void 0 : e.stage) == null ? t.functionName : n,
								state: t.error ? "failed" : "completed",
								title: (i = (a = t.reused || e == null ? void 0 : e.title) == null ? mt[t.functionName] : a) == null ? t.functionName : i,
								titleKey: t.reused ? "tool.reused" : e == null ? void 0 : e.titleKey,
								tool: t.functionName,
								step: (o = t.turn) == null ? e == null ? void 0 : e.step : o,
								data: {
									...e == null ? void 0 : e.data,
									preview: (s = t.functionResult) == null ? e == null || (c = e.data) == null ? void 0 : c.preview : s,
									error: (l = t.error) == null ? e == null || (u = e.data) == null ? void 0 : u.error : l
								},
								startedAt: (d = e == null ? void 0 : e.startedAt) == null ? r : d,
								endedAt: r,
								duration: t.duration,
								reused: t.reused
							};
						})
					};
				}
				case "answer": return {
					...e,
					status: "answering",
					answerText: e.answerText + n.data.delta
				};
				case "log": return {
					...e,
					log: [...e.log, n.data.message]
				};
				default: return e;
			}
		}
		default: return e;
	}
}
function yt({ client: e, throttleMs: t = 120, onEvent: n, now: r = () => Date.now() }) {
	let [i, a] = I(vt, pt), o = L(null), s = L(null), c = L(""), l = L(null), u = L(n);
	u.current = n;
	let d = A(() => {
		l.current = null, a({
			type: "partial",
			partial: ft(c.current)
		});
	}, []), f = A(() => {
		l.current || (l.current = setTimeout(d, t));
	}, [d, t]), p = A(() => {
		if (!o.current) return;
		o.current.abort();
		let t = s.current;
		s.current = null, t && e.cancelTurn && e.cancelTurn(t).catch(() => {});
	}, [e]), m = A(() => {
		p(), c.current = "", a({ type: "reset" });
	}, [p]), h = A(async (e, t) => {
		var n;
		(n = o.current) == null || n.abort();
		let i = new AbortController();
		o.current = i, s.current = t == null ? null : t, c.current = "", l.current && (clearTimeout(l.current), l.current = null), a({
			type: "start",
			at: r()
		}), t && a({
			type: "event",
			event: {
				event: "accepted",
				data: { turnId: t }
			},
			at: r()
		});
		try {
			let t = await e({
				signal: i.signal,
				onEvent: (e) => {
					var t;
					i.signal.aborted || (e.event === "accepted" && (s.current = e.data.turnId), e.event === "answer" ? (c.current += e.data.delta, f()) : e.event === "progress" && e.data.stage === "model" && e.data.state === "running" && (c.current = ""), a({
						type: "event",
						event: e,
						at: r()
					}), (t = u.current) == null || t.call(u, e));
				},
				onConnection: (e) => {
					i.signal.aborted || a({
						type: "connection",
						connection: e
					});
				}
			});
			return l.current && (clearTimeout(l.current), l.current = null), a({
				type: "done",
				result: t,
				at: r()
			}), t;
		} catch (e) {
			l.current && (clearTimeout(l.current), l.current = null);
			let t = G(e) || i.signal.aborted, n = e, o = (n == null ? void 0 : n.status) === 429 || (n == null ? void 0 : n.code) === "limit_exceeded";
			a({
				type: "fail",
				error: {
					message: t ? "Request cancelled" : (n == null ? void 0 : n.message) || String(e),
					code: t ? "cancelled" : o ? "limit_exceeded" : n == null ? void 0 : n.code,
					status: n == null ? void 0 : n.status,
					limitStatus: n == null ? void 0 : n.limitStatus
				},
				at: r(),
				cancelled: t
			});
			return;
		} finally {
			o.current === i && (o.current = null, s.current = null);
		}
	}, [r, f]), g = A((t) => h((n) => e.ask(t, n)), [e, h]), _ = A((t, n) => e.attachTurn ? h((r) => e.attachTurn(t, {
		...r,
		after: n
	}), t) : Promise.resolve(void 0), [e, h]);
	M(() => () => {
		var e;
		(e = o.current) == null || e.abort(), l.current && clearTimeout(l.current);
	}, []);
	let v = i.status === "queued" || i.status === "running" || i.status === "answering";
	return F(() => ({
		state: i,
		start: g,
		attach: _,
		cancel: p,
		reset: m,
		busy: v
	}), [
		i,
		g,
		_,
		p,
		m,
		v
	]);
}
// src/hooks/storage.ts
function bt(e) {
	if (e === "memory" || typeof window > "u") return q();
	try {
		return te(e === "local" ? window.localStorage : window.sessionStorage);
	} catch {
		return q();
	}
}
var xt = /* @__PURE__ */ new Map();
function St(e = {}) {
	var t, n;
	let r = (t = e.prefix) == null ? "nb" : t, i = (n = e.scope) == null ? "session" : n, a;
	if (e.adapter) a = e.adapter;
	else if (i === "memory") {
		var o;
		a = (o = xt.get(r)) == null ? q() : o, xt.set(r, a);
	} else a = bt(i);
	let s = (e) => `${r}:${e}`;
	return {
		prefix: r,
		get: (e) => a.get(s(e)),
		set: (e, t) => a.set(s(e), t),
		remove: (e) => a.remove(s(e)),
		getJson(e) {
			let t = a.get(s(e));
			if (t == null) return null;
			try {
				return JSON.parse(t);
			} catch {
				return null;
			}
		},
		setJson: (e, t) => a.set(s(e), JSON.stringify(t)),
		scope: (t) => St({
			prefix: r,
			scope: e.adapter ? i : t,
			adapter: e.adapter
		})
	};
}
function Ct() {
	let e = typeof crypto < "u" ? crypto : void 0;
	if (e && typeof e.randomUUID == "function") return e.randomUUID();
	let t = /* @__PURE__ */ new Uint8Array(16);
	if (e && typeof e.getRandomValues == "function") e.getRandomValues(t);
	else for (let e = 0; e < 16; e++) t[e] = Math.floor(Math.random() * 256);
	t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
	let n = [...t].map((e) => e.toString(16).padStart(2, "0")).join("");
	return `${n.slice(0, 8)}-${n.slice(8, 12)}-${n.slice(12, 16)}-${n.slice(16, 20)}-${n.slice(20)}`;
}
// src/hooks/useConversation.ts
var wt = "session_id";
function Tt({ client: e, storage: t, initialSessionId: n, maxMessages: r = 15 }) {
	let [i, a] = R(() => {
		let e = n || t.get(wt) || Ct();
		return t.set(wt, e), e;
	}), [o, s] = R([]), c = L(i);
	c.current = i;
	let l = A((e) => {
		c.current = e, t.set(wt, e), a(e);
	}, [t]), u = A((e) => s((t) => [...t, e].slice(-r)), [r]), d = A((e, t) => s((n) => n.map((n) => n.id === e ? {
		...n,
		...t
	} : n)), []), f = A(async () => {
		let t = c.current, n = Ct();
		if (l(n), s([]), e) try {
			await e.newConversation(t);
		} catch {}
		return n;
	}, [e, l]), p = A((e, t) => {
		l(e), s(t ? t.slice(-r) : []);
	}, [l, r]);
	return F(() => ({
		sessionId: i,
		messages: o,
		addMessage: u,
		updateMessage: d,
		setMessages: s,
		newConversation: f,
		loadConversation: p
	}), [
		i,
		o,
		u,
		d,
		f,
		p
	]);
}
// src/hooks/useScrollManagement.ts
function Et({ isStreaming: e, contentKey: t, threshold: n = 48 }) {
	let r = L(null), i = L(null), a = L(0), o = L(0), s = L(!1), c = L(!0), l = L(!0), u = L(null), d = A((e) => {
		s.current = !0;
		let t = i.current;
		t ? (typeof t.scrollTo == "function" ? t.scrollTo({
			top: t.scrollHeight,
			behavior: e ? "smooth" : "auto"
		}) : t.scrollTop = t.scrollHeight, o.current = t.scrollTop, typeof requestAnimationFrame == "function" ? requestAnimationFrame(() => s.current = !1) : s.current = !1) : s.current = !1;
	}, []), f = A((t = !0) => {
		e || (l.current = !1), typeof requestAnimationFrame == "function" ? u.current === null && (u.current = requestAnimationFrame(() => {
			u.current = null, d(t);
		})) : d(t);
	}, [e, d]), p = A(() => {
		l.current = !0;
	}, []);
	return M(() => {
		let e = i.current;
		if (!e) return;
		let t = () => {
			let t = e.scrollHeight - (e.scrollTop + e.clientHeight) <= n;
			c.current = t, t ? l.current = !0 : !s.current && e.scrollTop < o.current && (l.current = !1), o.current = e.scrollTop;
		};
		return e.addEventListener("scroll", t, { passive: !0 }), t(), a.current = e.scrollHeight, () => e.removeEventListener("scroll", t);
	}, [n]), M(() => {
		i.current && (c.current || l.current) && f(!1);
	}, [t, f]), M(() => {
		let e = i.current;
		if (!e || typeof MutationObserver > "u") return;
		let t = () => {
			let t = e.scrollHeight;
			t > a.current && ((c.current || l.current) && f(!1), a.current = t);
		}, n = typeof ResizeObserver < "u" ? new ResizeObserver(t) : null, r = () => {
			if (n) {
				n.disconnect();
				for (let t of Array.from(e.children)) n.observe(t);
			}
		}, o = new MutationObserver((n) => {
			n.some((t) => t.type === "childList" && t.target === e) && r(), t();
		});
		return o.observe(e, {
			childList: !0,
			subtree: !0,
			characterData: !0
		}), r(), () => {
			o.disconnect(), n == null || n.disconnect();
		};
	}, [e, f]), {
		messagesEndRef: r,
		messagesContainerRef: i,
		scrollToBottom: f,
		enableAutoScroll: p
	};
}
// src/hooks/useUserSettings.ts
var Dt = {
	showRawData: !1,
	language: "en",
	fontSize: "medium"
}, Ot = "settings";
function kt({ client: e, storage: t, enabled: n = !0, initial: r }) {
	let [i, a] = R(() => {
		var e;
		return {
			...Dt,
			...(e = t == null ? void 0 : t.getJson(Ot)) == null ? {} : e,
			...r
		};
	}), [o, s] = R(n), [c, l] = R(null), u = L(!0);
	M(() => (u.current = !0, () => {
		u.current = !1;
	}), []);
	let d = A((e) => {
		a(e), t == null || t.setJson(Ot, e);
	}, [t]), f = A(async () => {
		if (n) {
			s(!0);
			try {
				let t = await e.settings.get();
				u.current && d({
					...Dt,
					...t
				}), l(null);
			} catch (e) {
				u.current && l(e.message);
			} finally {
				u.current && s(!1);
			}
		}
	}, [
		e,
		n,
		d
	]);
	M(() => {
		f();
	}, [f]);
	let p = A(async (t) => {
		let r = i, a = {
			...i,
			...t
		};
		if (d(a), !n) return null;
		try {
			let t = await e.settings.put(a);
			return u.current && t && typeof t == "object" && d({
				...a,
				...t
			}), l(null), null;
		} catch (e) {
			return u.current && (l(e.message), e.status === 400 && d(r)), e;
		}
	}, [
		i,
		d,
		e,
		n
	]);
	return F(() => ({
		settings: i,
		loading: o,
		error: c,
		update: p,
		reload: f
	}), [
		i,
		o,
		c,
		p,
		f
	]);
}
// src/drawers/HistoryDrawer.tsx
var At = (e) => {
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : t.toLocaleString(void 0, {
		dateStyle: "medium",
		timeStyle: "short"
	});
};
function jt({ open: e, onClose: t, client: r, currentSessionId: i, onContinue: a, onNewConversation: o, refreshKey: s }) {
	let { t: u } = C(), [d, p] = R([]), [m, h] = R(!1), [g, _] = R(null), [v, y] = R(!1), [b, x] = R(null), S = A(async () => {
		h(!0), _(null);
		try {
			let e = await r.conversations.list({
				limit: 50,
				starred: v || void 0
			});
			p([...e.items].sort((e, t) => Number(t.isStarred) - Number(e.isStarred) || t.updatedAt.localeCompare(e.updatedAt)));
		} catch (e) {
			_(e.message);
		} finally {
			h(!1);
		}
	}, [r, v]);
	M(() => {
		e && S();
	}, [
		e,
		S,
		s
	]);
	let w = async (e) => {
		p((t) => t.map((t) => t.id === e.id ? {
			...t,
			isStarred: !t.isStarred
		} : t));
		try {
			let t = await r.conversations.star(e.id);
			p((n) => n.map((n) => n.id === e.id ? {
				...n,
				isStarred: t.isStarred
			} : n));
		} catch {
			p((t) => t.map((t) => t.id === e.id ? {
				...t,
				isStarred: e.isStarred
			} : t));
		}
	}, T = async (e) => {
		if (typeof window > "u" || typeof window.confirm != "function" || window.confirm(u("history.deleteConfirm"))) {
			p((t) => t.filter((t) => t.id !== e.id));
			try {
				await r.conversations.remove(e.id);
			} catch (e) {
				_(e.message), S();
			}
		}
	}, E = async () => {
		if (!b) return;
		let e = b.title.trim(), t = b.id;
		if (x(null), e) {
			p((n) => n.map((n) => n.id === t ? {
				...n,
				title: e
			} : n));
			try {
				await r.conversations.rename(t, e);
			} catch (e) {
				_(e.message), S();
			}
		}
	};
	return /* @__PURE__ */ V(c, {
		open: e,
		onClose: t,
		title: u("chat.conversationHistory"),
		closeLabel: u("common.close"),
		actions: /* @__PURE__ */ B(f, {
			size: "sm",
			icon: /* @__PURE__ */ B(ke, { size: 14 }),
			onClick: o,
			children: u("history.new")
		}),
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-list-controls",
				children: [/* @__PURE__ */ V("label", {
					className: "nb-switch-label",
					children: [/* @__PURE__ */ B("input", {
						type: "checkbox",
						checked: v,
						onChange: (e) => y(e.target.checked)
					}), u("history.starredOnly")]
				}), m && /* @__PURE__ */ B(l, { size: 16 })]
			}),
			g && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: g
			}),
			!m && !d.length && /* @__PURE__ */ V("div", {
				className: "nb-empty-state",
				children: [/* @__PURE__ */ B("p", { children: u("history.empty") }), /* @__PURE__ */ B("p", {
					className: "nb-hint",
					children: u("history.emptyHint")
				})]
			}),
			/* @__PURE__ */ B("ul", {
				className: "nb-list",
				children: d.map((e) => {
					let t = e.sessionId === i;
					return /* @__PURE__ */ V("li", {
						className: `nb-list-item${t ? " nb-current" : ""}`,
						"data-conversation-id": e.id,
						children: [
							/* @__PURE__ */ V("div", {
								className: "nb-list-head",
								children: [(b == null ? void 0 : b.id) === e.id ? /* @__PURE__ */ V("span", {
									className: "nb-list-title nb-editing",
									children: [
										/* @__PURE__ */ B("input", {
											className: "nb-input",
											value: b.title,
											autoFocus: !0,
											"aria-label": u("history.rename"),
											onChange: (t) => x({
												id: e.id,
												title: t.target.value
											}),
											onKeyDown: (e) => {
												e.key === "Enter" && E(), e.key === "Escape" && x(null);
											}
										}),
										/* @__PURE__ */ B(n, {
											label: u("common.save"),
											onClick: () => void E(),
											children: /* @__PURE__ */ B(le, { size: 16 })
										}),
										/* @__PURE__ */ B(n, {
											label: u("common.cancel"),
											onClick: () => x(null),
											children: /* @__PURE__ */ B(Ve, { size: 16 })
										})
									]
								}) : /* @__PURE__ */ V("h4", {
									className: "nb-list-title",
									children: [e.title || u("history.untitled"), t && /* @__PURE__ */ B("span", {
										className: "nb-badge-current",
										children: u("history.current")
									})]
								}), /* @__PURE__ */ B("span", {
									className: "nb-list-date",
									children: At(e.updatedAt)
								})]
							}),
							e.preview && /* @__PURE__ */ B("p", {
								className: "nb-list-preview",
								children: e.preview
							}),
							/* @__PURE__ */ B("div", {
								className: "nb-list-meta",
								children: u("history.messages", { n: e.messageCount })
							}),
							/* @__PURE__ */ V("div", {
								className: "nb-list-actions",
								children: [
									/* @__PURE__ */ B(f, {
										size: "sm",
										variant: "secondary",
										onClick: () => a(e),
										disabled: t,
										children: u(t ? "history.current" : "history.continue")
									}),
									/* @__PURE__ */ B(n, {
										label: e.isStarred ? u("history.unstar") : u("history.star"),
										active: e.isStarred,
										onClick: () => void w(e),
										children: /* @__PURE__ */ B(Ie, {
											size: 16,
											fill: e.isStarred ? "currentColor" : "none"
										})
									}),
									/* @__PURE__ */ B(n, {
										label: u("history.rename"),
										onClick: () => x({
											id: e.id,
											title: e.title
										}),
										children: /* @__PURE__ */ B(De, { size: 16 })
									}),
									/* @__PURE__ */ B(n, {
										label: u("common.delete"),
										onClick: () => void T(e),
										children: /* @__PURE__ */ B(ze, { size: 16 })
									})
								]
							})
						]
					}, e.id);
				})
			})
		]
	});
}
// src/report/csv.ts
var Mt = (e) => {
	let t = m(e, !1);
	return /[",\n;\r]/.test(t) ? `"${t.replace(/"/g, "\"\"")}"` : t;
}, Nt = (e) => {
	let t = m(e, !1);
	return /[\t\r\n"]/.test(t) ? `"${t.replace(/"/g, "\"\"")}"` : t;
};
function Pt(e, t) {
	let n = _(e, t);
	return "﻿" + [n.join(","), ...e.map((e) => n.map((t) => Mt(e[t])).join(","))].join("\r\n");
}
function Ft(e, t) {
	let n = _(e, t);
	return [n.map(Nt).join("	"), ...e.map((e) => n.map((t) => Nt(e[t])).join("	"))].join("\r\n");
}
function It(e, t) {
	if (typeof document > "u" || typeof URL.createObjectURL != "function") return;
	let n = document.createElement("a");
	n.href = URL.createObjectURL(e), n.download = t, n.click(), setTimeout(() => URL.revokeObjectURL(n.href), 0);
}
function Lt(e, t, n = "text/csv;charset=utf-8") {
	It(new Blob([e], { type: n }), t);
}
var Rt = (e, t) => `${(e || t).replace(/[^\w-]+/g, "_").slice(0, 80)}`;
function zt(e, t, n) {
	Lt(Pt(e, n), t.endsWith(".csv") ? t : `${t}.csv`);
}
async function Bt(e) {
	try {
		return await navigator.clipboard.writeText(e), !0;
	} catch {
		return !1;
	}
}
// src/drawers/ScheduleDialog.tsx
function Vt(e, t) {
	var n, r;
	let [i, a] = R(""), o = !!t && !((n = (r = e.schedules).canMintChain) != null && n.call(r));
	return {
		asks: o,
		password: i,
		setPassword: a,
		chain: A(async () => o && i ? await t(i) : void 0, [
			o,
			i,
			t
		])
	};
}
function Ht({ state: e }) {
	let { t } = C();
	return e.asks ? /* @__PURE__ */ V("label", {
		className: "nb-field nb-schedule-runas",
		children: [
			/* @__PURE__ */ B("span", {
				className: "nb-field-label",
				children: t("schedule.runAsPassword")
			}),
			/* @__PURE__ */ B("input", {
				className: "nb-input",
				type: "password",
				autoComplete: "current-password",
				value: e.password,
				"aria-label": t("schedule.runAsPassword"),
				onChange: (t) => e.setPassword(t.target.value)
			}),
			/* @__PURE__ */ B("span", {
				className: "nb-hint",
				children: t("schedule.runAsHint")
			})
		]
	}) : null;
}
function Ut(e) {
	let t = e.status;
	return t === 400 || t === 401;
}
var Wt = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function Gt(e) {
	let { open: t, text: n, timezone: r, client: i, kind: a, debounceMs: o, onRecipients: s } = e, { t: c } = C(), [l, u] = R({ status: "idle" }), d = L(0), f = L(s);
	f.current = s;
	let p = A(() => {
		u({ status: "idle" }), d.current++;
	}, []);
	return M(() => {
		if (!t) return;
		let e = n.trim();
		if (!e) {
			u({ status: "idle" });
			return;
		}
		let s = ++d.current, l = typeof AbortController == "function" ? new AbortController() : void 0, p = setTimeout(() => {
			u({ status: "parsing" }), i.schedules.parse(a === "agent" ? {
				text: e,
				timezone: r,
				kind: a
			} : {
				text: e,
				timezone: r
			}, l == null ? void 0 : l.signal).then((e) => {
				if (s === d.current) {
					if (e.ok) {
						var t, n;
						u({
							status: "ok",
							result: e
						}), (t = e.recipients) != null && t.length && ((n = f.current) == null || n.call(f, e.recipients));
					} else u({
						status: "error",
						error: e.error || c("schedule.notUnderstood")
					});
				}
			}).catch((e) => {
				s === d.current && e.name !== "AbortError" && u({
					status: "error",
					error: e.message || c("schedule.notUnderstood")
				});
			});
		}, o);
		return () => {
			clearTimeout(p), l == null || l.abort();
		};
	}, [
		t,
		n,
		r,
		i,
		a,
		o,
		c
	]), [l, p];
}
function Kt({ parse: e, hint: t }) {
	let { t: n } = C();
	return /* @__PURE__ */ V("div", {
		className: "nb-schedule-preview",
		"data-status": e.status,
		"aria-live": "polite",
		children: [
			e.status === "parsing" && /* @__PURE__ */ V(z, { children: [
				/* @__PURE__ */ B(l, { size: 12 }),
				" ",
				/* @__PURE__ */ B("span", {
					className: "nb-schedule-preview-text",
					children: n("schedule.parsing")
				})
			] }),
			e.status === "ok" && /* @__PURE__ */ B("span", {
				className: "nb-schedule-preview-text nb-schedule-preview-ok",
				children: e.result.description
			}),
			e.status === "error" && /* @__PURE__ */ B("span", {
				className: "nb-schedule-preview-text nb-schedule-preview-error",
				role: "alert",
				children: e.error
			}),
			e.status === "idle" && /* @__PURE__ */ B("span", {
				className: "nb-schedule-preview-text nb-schedule-hint",
				children: t
			})
		]
	});
}
function qt(e, t) {
	let { t: n } = C(), [r, i] = R([]), [a, o] = R("");
	return {
		recipients: r,
		setRecipients: i,
		input: a,
		setInput: o,
		reset: A(() => {
			i(e ? [e] : []), o("");
		}, [e]),
		commit: A(() => {
			let e = a.trim().replace(/[,;]+$/, "");
			return e ? Wt.test(e) ? (i((t) => t.includes(e) ? t : [...t, e]), o(""), t(null), !0) : (t(n("schedule.invalidEmail", { email: e })), !1) : !0;
		}, [
			a,
			n,
			t
		]),
		addNamed: A((e) => {
			i((t) => {
				let n = e.filter((e) => Wt.test(e) && !t.includes(e));
				return n.length ? [...t, ...n] : t;
			});
		}, []),
		final: () => a.trim() ? [...r, a.trim()] : r
	};
}
function Jt({ state: e, canSendMail: t }) {
	let { t: n } = C(), { recipients: r, setRecipients: i, input: a, setInput: o, commit: s } = e;
	return /* @__PURE__ */ V("div", {
		className: "nb-field nb-schedule-recipients",
		children: [
			/* @__PURE__ */ B("span", {
				className: "nb-field-label",
				children: n("schedule.recipients")
			}),
			/* @__PURE__ */ V("div", {
				className: "nb-chips nb-schedule-chips",
				"data-testid": "schedule-recipients",
				children: [r.map((e) => /* @__PURE__ */ V("span", {
					className: "nb-chip nb-chip-sm nb-schedule-chip",
					children: [e, t && /* @__PURE__ */ B("button", {
						type: "button",
						className: "nb-chip-remove",
						"aria-label": n("schedule.removeRecipient", { email: e }),
						onClick: () => i((t) => t.filter((t) => t !== e)),
						children: /* @__PURE__ */ B(Ve, { size: 12 })
					})]
				}, e)), t && /* @__PURE__ */ B("input", {
					className: "nb-input nb-schedule-recipient-input",
					type: "email",
					value: a,
					placeholder: n("schedule.addRecipient"),
					"aria-label": n("schedule.addRecipient"),
					onChange: (e) => o(e.target.value),
					onKeyDown: (e) => {
						e.key === "Enter" || e.key === "," || e.key === ";" || e.key === " " ? (e.preventDefault(), s()) : e.key === "Backspace" && !a && r.length && i((e) => e.slice(0, -1));
					},
					onBlur: () => s()
				})]
			}),
			/* @__PURE__ */ B("span", {
				className: "nb-hint",
				children: !r.length && !t ? n("schedule.noEmail") : n(t ? "schedule.recipientsHint" : "schedule.recipientsFixed")
			})
		]
	});
}
function Yt({ open: e, onClose: t, message: n, client: r, timezone: i, defaultEmail: a, canSendMail: s = !1, onCreated: c, debounceMs: l = 400, signIn: u }) {
	var d;
	let { t: p } = C(), m = x(), [g, _] = R(""), [v, y] = R(""), [b, S] = R(!0), [w, T] = R(!1), [E, D] = R(null), O = ((n == null || (d = n.report) == null ? void 0 : d.heading) || "").trim().slice(0, 120), k = qt(a, D), [A, j] = Gt({
		open: e,
		text: g,
		timezone: i,
		client: r,
		debounceMs: l,
		onRecipients: s ? k.addNamed : void 0
	}), N = k.reset, P = Vt(r, u), F = P.setPassword;
	M(() => {
		e && (_(""), y(O), N(), S(!0), j(), F(""), D(null));
	}, [
		e,
		O,
		N,
		j,
		F
	]);
	let I = A.status === "ok" && !!v.trim() && !!n && !w, L = async (e) => {
		if (e == null || e.preventDefault(), A.status !== "ok" || !n || k.input.trim() && !k.commit()) return;
		let a = k.final();
		T(!0), D(null);
		let o;
		try {
			o = await P.chain();
		} catch (e) {
			D(Ut(e) ? p("schedule.runAsBadPassword") : e.message), T(!1);
			return;
		}
		try {
			let e = await r.schedules.create({
				messageId: n.id,
				cron: A.result.cron,
				timezone: A.result.timezone || i,
				name: v.trim() || O || void 0,
				recipients: a.length ? a : void 0,
				attachPdf: b,
				refreshToken: o
			});
			m(p("schedule.created", { description: e.description || A.result.description }), "success"), c == null || c(e, n.id), t();
		} catch (e) {
			D(Xt(e, p) || p("schedule.createFailed"));
		} finally {
			T(!1);
		}
	};
	return /* @__PURE__ */ B(h, {
		open: e,
		onClose: t,
		title: p("schedule.title"),
		closeLabel: p("common.close"),
		maxWidth: 520,
		footer: /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(f, {
			variant: "ghost",
			onClick: t,
			disabled: w,
			children: p("common.cancel")
		}), /* @__PURE__ */ B(f, {
			loading: w,
			disabled: !I,
			onClick: () => void L(),
			children: p("schedule.create")
		})] }),
		children: /* @__PURE__ */ V("form", {
			className: "nb-schedule-form",
			onSubmit: (e) => void L(e),
			children: [
				/* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [/* @__PURE__ */ B("span", {
						className: "nb-field-label",
						children: p("schedule.when")
					}), /* @__PURE__ */ B("input", {
						className: "nb-input nb-schedule-phrase",
						value: g,
						placeholder: p("schedule.placeholder"),
						"aria-label": p("schedule.when"),
						autoFocus: !0,
						onChange: (e) => _(e.target.value)
					})]
				}),
				/* @__PURE__ */ B(Kt, {
					parse: A,
					hint: p("schedule.hint")
				}),
				/* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [/* @__PURE__ */ B("span", {
						className: "nb-field-label",
						children: p("schedule.name")
					}), /* @__PURE__ */ B("input", {
						className: "nb-input",
						value: v,
						maxLength: 120,
						"aria-label": p("schedule.name"),
						onChange: (e) => y(e.target.value)
					})]
				}),
				/* @__PURE__ */ B(Jt, {
					state: k,
					canSendMail: s
				}),
				/* @__PURE__ */ V("div", {
					className: "nb-schedule-row",
					children: [/* @__PURE__ */ B("span", {
						className: "nb-schedule-row-label",
						children: p("schedule.attachPdf")
					}), /* @__PURE__ */ B(o, {
						checked: b,
						onChange: S,
						label: p(b ? "common.on" : "common.off")
					})]
				}),
				/* @__PURE__ */ B(Ht, { state: P }),
				E && /* @__PURE__ */ B("div", {
					className: "nb-login-error",
					role: "alert",
					children: E
				})
			]
		})
	});
}
function Xt(e, t) {
	let n = e.code, r = e.status;
	return n === "email_required" ? t("schedule.emailRequired") : n === "sendmail_group_required" ? t("schedule.sendMailRequired") : r === 409 || n === "schedule_limit" ? t("schedule.tooMany") : e.message || null;
}
// src/drawers/SettingsDialog.tsx
function Zt({ client: e, open: t }) {
	let { t: r } = C(), [i, a] = R(null), [o, s] = R(null), c = A(async () => {
		try {
			a(await e.memory.list()), s(null);
		} catch (e) {
			s(e.message), a([]);
		}
	}, [e]);
	M(() => {
		t && c();
	}, [t, c]);
	let u = async (t) => {
		a((e) => (e == null ? [] : e).filter((e) => e.id !== t));
		try {
			await e.memory.remove(t);
		} catch (e) {
			s(e.message), c();
		}
	}, d = async () => {
		if (typeof window > "u" || typeof window.confirm != "function" || window.confirm(r("memory.clearConfirm"))) {
			a([]);
			try {
				await e.memory.clear();
			} catch (e) {
				s(e.message), c();
			}
		}
	};
	return /* @__PURE__ */ V("section", {
		className: "nb-settings-section",
		"data-section": "memory",
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-settings-head",
				children: [/* @__PURE__ */ B("h3", { children: r("memory.title") }), !!(i != null && i.length) && /* @__PURE__ */ B(f, {
					size: "sm",
					variant: "ghost",
					onClick: () => void d(),
					children: r("memory.clear")
				})]
			}),
			/* @__PURE__ */ B("p", {
				className: "nb-settings-desc",
				children: r("memory.description")
			}),
			o && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: o
			}),
			i === null ? /* @__PURE__ */ B(l, { size: 16 }) : i.length ? /* @__PURE__ */ B("ul", {
				className: "nb-memory-list",
				children: i.map((e) => /* @__PURE__ */ V("li", {
					className: "nb-memory-item",
					children: [
						/* @__PURE__ */ B("span", {
							className: "nb-chip nb-chip-sm nb-memory-kind",
							children: r(`memory.kind.${e.kind}`) || e.kind
						}),
						/* @__PURE__ */ B("span", {
							className: "nb-memory-text",
							children: e.text
						}),
						/* @__PURE__ */ B(n, {
							label: r("common.delete"),
							onClick: () => void u(e.id),
							children: /* @__PURE__ */ B(ze, { size: 14 })
						})
					]
				}, e.id))
			}) : /* @__PURE__ */ B("p", {
				className: "nb-hint",
				children: r("memory.empty")
			})
		]
	});
}
var Qt = [
	"",
	"30",
	"90",
	"365"
];
function $t(e) {
	let t = e.replace(/\/api\/buddy\/?$/, "").replace(/\/+$/, "");
	try {
		let e = typeof location < "u" ? location.origin : "http://localhost";
		return new URL(`${t}/mcp`, e).toString();
	} catch {
		return `${t}/mcp`;
	}
}
function en(e, t, n) {
	let r = { Authorization: `Bearer ${t}` };
	return n && (r["X-Nyce-System"] = n), JSON.stringify({ mcpServers: { nycebuddy: {
		url: e,
		headers: r
	} } }, null, 2);
}
function tn({ value: e, label: t, copyLabel: n, copiedLabel: r }) {
	let [i, a] = R(!1), o = async () => {
		await Bt(e) && (a(!0), setTimeout(() => a(!1), 1500));
	};
	return /* @__PURE__ */ V("div", {
		className: "nb-mcp-copy",
		children: [/* @__PURE__ */ B("input", {
			className: "nb-input",
			readOnly: !0,
			value: e,
			"aria-label": t,
			onFocus: (e) => e.target.select()
		}), /* @__PURE__ */ B(f, {
			size: "sm",
			variant: "secondary",
			onClick: () => void o(),
			children: i ? r : n
		})]
	});
}
var nn = (e) => {
	if (!e) return "";
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : t.toLocaleDateString();
};
function rn({ client: e, open: t, userName: r, userCode: i, loginContext: a }) {
	let { t: o } = C(), [c, u] = R(null), [d, p] = R(null), [m, h] = R(!1), [g, _] = R(""), [v, y] = R(""), [b, x] = R(i || r || ""), [S, w] = R(""), [T, E] = R(!1), [D, O] = R(null);
	M(() => x(i || r || ""), [i, r]);
	let k = A(async () => {
		try {
			u(await e.mcpKeys.list()), p(null);
		} catch (e) {
			p(e.message), u([]);
		}
	}, [e]);
	M(() => {
		t && k();
	}, [t, k]);
	let j = (e) => typeof window > "u" || typeof window.confirm != "function" || window.confirm(e), N = async (t) => {
		if (j(o("mcp.revokeConfirm", { name: t.name }))) {
			try {
				await e.mcpKeys.revoke(t.id);
			} catch (e) {
				p(e.message);
			}
			k();
		}
	}, P = async (t) => {
		if (t.preventDefault(), !g.trim() || T) return;
		p(null);
		let n = v ? new Date(Date.now() + Number(v) * 864e5).toISOString() : void 0;
		E(!0);
		try {
			var r, i;
			let t;
			if (S) try {
				var s;
				t = (await e.login({
					system: (s = e.system) == null ? "" : s,
					username: b.trim(),
					password: S,
					client: (a == null ? void 0 : a.clientId) == null ? void 0 : String(a.clientId),
					warehouse: (a == null ? void 0 : a.warehouseId) == null ? void 0 : String(a.warehouseId)
				})).refresh_token;
			} catch (e) {
				let t = e.status;
				throw Error(t === 401 || t === 400 ? o("mcp.badPassword") : e.message, { cause: e });
			}
			else if (e.mcpKeys.canCreate()) {
				if (!j(o("mcp.handOverConfirm"))) return;
			} else throw Error(o("mcp.noSession"));
			let c = await e.mcpKeys.create({
				name: g.trim(),
				expiresAt: n,
				refreshToken: t
			});
			O({
				secret: c.secret,
				name: (r = (i = c.key) == null ? void 0 : i.name) == null ? g.trim() : r,
				handedOver: !!c.ownChainHandedOver
			}), h(!1), _(""), w(""), y(""), k();
		} catch (e) {
			let t = e.code;
			p(t === "too_many_keys" ? o("mcp.tooManyKeys") : e.message);
		} finally {
			E(!1);
		}
	}, F = $t(e.baseUrl);
	return /* @__PURE__ */ V("section", {
		className: "nb-settings-section",
		"data-section": "mcp",
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-settings-head",
				children: [/* @__PURE__ */ B("h3", { children: o("mcp.title") }), !D && /* @__PURE__ */ B(f, {
					size: "sm",
					variant: m ? "ghost" : "secondary",
					onClick: () => h((e) => !e),
					children: o(m ? "common.cancel" : "mcp.newKey")
				})]
			}),
			/* @__PURE__ */ B("p", {
				className: "nb-settings-desc",
				children: o("mcp.description")
			}),
			d && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				role: "alert",
				children: d
			}),
			D && /* @__PURE__ */ V("div", {
				className: "nb-mcp-secret",
				"data-testid": "mcp-secret",
				children: [
					/* @__PURE__ */ B("div", {
						className: "nb-mcp-warning",
						children: o("mcp.secretOnce")
					}),
					D.handedOver && /* @__PURE__ */ B("div", {
						className: "nb-mcp-warning",
						role: "status",
						"data-testid": "mcp-handed-over",
						children: o("mcp.sessionEnds")
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-settings-label",
						children: [
							o("mcp.secret"),
							" · ",
							D.name
						]
					}),
					/* @__PURE__ */ B(tn, {
						value: D.secret,
						label: o("mcp.secret"),
						copyLabel: o("mcp.copy"),
						copiedLabel: o("mcp.copied")
					}),
					/* @__PURE__ */ B("div", {
						className: "nb-settings-label",
						children: o("mcp.url")
					}),
					/* @__PURE__ */ B(tn, {
						value: F,
						label: o("mcp.url"),
						copyLabel: o("mcp.copy"),
						copiedLabel: o("mcp.copied")
					}),
					e.system && /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", {
						className: "nb-settings-label",
						children: o("mcp.header")
					}), /* @__PURE__ */ B(tn, {
						value: `X-Nyce-System: ${e.system}`,
						label: o("mcp.header"),
						copyLabel: o("mcp.copy"),
						copiedLabel: o("mcp.copied")
					})] }),
					/* @__PURE__ */ B("div", {
						className: "nb-settings-label",
						children: o("mcp.snippet")
					}),
					/* @__PURE__ */ B("pre", {
						className: "nb-mcp-snippet",
						"data-testid": "mcp-snippet",
						children: en(F, D.secret, e.system)
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-mcp-actions",
						children: [/* @__PURE__ */ B(an, {
							text: en(F, D.secret, e.system),
							copyLabel: o("mcp.copy"),
							copiedLabel: o("mcp.copied")
						}), /* @__PURE__ */ B(f, {
							size: "sm",
							onClick: () => O(null),
							children: o("mcp.done")
						})]
					})
				]
			}),
			m && !D && /* @__PURE__ */ V("form", {
				className: "nb-mcp-form",
				onSubmit: (e) => void P(e),
				"data-testid": "mcp-form",
				children: [
					/* @__PURE__ */ V("label", {
						className: "nb-field",
						children: [/* @__PURE__ */ B("span", { children: o("mcp.name") }), /* @__PURE__ */ B("input", {
							className: "nb-input",
							value: g,
							onChange: (e) => _(e.target.value),
							required: !0,
							autoFocus: !0
						})]
					}),
					/* @__PURE__ */ B(s, {
						label: o("mcp.expiry"),
						value: v,
						onChange: y,
						options: Qt.map((e) => ({
							value: e,
							label: e ? o("mcp.expiryDays", { days: e }) : o("mcp.expiryNever")
						}))
					}),
					/* @__PURE__ */ V("label", {
						className: "nb-field",
						children: [/* @__PURE__ */ B("span", { children: o("mcp.username") }), /* @__PURE__ */ B("input", {
							className: "nb-input",
							value: b,
							autoComplete: "username",
							readOnly: !!i,
							onChange: (e) => x(e.target.value)
						})]
					}),
					/* @__PURE__ */ V("label", {
						className: "nb-field",
						children: [/* @__PURE__ */ B("span", { children: o("mcp.password") }), /* @__PURE__ */ B("input", {
							className: "nb-input",
							type: "password",
							value: S,
							autoComplete: "current-password",
							onChange: (e) => w(e.target.value)
						})]
					}),
					/* @__PURE__ */ B("p", {
						className: "nb-settings-desc",
						children: o("mcp.passwordHint")
					}),
					/* @__PURE__ */ B("div", {
						className: "nb-mcp-actions",
						children: /* @__PURE__ */ B(f, {
							size: "sm",
							type: "submit",
							loading: T,
							disabled: !g.trim(),
							children: o("mcp.create")
						})
					})
				]
			}),
			c === null ? /* @__PURE__ */ B(l, { size: 16 }) : c.length ? /* @__PURE__ */ B("ul", {
				className: "nb-mcp-list",
				children: c.map((e) => /* @__PURE__ */ V("li", {
					className: "nb-mcp-key",
					"data-key-status": e.status,
					children: [
						/* @__PURE__ */ B("span", {
							className: "nb-mcp-name",
							children: e.name
						}),
						/* @__PURE__ */ B("span", {
							className: `nb-chip nb-chip-sm nb-mcp-status nb-mcp-status-${e.status}`,
							children: o(`mcp.status.${e.status}`)
						}),
						/* @__PURE__ */ B(n, {
							label: o("mcp.revoke"),
							onClick: () => void N(e),
							disabled: e.status === "revoked",
							children: /* @__PURE__ */ B(ze, { size: 14 })
						}),
						/* @__PURE__ */ V("span", {
							className: "nb-mcp-meta",
							children: [
								/* @__PURE__ */ V("span", {
									className: "nb-mcp-prefix",
									children: [e.keyPrefix, "…"]
								}),
								" · ",
								o("mcp.created"),
								" ",
								nn(e.createdAt),
								" · ",
								o("mcp.lastUsed"),
								" ",
								e.lastUsedAt ? nn(e.lastUsedAt) : o("mcp.neverUsed"),
								e.expiresAt ? ` · ${o("mcp.expiry")} ${nn(e.expiresAt)}` : "",
								e.status === "broken" && e.error ? /* @__PURE__ */ V("span", {
									className: "nb-mcp-error",
									children: [" · ", e.error]
								}) : null
							]
						})
					]
				}, e.id))
			}) : /* @__PURE__ */ B("p", {
				className: "nb-hint",
				children: o("mcp.empty")
			})
		]
	});
}
function an({ text: e, copyLabel: t, copiedLabel: n }) {
	let [r, i] = R(!1);
	return /* @__PURE__ */ B(f, {
		size: "sm",
		variant: "secondary",
		onClick: () => void Bt(e).then((e) => {
			e && (i(!0), setTimeout(() => i(!1), 1500));
		}),
		children: r ? n : t
	});
}
var on = (e) => {
	if (!e) return "";
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : t.toLocaleString([], {
		year: "numeric",
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	});
};
function sn({ client: e, open: t, signIn: r }) {
	let { t: i } = C(), a = x(), [s, c] = R(null), [u, d] = R(null), [p, m] = R(null), [h, g] = R(null), _ = Vt(e, r), v = A(async () => {
		try {
			c(await e.schedules.list()), d(null);
		} catch (e) {
			d(e.message), c([]);
		}
	}, [e]);
	M(() => {
		t && v();
	}, [t, v]);
	let y = (e) => typeof window > "u" || typeof window.confirm != "function" || window.confirm(e), b = async (t, n) => {
		c((e) => (e == null ? [] : e).map((e) => e.id === t.id ? {
			...e,
			enabled: n
		} : e));
		try {
			let r = await e.schedules.update(t.id, { enabled: n });
			r && typeof r == "object" && c((e) => (e == null ? [] : e).map((e) => e.id === t.id ? {
				...e,
				...r
			} : e)), d(null);
		} catch (e) {
			d(e.code === "sign_in_required" ? i("schedule.signInRequired") : e.message), v();
		}
	}, S = async (t) => {
		g(t.id);
		try {
			let n = await _.chain(), r = await e.schedules.update(t.id, {
				enabled: !0,
				refreshToken: n
			});
			c((e) => (e == null ? [] : e).map((e) => e.id === t.id ? {
				...e,
				...r
			} : e)), _.setPassword(""), d(null);
		} catch (e) {
			let t = e.code;
			d(t === "sign_in_required" ? i("schedule.signInRequired") : Ut(e) ? i("schedule.runAsBadPassword") : e.message);
		} finally {
			g(null);
		}
	}, w = async (t) => {
		if (y(i("schedule.deleteConfirm", { name: t.name }))) {
			c((e) => (e == null ? [] : e).filter((e) => e.id !== t.id));
			try {
				await e.schedules.remove(t.id), d(null);
			} catch (e) {
				d(e.message), v();
			}
		}
	}, T = async (t) => {
		m(t.id);
		try {
			let n = await e.schedules.runNow(t.id);
			(n == null ? void 0 : n.status) === "error" ? a(i("schedule.runFailed", { error: n.error || "" }).trim(), "error") : a(i(t.kind === "agent" ? "schedule.ran" : "schedule.sent", { name: t.name }), "success"), d(null);
		} catch (e) {
			let t = e.code;
			a(t === "run_in_progress" ? i("schedule.runInProgress") : e.message || i("schedule.runFailed", { error: "" }).trim(), "error");
		} finally {
			m(null), v();
		}
	};
	return /* @__PURE__ */ V("section", {
		className: "nb-settings-section",
		"data-section": "schedules",
		children: [
			/* @__PURE__ */ B("div", {
				className: "nb-settings-head",
				children: /* @__PURE__ */ B("h3", { children: i("schedule.sectionTitle") })
			}),
			/* @__PURE__ */ B("p", {
				className: "nb-settings-desc",
				children: i("schedule.sectionDescription")
			}),
			u && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				role: "alert",
				children: u
			}),
			s === null ? /* @__PURE__ */ B(l, { size: 16 }) : s.length ? /* @__PURE__ */ B("ul", {
				className: "nb-schedule-list",
				children: s.map((t) => {
					var r, a;
					return /* @__PURE__ */ V("li", {
						className: `nb-schedule-item${t.enabled ? "" : " nb-schedule-disabled"}`,
						"data-schedule-id": t.id,
						"data-enabled": t.enabled,
						children: [
							/* @__PURE__ */ V("span", {
								className: "nb-schedule-name",
								children: [
									t.name,
									t.kind === "agent" && /* @__PURE__ */ B("span", {
										className: "nb-schedule-kind",
										children: i("schedule.kindAgent")
									}),
									t.runAs === "owner" && /* @__PURE__ */ B("span", {
										className: "nb-schedule-kind nb-schedule-runas",
										children: i("schedule.runsAsYou")
									})
								]
							}),
							/* @__PURE__ */ V("span", {
								className: "nb-schedule-controls",
								children: [
									/* @__PURE__ */ B(o, {
										checked: t.enabled,
										onChange: (e) => void b(t, e),
										label: t.enabled ? i("common.on") : i("common.off")
									}),
									/* @__PURE__ */ B(n, {
										label: t.kind === "agent" ? i("schedule.runNow") : i("schedule.sendNow"),
										onClick: () => void T(t),
										disabled: p !== null,
										children: p === t.id ? /* @__PURE__ */ B(l, { size: 14 }) : /* @__PURE__ */ B(je, { size: 14 })
									}),
									/* @__PURE__ */ B(n, {
										label: i("common.delete"),
										onClick: () => void w(t),
										children: /* @__PURE__ */ B(ze, { size: 14 })
									})
								]
							}),
							/* @__PURE__ */ V("span", {
								className: "nb-schedule-meta",
								children: [
									/* @__PURE__ */ B("span", {
										className: "nb-schedule-desc",
										children: t.description
									}),
									t.nextRunAt && t.enabled ? /* @__PURE__ */ V("span", {
										className: "nb-schedule-next",
										children: [" · ", i("schedule.nextRun", { when: on(t.nextRunAt) })]
									}) : null,
									t.lastRunAt || t.lastStatus === "running" ? /* @__PURE__ */ V("span", {
										className: `nb-schedule-last nb-schedule-last-${t.lastStatus === "error" ? "error" : "ok"}`,
										children: [
											" · ",
											t.lastStatus === "running" ? i("schedule.running") : t.lastStatus === "error" ? i("schedule.lastRunFailed", { when: on(t.lastRunAt) }) : i("schedule.lastRun", { when: on(t.lastRunAt) }),
											t.lastStatus === "error" && t.lastError ? `: ${t.lastError}` : ""
										]
									}) : null
								]
							}),
							/* @__PURE__ */ V("span", {
								className: "nb-schedule-recipients-line",
								children: [
									i("schedule.to"),
									" ",
									t.recipients.join(", "),
									t.kind === "agent" ? t.sinceLastRun ? ` · ${i("schedule.sinceLastRun")}` : "" : t.attachPdf ? ` · ${i("schedule.pdfAttached")}` : ""
								]
							}),
							t.signInRequired && /* @__PURE__ */ V("span", {
								className: "nb-schedule-signin",
								role: "status",
								children: [
									/* @__PURE__ */ B("span", {
										className: "nb-hint",
										children: i("schedule.signInRequired")
									}),
									_.asks && /* @__PURE__ */ B("input", {
										className: "nb-input",
										type: "password",
										autoComplete: "current-password",
										value: _.password,
										"aria-label": i("schedule.runAsPassword"),
										placeholder: i("mcp.password"),
										onChange: (e) => _.setPassword(e.target.value)
									}),
									(_.asks || ((r = (a = e.schedules).canMintChain) == null ? void 0 : r.call(a))) && /* @__PURE__ */ B(f, {
										size: "sm",
										variant: "secondary",
										loading: h === t.id,
										disabled: h !== null || _.asks && !_.password,
										onClick: () => void S(t),
										children: i("schedule.resume")
									})
								]
							})
						]
					}, t.id);
				})
			}) : /* @__PURE__ */ B("p", {
				className: "nb-hint",
				children: i("schedule.empty")
			})
		]
	});
}
var cn = [
	"dark",
	"light",
	"auto"
], ln = [
	"small",
	"medium",
	"large"
], un = [
	"normal",
	"high",
	"expert"
], dn = [
	"off",
	"dictated",
	"always"
];
function fn({ open: e, onClose: t, settings: n, onChange: r, client: i, showMemory: a = !0, showMcpKeys: c = !1, showSchedules: l = !1, showFormContext: u = !1, showReadAloud: d = !1, userName: f, userCode: p, loginContext: m, scheduleSignIn: g, error: _, theme: v, onThemeChange: y }) {
	var b, x, S, w;
	let { t: T } = C(), [E, D] = R([{
		code: "en",
		name: "English",
		nyceLogicCodes: ["ENG"]
	}]), [O, k] = R((b = n.email) == null ? "" : b);
	M(() => {
		var e;
		return k((e = n.email) == null ? "" : e);
	}, [n.email]), M(() => {
		e && i.languages().then((e) => e.length && D(e)).catch(() => {});
	}, [e, i]);
	let A = E.some((e) => e.code === n.language) ? E : [...E, {
		code: n.language,
		name: n.language,
		nyceLogicCodes: []
	}];
	return /* @__PURE__ */ V(h, {
		open: e,
		onClose: t,
		title: T("settings.title"),
		closeLabel: T("common.close"),
		maxWidth: 560,
		children: [
			_ && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: _
			}),
			/* @__PURE__ */ V("section", {
				className: "nb-settings-section",
				children: [
					/* @__PURE__ */ B("h3", { children: T("settings.display") }),
					/* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.language")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.languageDescription")
						})] }), /* @__PURE__ */ B(s, {
							"aria-label": T("settings.language"),
							value: n.language,
							onChange: (e) => r({ language: e }),
							options: A.map((e) => ({
								value: e.code,
								label: e.name
							}))
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.fontSize")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.fontSizeDescription")
						})] }), /* @__PURE__ */ B("div", {
							className: "nb-segment",
							role: "radiogroup",
							"aria-label": T("settings.fontSize"),
							children: ln.map((e) => /* @__PURE__ */ B("button", {
								type: "button",
								role: "radio",
								"aria-checked": n.fontSize === e,
								className: `nb-segment-btn${n.fontSize === e ? " nb-selected" : ""}`,
								onClick: () => r({ fontSize: e }),
								children: T(`settings.fontSize${e[0].toUpperCase()}${e.slice(1)}`)
							}, e))
						})]
					}),
					y && /* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.theme")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.themeDescription")
						})] }), /* @__PURE__ */ B("div", {
							className: "nb-segment",
							role: "radiogroup",
							"aria-label": T("settings.theme"),
							children: cn.map((e) => /* @__PURE__ */ B("button", {
								type: "button",
								role: "radio",
								"aria-checked": (v == null ? "dark" : v) === e,
								className: `nb-segment-btn${(v == null ? "dark" : v) === e ? " nb-selected" : ""}`,
								onClick: () => y(e),
								children: T(`settings.theme${e[0].toUpperCase()}${e.slice(1)}`)
							}, e))
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.showRawData")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.showRawDataDescription")
						})] }), /* @__PURE__ */ B(o, {
							checked: n.showRawData,
							onChange: (e) => r({ showRawData: e }),
							label: n.showRawData ? T("common.on") : T("common.off")
						})]
					}),
					u && /* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.formContext")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.formContextDescription")
						})] }), /* @__PURE__ */ B(o, {
							checked: n.useFormContext !== !1,
							onChange: (e) => r({ useFormContext: e }),
							label: n.useFormContext === !1 ? T("common.off") : T("common.on")
						})]
					}),
					d && /* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.readAloud")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.readAloudDescription")
						})] }), /* @__PURE__ */ B(s, {
							"aria-label": T("settings.readAloud"),
							value: (x = n.readAloud) == null ? "dictated" : x,
							onChange: (e) => r({ readAloud: e }),
							options: dn.map((e) => ({
								value: e,
								label: T(`settings.readAloud${e[0].toUpperCase()}${e.slice(1)}`)
							}))
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.defaultThinking")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.defaultThinkingDescription")
						})] }), /* @__PURE__ */ B(s, {
							"aria-label": T("settings.defaultThinking"),
							value: (S = n.defaultThinking) == null ? "normal" : S,
							onChange: (e) => r({ defaultThinking: e }),
							options: un.map((e) => ({
								value: e,
								label: T(`chat.thinking${e[0].toUpperCase()}${e.slice(1)}`)
							}))
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-settings-row",
						children: [/* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B("div", {
							className: "nb-settings-label",
							children: T("settings.email")
						}), /* @__PURE__ */ B("div", {
							className: "nb-settings-desc",
							children: T("settings.emailDescription")
						})] }), /* @__PURE__ */ B("input", {
							className: "nb-input",
							type: "email",
							"aria-label": T("settings.email"),
							value: O,
							placeholder: "name@example.com",
							onChange: (e) => k(e.target.value),
							onBlur: () => {
								var e;
								return O !== ((e = n.email) == null ? "" : e) && r({ email: O });
							}
						})]
					})
				]
			}),
			a && /* @__PURE__ */ B(Zt, {
				client: i,
				open: e
			}),
			l && i.schedules && /* @__PURE__ */ B(sn, {
				client: { schedules: i.schedules },
				open: e,
				signIn: g
			}),
			c && i.mcpKeys && i.login && /* @__PURE__ */ B(rn, {
				client: {
					mcpKeys: i.mcpKeys,
					login: i.login,
					baseUrl: (w = i.baseUrl) == null ? "" : w,
					system: i.system
				},
				open: e,
				userName: f,
				userCode: p,
				loginContext: m
			})
		]
	});
}
// src/drawers/AgentDialog.tsx
function pn({ open: e, onClose: t, message: n, client: r, timezone: i, defaultEmail: a, canSendMail: s = !1, onCreated: c, debounceMs: u = 400, signIn: d }) {
	var p;
	let { t: m } = C(), g = x(), [_, v] = R({ status: "loading" }), [y, b] = R(""), [S, w] = R(""), [T, E] = R(null), [D, O] = R(!1), [k, A] = R(!1), [j, N] = R(""), [P, F] = R(!1), [I, L] = R(null), H = ((n == null || (p = n.report) == null ? void 0 : p.heading) || "").trim().slice(0, 120), U = qt(a, L), [W, G] = Gt({
		open: e,
		text: y,
		timezone: i,
		client: r,
		kind: "agent",
		debounceMs: u,
		onRecipients: s ? U.addNamed : void 0
	}), K = U.reset, q = Vt(r, d), J = q.setPassword, ee = n == null ? void 0 : n.id;
	M(() => {
		if (!e || (b(""), w(H), K(), G(), N(""), A(!1), J(""), L(null), !ee)) return;
		v({ status: "loading" });
		let t = typeof AbortController == "function" ? new AbortController() : void 0;
		return r.schedules.agentPreview(ee, t == null ? void 0 : t.signal).then((e) => {
			var t, n, r;
			v({
				status: "ok",
				preview: e
			}), E((t = (n = e.resultFrame) == null ? (r = e.frames[0]) == null ? void 0 : r.frame : n) == null ? null : t), O(e.canSinceLastRun);
		}).catch((e) => {
			if (e.name === "AbortError") return;
			let t = e.code;
			v({
				status: "error",
				error: t === "create_agent_group_required" ? m("agent.groupRequired") : t === "feature_disabled" ? m("agent.disabled") : m("agent.loadFailed", { error: e.message })
			});
		}), () => t == null ? void 0 : t.abort();
	}, [
		e,
		H,
		ee,
		r,
		K,
		G,
		J,
		m
	]);
	let Y = _.status === "ok" ? _.preview : null, te = W.status === "ok" && !!S.trim() && !!Y && T !== null && !P, ne = async (e) => {
		if (e == null || e.preventDefault(), W.status !== "ok" || !n || T === null || U.input.trim() && !U.commit()) return;
		let a = U.final();
		F(!0), L(null);
		let o;
		try {
			o = await q.chain();
		} catch (e) {
			L(Ut(e) ? m("schedule.runAsBadPassword") : e.message), F(!1);
			return;
		}
		try {
			let e = await r.schedules.create({
				kind: "agent",
				messageId: n.id,
				cron: W.result.cron,
				timezone: W.result.timezone || i,
				name: S.trim() || H || void 0,
				recipients: a.length ? a : void 0,
				resultFrame: T,
				sinceLastRun: D,
				focus: j.trim() || void 0,
				refreshToken: o
			});
			g(m("agent.created", { description: e.description || W.result.description }), "success"), c == null || c(e, n.id), t();
		} catch (e) {
			let t = e.code;
			L(t === "create_agent_group_required" ? m("agent.groupRequired") : Xt(e, m) || m("agent.createFailed"));
		} finally {
			F(!1);
		}
	}, re = (e) => m(e === "table" ? "agent.kindTable" : e === "analysis" ? "agent.kindAnalysis" : "agent.kindQuery");
	return /* @__PURE__ */ B(h, {
		open: e,
		onClose: t,
		title: m("agent.title"),
		closeLabel: m("common.close"),
		maxWidth: 560,
		footer: /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(f, {
			variant: "ghost",
			onClick: t,
			disabled: P,
			children: m("common.cancel")
		}), /* @__PURE__ */ B(f, {
			loading: P,
			disabled: !te,
			onClick: () => void ne(),
			children: m("agent.create")
		})] }),
		children: /* @__PURE__ */ V("form", {
			className: "nb-schedule-form nb-agent-form",
			onSubmit: (e) => void ne(e),
			children: [
				/* @__PURE__ */ B("p", {
					className: "nb-hint nb-agent-intro",
					children: m("agent.intro")
				}),
				_.status === "loading" && /* @__PURE__ */ V("div", {
					className: "nb-agent-loading",
					children: [
						/* @__PURE__ */ B(l, { size: 14 }),
						" ",
						/* @__PURE__ */ B("span", {
							className: "nb-hint",
							children: m("agent.loading")
						})
					]
				}),
				_.status === "error" && /* @__PURE__ */ B("div", {
					className: "nb-login-error",
					role: "alert",
					children: _.error
				}),
				Y && !Y.frames.length && /* @__PURE__ */ B("div", {
					className: "nb-login-error",
					role: "alert",
					children: m("agent.nothingToWatch")
				}),
				/* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [/* @__PURE__ */ B("span", {
						className: "nb-field-label",
						children: m("schedule.when")
					}), /* @__PURE__ */ B("input", {
						className: "nb-input nb-schedule-phrase",
						value: y,
						placeholder: m("agent.placeholder"),
						"aria-label": m("schedule.when"),
						autoFocus: !0,
						onChange: (e) => b(e.target.value)
					})]
				}),
				/* @__PURE__ */ B(Kt, {
					parse: W,
					hint: m("agent.hint")
				}),
				Y && Y.frames.length > 0 && /* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [
						/* @__PURE__ */ B("span", {
							className: "nb-field-label",
							children: m("agent.result")
						}),
						/* @__PURE__ */ B("select", {
							className: "nb-input nb-agent-result",
							value: T == null ? "" : T,
							"aria-label": m("agent.result"),
							onChange: (e) => E(Number(e.target.value)),
							children: Y.frames.map((e) => /* @__PURE__ */ V("option", {
								className: "nb-agent-result-option",
								value: e.frame,
								children: [
									e.label,
									" (",
									re(e.kind),
									")"
								]
							}, e.frame))
						}),
						/* @__PURE__ */ B("span", {
							className: "nb-hint",
							children: m("agent.resultHint")
						})
					]
				}),
				Y && /* @__PURE__ */ V("div", {
					className: "nb-field nb-agent-since",
					children: [
						/* @__PURE__ */ V("div", {
							className: "nb-schedule-row",
							children: [/* @__PURE__ */ B("span", {
								className: "nb-schedule-row-label",
								children: m("agent.sinceLastRun")
							}), /* @__PURE__ */ B(o, {
								checked: D,
								onChange: O,
								disabled: !Y.canSinceLastRun,
								label: m(D ? "common.on" : "common.off")
							})]
						}),
						/* @__PURE__ */ V("span", {
							className: "nb-hint",
							children: [
								Y.canSinceLastRun ? m("agent.sinceLastRunHint") : m("agent.noDateFilter"),
								D && Y.queries.some((e) => e.fixedDatesLeft) ? ` ${m("agent.fixedDates")}` : "",
								" ",
								Y.queries.length > 0 && /* @__PURE__ */ B("button", {
									type: "button",
									className: "nb-linkbtn nb-agent-toggle-queries",
									onClick: () => A((e) => !e),
									children: m(k ? "agent.hideQueries" : "agent.showQueries")
								})
							]
						}),
						k && /* @__PURE__ */ B("ul", {
							className: "nb-agent-queries",
							"data-testid": "agent-queries",
							children: Y.queries.map((e, t) => /* @__PURE__ */ V("li", {
								className: "nb-agent-query",
								children: [/* @__PURE__ */ V("span", {
									className: "nb-agent-query-purpose",
									children: [e.purpose, D && e.replaced === 0 ? ` · ${m("agent.unchanged")}` : ""]
								}), /* @__PURE__ */ B("code", {
									className: "nb-agent-query-text",
									children: D ? e.sinceLastRun : e.query
								})]
							}, t))
						})
					]
				}),
				/* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [/* @__PURE__ */ B("span", {
						className: "nb-field-label",
						children: m("agent.focus")
					}), /* @__PURE__ */ B("textarea", {
						className: "nb-input nb-agent-focus",
						value: j,
						rows: 2,
						maxLength: 1e3,
						placeholder: m("agent.focusPlaceholder"),
						"aria-label": m("agent.focus"),
						onChange: (e) => N(e.target.value)
					})]
				}),
				/* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [/* @__PURE__ */ B("span", {
						className: "nb-field-label",
						children: m("schedule.name")
					}), /* @__PURE__ */ B("input", {
						className: "nb-input",
						value: S,
						maxLength: 120,
						"aria-label": m("schedule.name"),
						onChange: (e) => w(e.target.value)
					})]
				}),
				/* @__PURE__ */ B(Jt, {
					state: U,
					canSendMail: s
				}),
				/* @__PURE__ */ B(Ht, { state: q }),
				I && /* @__PURE__ */ B("div", {
					className: "nb-login-error",
					role: "alert",
					children: I
				})
			]
		})
	});
}
// src/drawers/UsageDialog.tsx
function mn(e, t = /* @__PURE__ */ new Date()) {
	if (e === "30d") return { days: 30 };
	if (e === "7d") return { days: 7 };
	let n = e === "prev" ? new Date(t.getFullYear(), t.getMonth() - 1, 1) : t;
	return { month: `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}` };
}
function hn({ title: e, b: t }) {
	var n;
	let { t: r } = C();
	if (!t) return null;
	let i = t.weightedTokens, a = [
		[r("usage.inputTokens"), t.weightedInputTokens],
		[r("usage.cachedTokens"), t.weightedCachedTokens],
		[r("usage.outputTokens"), t.weightedOutputTokens],
		[r("usage.thinkingTokens"), t.weightedThoughtTokens]
	], o = [];
	i != null && o.push({
		k: r("usage.nyceTokens"),
		v: d(i),
		strong: !0
	});
	for (let [e, t] of a) t != null && o.push({
		k: e,
		v: d(t)
	});
	return i == null && o.push({
		k: r("usage.tokens"),
		v: d(t.totalTokens)
	}), o.push({
		k: r("usage.questions"),
		v: d((n = t.questionCount) == null ? t.requestCount : n)
	}), t.questionCount != null && o.push({
		k: r("usage.requests"),
		v: d(t.requestCount)
	}), /* @__PURE__ */ V("div", {
		className: "nb-usage-card",
		"data-bucket": e,
		children: [/* @__PURE__ */ B("div", {
			className: "nb-eyebrow",
			children: e
		}), /* @__PURE__ */ B("dl", {
			className: "nb-usage-list",
			children: o.map((e) => /* @__PURE__ */ V("div", {
				className: e.strong ? "nb-usage-total" : void 0,
				children: [/* @__PURE__ */ B("dt", { children: e.k }), /* @__PURE__ */ B("dd", { children: e.v })]
			}, e.k))
		})]
	});
}
var gn = {
	organization: "usage.scopeOrganization",
	tenant: "usage.scopeTenant",
	system: "usage.scopeSystem"
};
function _n(e) {
	return `nb-fill${e >= 100 ? " nb-fill-critical" : e >= 80 ? " nb-fill-warning" : ""}`;
}
function vn({ s: e }) {
	var t, n;
	let { t: r } = C(), i = e.isUnlimited ? 0 : Math.min(100, Math.max(0, e.usagePercentage)), a = (t = e.isExceeded) == null ? !e.isUnlimited && e.usagePercentage >= 100 : t;
	return /* @__PURE__ */ V("div", {
		className: `nb-usage-scope${a ? " nb-exceeded" : e.warn ? " nb-warn" : ""}`,
		"data-scope": e.scope,
		"data-scope-id": e.scopeId,
		children: [/* @__PURE__ */ V("div", {
			className: "nb-usage-scope-head",
			children: [/* @__PURE__ */ V("span", { children: [/* @__PURE__ */ B("b", { children: r((n = gn[e.scope]) == null ? "usage.tenant" : n) }), e.name && /* @__PURE__ */ V("span", {
				className: "nb-hint",
				children: [" · ", e.name]
			})] }), /* @__PURE__ */ V("span", {
				className: "nb-hint",
				children: [
					e.isUnlimited || e.monthlyLimit == null ? r("usage.unlimited") : r("usage.scopeUsed", {
						used: d(e.used),
						limit: d(e.monthlyLimit),
						pct: Math.round(i)
					}),
					a && /* @__PURE__ */ V("b", {
						className: "nb-usage-scope-flag",
						children: [" · ", r("usage.limitExceeded")]
					}),
					!a && e.warn && /* @__PURE__ */ V("span", {
						className: "nb-usage-scope-flag",
						children: [" · ", r("usage.limitWarn")]
					})
				]
			})]
		}), !e.isUnlimited && e.monthlyLimit != null && /* @__PURE__ */ B("div", {
			className: "nb-track nb-usage-track",
			children: /* @__PURE__ */ B("div", {
				className: _n(i),
				style: { width: `${i}%` }
			})
		})]
	});
}
function yn({ open: e, onClose: t, client: n }) {
	var r, i, a;
	let { t: o } = C(), [c, u] = R("month"), [f, p] = R(null), [m, g] = R(null), [_, v] = R(!1);
	M(() => {
		if (!e) return;
		let t = !0;
		return v(!0), n.usage.stats(mn(c)).then((e) => t && (p(e), g(null))).catch((e) => t && g(e.message)).finally(() => t && v(!1)), () => {
			t = !1;
		};
	}, [
		e,
		c,
		n
	]);
	let y = f == null ? void 0 : f.limits, b = y && !y.isUnlimited ? Math.min(100, Math.max(0, y.usagePercentage)) : 0, x = f == null || (r = f.limitStatus) == null ? void 0 : r.scopes;
	return /* @__PURE__ */ V(h, {
		open: e,
		onClose: t,
		title: o("chat.tokenUsage"),
		closeLabel: o("common.close"),
		maxWidth: 640,
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-usage-head",
				children: [
					/* @__PURE__ */ B(s, {
						"aria-label": o("usage.period"),
						value: c,
						onChange: (e) => u(e),
						options: [
							{
								value: "month",
								label: o("usage.thisMonth")
							},
							{
								value: "prev",
								label: o("usage.lastMonth")
							},
							{
								value: "30d",
								label: o("usage.last30")
							},
							{
								value: "7d",
								label: o("usage.last7")
							}
						]
					}),
					(f == null ? void 0 : f.yearMonth) && /* @__PURE__ */ B("span", {
						className: "nb-hint",
						children: f.period ? `${f.period.from} – ${f.period.to}` : f.yearMonth
					}),
					_ && /* @__PURE__ */ B(l, { size: 16 })
				]
			}),
			m && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: m
			}),
			f && /* @__PURE__ */ V(z, { children: [
				/* @__PURE__ */ V("div", {
					className: "nb-usage-grid",
					children: [/* @__PURE__ */ B(hn, {
						title: o("usage.you"),
						b: f.user
					}), /* @__PURE__ */ B(hn, {
						title: o("usage.tenant"),
						b: (i = f.tenant) == null ? f.system : i
					})]
				}),
				x && x.length > 0 && /* @__PURE__ */ V("div", {
					className: "nb-usage-limit nb-usage-scopes",
					"data-testid": "limit-scopes",
					children: [/* @__PURE__ */ B("div", {
						className: "nb-eyebrow",
						children: o("usage.scopes")
					}), x.map((e) => /* @__PURE__ */ B(vn, { s: e }, `${e.scope}:${e.scopeId}`))]
				}),
				y && !(x && x.length > 0) && /* @__PURE__ */ V("div", {
					className: "nb-usage-limit",
					"data-testid": "limit-bar",
					children: [/* @__PURE__ */ V("div", {
						className: "nb-eyebrow",
						children: [o("usage.monthlyLimit"), /* @__PURE__ */ B("span", { children: y.isUnlimited ? o("usage.unlimited") : o("usage.limitUsed", {
							pct: Math.round(y.usagePercentage),
							remaining: d((a = y.remainingTokens) == null ? 0 : a),
							limit: d(y.monthlyLimit)
						}) })]
					}), !y.isUnlimited && /* @__PURE__ */ B("div", {
						className: "nb-track nb-usage-track",
						children: /* @__PURE__ */ B("div", {
							className: _n(b),
							style: { width: `${b}%` }
						})
					})]
				})
			] })
		]
	});
}
// src/report/MathContext.tsx
var bn = O({});
function xn(e) {
	let t = j(bn), [n, r] = R(0), i = !t.renderMath && t.loadKatex !== !1 && dt(e);
	return M(() => {
		if (!i || globalThis.katex) return;
		let e = !0;
		return Je().then((t) => e && t && r((e) => e + 1)), () => {
			e = !1;
		};
	}, [i]), {
		renderMath: t.renderMath,
		ready: n
	};
}
// src/report/artifacts.ts
var Sn = (e) => typeof TextEncoder == "function" ? new TextEncoder().encode(e).length : e.length, Cn = (e) => e < 1024 ? `${e} B` : e < 1048576 ? `${(e / 1024).toFixed(1)} KB` : `${(e / 1048576).toFixed(1)} MB`, wn = (e, t) => (e || t).replace(/[^\w-]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 80) || t;
function Tn(e) {
	var t, n;
	if (!e.includes("<FastReportContainer")) return null;
	let r = (t = /ReportInfo\.Name=(?:"|&quot;)([^"&]+)/.exec(e)) == null ? void 0 : t[1], i = ((n = e.match(/<QueryDefinitionLine>/g)) == null ? [] : n).length, a = Sn(e);
	return {
		type: "fastreport",
		kind: "NYCE.LOGIC report",
		fileName: `${wn(r, "report")}.frx`,
		mime: "application/xml",
		detail: `${Cn(a)} · ${i} data source${i === 1 ? "" : "s"}`
	};
}
var En = [Tn];
function Dn(e) {
	let t = String(e == null ? "" : e);
	if (t.length < 200) return null;
	for (let e of En) {
		let n = e(t);
		if (n) return n;
	}
	return null;
}
// src/report/ArtifactActions.tsx
var On = O([]);
function kn(e) {
	var t;
	return /* @__PURE__ */ B(On.Provider, {
		value: (t = e.actions) == null ? An : t,
		children: e.children
	});
}
var An = [], jn = () => j(On), Mn = (e, t) => e.filter((e) => !e.types || e.types.includes(t)), Nn = O(null), Pn = O(0);
function Fn() {
	return j(Nn);
}
function In() {
	return j(Pn);
}
function Ln({ fetch: e, children: t }) {
	let n = L(/* @__PURE__ */ new Map()), r = L([]), [i, a] = R(0), o = L(e);
	o.current = e, M(() => () => {
		for (let e of r.current) try {
			URL.revokeObjectURL(e);
		} catch {}
	}, []);
	let s = A((e) => {
		let t = e.trim(), i = n.current.get(t);
		if (i) return i;
		if (!ee(t)) return Promise.reject(/* @__PURE__ */ Error(`not an image handle: ${e}`));
		a((e) => e + 1);
		let s = o.current(t).then((e) => {
			let t = URL.createObjectURL(e);
			return r.current.push(t), t;
		}).finally(() => a((e) => e - 1));
		return s.catch(() => n.current.delete(t)), n.current.set(t, s), s;
	}, []), c = F(() => ({ resolve: s }), [s]);
	return /* @__PURE__ */ B(Nn.Provider, {
		value: c,
		children: /* @__PURE__ */ B(Pn.Provider, {
			value: i,
			children: t
		})
	});
}
function Rn(e, t) {
	let n = !0, r = Array.from(e.querySelectorAll("img[data-nb-image]"));
	for (let e of r) {
		var i;
		let r = (i = e.getAttribute("data-nb-image")) == null ? "" : i;
		e.removeAttribute("data-nb-image"), e.classList.add("nb-img"), e.setAttribute("data-nb-ref", r), t ? t.resolve(r).then((t) => {
			n && (e.src = t);
		}).catch(() => {
			n && zn(e);
		}) : zn(e);
	}
	return () => {
		n = !1;
	};
}
function zn(e) {
	var t;
	let n = e.ownerDocument.createElement("span");
	n.className = "nb-img-missing", n.textContent = e.getAttribute("alt") || "image", n.title = (t = e.getAttribute("data-nb-ref")) == null ? "" : t, e.replaceWith(n);
}
function Bn({ href: e, alt: t, className: n, thumbnail: r }) {
	var i;
	let a = Fn(), [o, s] = R(null), [c, l] = R(!1);
	M(() => {
		let t = !0;
		if (s(null), l(!1), !a || !K(e)) l(!0);
		else return a.resolve(e).then((e) => t && s(e)).catch(() => t && l(!0)), () => {
			t = !1;
		};
	}, [e, a]);
	let u = t || ((i = ee(e)) == null ? void 0 : i.entity) || "image";
	if (c) return /* @__PURE__ */ B("span", {
		className: ["nb-img-missing", n].filter(Boolean).join(" "),
		title: e,
		children: u
	});
	let d = [
		"nb-img",
		r ? "nb-img-thumb" : "",
		o ? "" : "nb-img-loading",
		n
	].filter(Boolean).join(" ");
	return o ? /* @__PURE__ */ B("img", {
		className: d,
		src: o,
		alt: u,
		title: u
	}) : /* @__PURE__ */ B("span", {
		className: d,
		"aria-label": u
	});
}
// src/report/Markdown.tsx
var Vn = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect width=\"14\" height=\"14\" x=\"8\" y=\"8\" rx=\"2\" ry=\"2\"/><path d=\"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2\"/></svg>", Hn = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20 6 9 17l-5-5\"/></svg>", Un = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v5h5\"/></svg>";
function Wn(e, t, n) {
	var r, i;
	let a = Dn(t);
	if (!a) return () => {};
	let o = document.createElement("div");
	o.className = "nb-artifact";
	let s = document.createElement("div");
	s.className = "nb-artifact-icon", s.innerHTML = Un;
	let c = document.createElement("div");
	c.className = "nb-artifact-text";
	let l = document.createElement("div");
	l.className = "nb-artifact-title", l.textContent = `${a.kind} · ${a.fileName}`;
	let u = document.createElement("div");
	u.className = "nb-artifact-detail", u.textContent = (r = a.detail) == null ? "" : r, c.append(l, u);
	let d = document.createElement("div");
	d.className = "nb-artifact-actions";
	let f = (e, t, n = "") => {
		let r = document.createElement("button");
		return r.type = "button", r.className = "nb-artifact-btn" + (n ? " " + n : ""), r.textContent = e, r.addEventListener("click", () => t(r)), d.appendChild(r), r;
	}, p = Mn(n.current, a.type);
	return p.forEach((e, r) => f(e.label, () => {
		var r;
		return (r = Mn(n.current, a.type).find((t) => t.label === e.label)) == null ? void 0 : r.onClick({
			...a,
			text: t
		});
	}, r === 0 ? "nb-artifact-primary" : "")), f("Download", () => Lt(t, a.fileName, a.mime), p.length ? "" : "nb-artifact-primary"), f("Copy", async (e) => {
		if (!await Bt(t)) return;
		let n = e.textContent;
		e.textContent = "Copied", setTimeout(() => e.textContent = n, 1500);
	}), f("Show code", (t) => {
		let n = e.hasAttribute("data-nb-shown");
		n ? e.removeAttribute("data-nb-shown") : e.setAttribute("data-nb-shown", ""), t.textContent = n ? "Show code" : "Hide code";
	}).classList.add("nb-artifact-toggle"), o.append(s, c, d), e.setAttribute("data-nb-artifact", ""), (i = e.parentNode) == null || i.insertBefore(o, e), () => {
		o.remove(), e.removeAttribute("data-nb-artifact"), e.removeAttribute("data-nb-shown");
	};
}
function Q({ text: e, className: t, style: n, inline: r }) {
	let { renderMath: i, ready: a } = xn(e), o = F(() => ut(e, i), [
		e,
		i,
		a
	]), s = L(null), c = Fn(), l = jn(), u = L(l);
	u.current = l;
	let d = l.map((e) => {
		var t, n;
		return `${e.label}:${(t = (n = e.types) == null ? void 0 : n.join(",")) == null ? "*" : t}`;
	}).join("|");
	M(() => {
		let e = s.current;
		if (e) return Rn(e, c);
	}, [o, c]), M(() => {
		let e = s.current;
		if (!e) return;
		let t = [];
		return e.querySelectorAll("pre").forEach((e) => {
			var n, r, i;
			let a = (n = (r = (i = e.querySelector("code")) == null ? void 0 : i.textContent) == null ? e.textContent : r) == null ? "" : n;
			t.push(Wn(e, a, u));
			let o = document.createElement("button");
			o.type = "button", o.className = "nb-copy", o.title = "Copy", o.innerHTML = Vn, o.addEventListener("click", async () => {
				await Bt(a) && (o.classList.add("nb-done"), o.innerHTML = Hn, setTimeout(() => {
					o.classList.remove("nb-done"), o.innerHTML = Vn;
				}, 1500));
			}), e.appendChild(o), t.push(() => o.remove());
		}), () => t.forEach((e) => e());
	}, [o, d]);
	let f = ["nb-md", t].filter(Boolean).join(" "), p = F(() => ({ __html: o }), [o]);
	return r ? /* @__PURE__ */ B("span", {
		className: f,
		style: n,
		dangerouslySetInnerHTML: p
	}) : /* @__PURE__ */ B("div", {
		ref: s,
		className: f,
		style: n,
		dangerouslySetInnerHTML: p
	});
}
// src/report/gaugeStrips.ts
function Gn(e) {
	let t = [];
	for (let n of e) {
		let e = n && n.group && String(n.group).trim() || void 0, r = t[t.length - 1];
		r && r.title === e ? r.gauges.push(n) : t.push({
			title: e,
			gauges: [n]
		});
	}
	return t;
}
// src/report/layout.ts
var Kn = /* @__PURE__ */ new Set([
	"chart",
	"heatmap",
	"table",
	"html"
]), qn = /* @__PURE__ */ new Set([
	"options",
	"input",
	"questionnaire"
]);
function Jn(e) {
	let t = [], n = (t) => {
		let n = 0;
		for (; t + n < e.length && e[t + n].type === "gauge";) n++;
		return n;
	}, r = (t) => {
		var r;
		return t >= 0 && t < e.length && e[t].type === "gauge" && n(t) === 1 && !String((r = e[t].content.group) == null ? "" : r).trim();
	}, i = (t) => t < e.length && (Kn.has(e[t].type) || r(t));
	for (let r = 0; r < e.length;) {
		let a = e[r], o = e[r + 1];
		if (qn.has(a.type)) t.push({
			kind: "row",
			row: a,
			index: r
		}), r++;
		else {
			if (o && i(r) && i(r + 1) && !qn.has(o.type) && a.type !== o.type) {
				let e = a.type === "table" || o.type === "table";
				if (a.type !== "gauge" && o.type !== "gauge" || e) {
					t.push({
						kind: "pair",
						first: a,
						second: o,
						index: r
					}), r += 2;
					continue;
				}
			}
			if (a.type === "gauge") {
				let i = n(r);
				t.push({
					kind: "gauges",
					strips: Gn(e.slice(r, r + i).map((e) => e.content)),
					index: r
				}), r += i;
			} else t.push({
				kind: "row",
				row: a,
				index: r
			}), r++;
		}
	}
	return t;
}
// src/report/DataTable.tsx
var Yn = /id$/i, Xn = /<\/?[a-z][\s\S]*>/i;
function Zn(e, t, r) {
	let { t: i } = C(), [a, o] = R(!r.hideIds), [s, c] = R(!1), l = t.some((e) => Yn.test(e)), u = a ? t : t.filter((e) => !Yn.test(e));
	return {
		toolbar: /* @__PURE__ */ V("span", {
			className: "nb-toolbar",
			children: [
				l && /* @__PURE__ */ B(n, {
					label: i(a ? "report.hideIds" : "report.showIds"),
					onClick: () => o((e) => !e),
					children: B(a ? me : he, { size: 16 })
				}),
				/* @__PURE__ */ B(n, {
					label: i(s ? "chat.copied" : "report.copyTable"),
					onClick: async () => {
						await Bt(Ft(e, u)) && (c(!0), setTimeout(() => c(!1), 1500));
					},
					children: B(s ? le : fe, { size: 16 })
				}),
				/* @__PURE__ */ B(n, {
					label: i("report.downloadCsv"),
					onClick: () => zt(e, Rt(r.fileName, "table"), u),
					children: /* @__PURE__ */ B(pe, { size: 16 })
				})
			]
		}),
		visible: u,
		showIds: a
	};
}
function Qn({ rows: e, columns: t, maxRows: n = 500, visibleColumns: r, onOpenEntity: i, maxHeight: o }) {
	let { t: s } = C(), c = r == null ? _(e, t) : r, [l, u] = R(null), d = F(() => new Set(c.filter((t) => e.some((e) => typeof e[t] == "number") && e.every((e) => e[t] == null || typeof e[t] == "number"))), [c, e]), f = F(() => l ? [...e].sort((e, t) => (l.asc ? 1 : -1) * a(e[l.col], t[l.col])) : e, [e, l]), p = c.find((e) => /^entity$/i.test(e)), h = c.find((e) => /^id$/i.test(e)), g = [
		"name",
		"sku",
		"code"
	].map((e) => c.find((t) => t.toLowerCase() === e)).find(Boolean);
	if (!e.length) return /* @__PURE__ */ B("div", {
		className: "nb-empty",
		children: s("report.emptyRows")
	});
	let v = f.slice(0, n);
	return /* @__PURE__ */ V("div", {
		className: "nb-tablewrap",
		style: { maxHeight: o },
		children: [/* @__PURE__ */ V("table", {
			className: "nb-table",
			children: [/* @__PURE__ */ B("thead", { children: /* @__PURE__ */ B("tr", { children: c.map((e) => /* @__PURE__ */ B("th", {
				className: [
					d.has(e) ? "nb-num" : "",
					(l == null ? void 0 : l.col) === e ? "nb-sorted" : "",
					(l == null ? void 0 : l.col) === e && !l.asc ? "nb-desc" : ""
				].filter(Boolean).join(" "),
				onClick: () => u((t) => ({
					col: e,
					asc: (t == null ? void 0 : t.col) !== e || !t.asc
				})),
				title: "sort",
				children: e
			}, e)) }) }), /* @__PURE__ */ B("tbody", { children: v.map((e, t) => {
				let n = p && h && i && typeof e[p] == "string" && typeof e[h] == "number" ? String(e[p]) : null;
				return /* @__PURE__ */ B("tr", { children: c.map((t) => {
					var r;
					let a = e[t];
					if (a == null) return /* @__PURE__ */ B("td", {
						className: d.has(t) ? "nb-null nb-num" : "nb-null",
						children: "null"
					}, t);
					if (K(a)) return /* @__PURE__ */ B("td", {
						className: "nb-img-cell",
						children: /* @__PURE__ */ B(Bn, {
							href: a,
							alt: String((r = e[g == null ? "" : g]) == null ? t : r),
							thumbnail: !0
						})
					}, t);
					if (typeof a == "string" && Xn.test(a)) return /* @__PURE__ */ B("td", { dangerouslySetInnerHTML: { __html: lt(a) } }, t);
					let o = n && t === h;
					return /* @__PURE__ */ B("td", {
						className: [d.has(t) || typeof a == "number" ? "nb-num" : "", o ? "nb-link" : ""].filter(Boolean).join(" "),
						onClick: o ? () => i(n, a) : void 0,
						children: m(a)
					}, t);
				}) }, t);
			}) })]
		}), e.length > n && /* @__PURE__ */ B("div", {
			className: "nb-empty",
			children: s("report.rowsShown", {
				count: e.length.toLocaleString(),
				shown: n.toLocaleString()
			})
		})]
	});
}
// src/report/TableCard.tsx
function $n({ content: e, streaming: t, onOpenEntity: n }) {
	var r;
	let { t: i } = C(), a = e.title || e.name || i("report.table"), o = Array.isArray(e.data) ? e.data : [], { toolbar: s, visible: c } = Zn(o, _(o, e.columns), {
		hideIds: !0,
		fileName: a
	});
	if (t && !Array.isArray(e.data)) return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [/* @__PURE__ */ V("div", {
			className: "nb-eyebrow",
			children: [a, /* @__PURE__ */ B("span", { children: i("report.loadingRows") })]
		}), /* @__PURE__ */ B("div", {
			className: "nb-empty",
			children: i("report.rowsArrive")
		})]
	});
	let l = (r = e.rowCount) == null ? o.length : r, u = e.error ? e.error : [e.truncated || l > o.length ? i("report.rowsShown", {
		count: l.toLocaleString(),
		shown: o.length.toLocaleString()
	}) : i("report.rows", { count: l.toLocaleString() }), e.frame == null ? null : i("report.frame", { n: e.frame })].filter(Boolean).join(" · ");
	return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [/* @__PURE__ */ V("div", {
			className: "nb-eyebrow",
			children: [
				a,
				/* @__PURE__ */ B("span", { children: u }),
				!e.error && o.length > 0 && s
			]
		}), e.error ? /* @__PURE__ */ B("div", {
			className: "nb-error",
			children: e.error
		}) : /* @__PURE__ */ B(Qn, {
			rows: o,
			visibleColumns: c,
			onOpenEntity: n
		})]
	});
}
// src/report/chartMath.ts
function er(e, t, n = 5) {
	if (!Number.isFinite(e) || !Number.isFinite(t)) return [0, 1];
	e === t && (t = e + 1);
	let r = t - e, i = r / n, a = 10 ** Math.floor(Math.log10(i)), o = [
		1,
		2,
		2.5,
		5,
		10
	].map((e) => e * a).find((e) => r / e <= n) || 10 * a, s = Math.floor(e / o) * o, c = Math.ceil(t / o) * o, l = [];
	for (let e = s; e <= c + o / 2; e += o) l.push(Math.round(e / o) * o);
	return l;
}
var $ = [
	"#C2417F",
	"#4C93C4",
	"#B0741F",
	"#2F9E8F",
	"#5857C9",
	"#6B8F2E"
], tr = {
	good: "#238653",
	warning: "#c48a00",
	critical: "#b42318"
}, nr = "#C2417F", rr = (e) => "iIjl.,:;'\"|!`[]()".includes(e) ? .35 : e === " " ? .3 : "ftr".includes(e) ? .46 : "mMWw@%".includes(e) ? 1.02 : e >= "A" && e <= "Z" ? .74 : e >= "0" && e <= "9" ? .64 : .62, ir = (e, t = 12) => {
	let n = 0;
	for (let t of e) n += rr(t);
	return n * t;
};
function ar(e, t, n = 12) {
	if (t <= 0) return "";
	if (ir(e, n) <= t) return e;
	let r = ir("…", n), i = 0, a = "";
	for (let o of e) {
		let e = i + rr(o) * n;
		if (e + r > t) break;
		a += o, i = e;
	}
	return a ? a + "…" : "";
}
// src/report/ChartExtras.tsx
var or = (e) => (Array.isArray(e) ? e : []).filter((e) => {
	var t;
	return e && Array.isArray((t = e.data) == null ? e.values : t);
}).map((e) => {
	var t, n, r, i;
	return {
		name: String((t = (n = e.name) == null ? e.label : n) == null ? "" : t),
		data: ((r = (i = e.data) == null ? e.values : i) == null ? [] : r).map((e) => v(e) ? e : null)
	};
});
function sr({ labels: e, series: t, donut: n, format: r = (e) => d(e, 2) }) {
	let [i, a] = R(null), o = t.data.map((e, t) => ({
		v: v(e) && e > 0 ? e : 0,
		i: t
	})).filter((e) => e.v > 0), s = o.reduce((e, t) => e + t.v, 0), c = n ? 66 : 0, l = -Math.PI / 2, u = o.map((e) => {
		let t = l, r = l + e.v / s * Math.PI * 2;
		l = r;
		let i = +(r - t > Math.PI), a = (e, t) => `${(150 + t * Math.cos(e)).toFixed(2)},${(150 + t * Math.sin(e)).toFixed(2)}`, u = o.length === 1 ? `M${a(t, 120)} A120,120 0 1,1 ${a(t + Math.PI, 120)} A120,120 0 1,1 ${a(t, 120)} ` + (n ? `M${a(t, c)} A${c},${c} 0 1,0 ${a(t + Math.PI, c)} A${c},${c} 0 1,0 ${a(t, c)}` : "") + "Z" : n ? `M${a(t, 120)} A120,120 0 ${i},1 ${a(r, 120)} L${a(r, c)} A${c},${c} 0 ${i},0 ${a(t, c)} Z` : `M150,150 L${a(t, 120)} A120,120 0 ${i},1 ${a(r, 120)} Z`;
		return {
			...e,
			d: u,
			share: e.v / s
		};
	});
	return /* @__PURE__ */ V("div", {
		className: "nb-chart-wrap nb-pie-wrap",
		children: [/* @__PURE__ */ V("svg", {
			viewBox: "0 0 300 300",
			className: "nb-chart nb-pie",
			role: "img",
			"aria-label": t.name || "pie chart",
			children: [u.map((t, n) => {
				var o;
				return /* @__PURE__ */ B("path", {
					d: t.d,
					className: "nb-slice",
					fill: $[n % $.length],
					fillRule: "evenodd",
					opacity: i == null || i === t.i ? 1 : .5,
					onMouseEnter: () => a(t.i),
					onMouseLeave: () => a(null),
					children: /* @__PURE__ */ B("title", { children: `${(o = e[t.i]) == null ? "" : o}: ${r(t.v)} (${(t.share * 100).toFixed(1)} %)` })
				}, t.i);
			}), n && /* @__PURE__ */ B("text", {
				x: 150,
				y: 155,
				textAnchor: "middle",
				className: "nb-pie-total",
				children: r(s)
			})]
		}), /* @__PURE__ */ B("ul", {
			className: "nb-pie-legend",
			children: u.map((t, n) => {
				var o;
				return /* @__PURE__ */ V("li", {
					className: i === t.i ? "nb-active" : "",
					onMouseEnter: () => a(t.i),
					onMouseLeave: () => a(null),
					children: [
						/* @__PURE__ */ B("i", { style: { background: $[n % $.length] } }),
						/* @__PURE__ */ B("span", { children: (o = e[t.i]) == null ? "" : o }),
						/* @__PURE__ */ B("b", { children: r(t.v) }),
						/* @__PURE__ */ V("em", { children: [(t.share * 100).toFixed(1), " %"] })
					]
				}, t.i);
			})
		})]
	});
}
function cr({ labels: e, series: t, format: n = (e) => d(e, 2) }) {
	let r = e.length, i = Math.max(1, ...t.flatMap((e) => e.data.slice(0, r)).filter(v)), a = (e) => -Math.PI / 2 + e / r * Math.PI * 2, o = (e, t) => {
		let n = 100 * Math.max(0, t) / i;
		return `${(160 + n * Math.cos(a(e))).toFixed(2)},${(150 + n * Math.sin(a(e))).toFixed(2)}`;
	};
	return /* @__PURE__ */ B("div", {
		className: "nb-chart-wrap nb-radar-wrap",
		children: /* @__PURE__ */ V("svg", {
			viewBox: "0 0 320 300",
			className: "nb-chart nb-radar",
			role: "img",
			"aria-label": "radar chart",
			children: [
				[
					.25,
					.5,
					.75,
					1
				].map((t) => /* @__PURE__ */ B("polygon", {
					className: "nb-grid",
					fill: "none",
					points: e.map((e, n) => o(n, i * t)).join(" ")
				}, t)),
				e.map((e, t) => {
					let n = 160 + 114 * Math.cos(a(t)), r = Math.cos(a(t)) > .2 ? "start" : Math.cos(a(t)) < -.2 ? "end" : "middle", s = r === "start" ? 320 - n - 4 : r === "end" ? n - 4 : 2 * Math.min(n, 320 - n) - 4;
					return /* @__PURE__ */ V("g", { children: [/* @__PURE__ */ B("line", {
						x1: 160,
						y1: 150,
						x2: o(t, i).split(",")[0],
						y2: o(t, i).split(",")[1],
						className: "nb-grid"
					}), /* @__PURE__ */ B("text", {
						x: n,
						y: 150 + 114 * Math.sin(a(t)) + 4,
						className: "nb-tick",
						textAnchor: r,
						children: ar(e, s, 12)
					})] }, t);
				}),
				t.map((t, r) => {
					let i = $[r % $.length], a = e.map((e, n) => o(n, v(t.data[n]) ? t.data[n] : 0));
					return /* @__PURE__ */ V("g", { children: [
						/* @__PURE__ */ B("polygon", {
							points: a.join(" "),
							fill: i,
							opacity: .18
						}),
						/* @__PURE__ */ B("polygon", {
							points: a.join(" "),
							fill: "none",
							stroke: i,
							strokeWidth: 2,
							strokeLinejoin: "round"
						}),
						a.map((r, a) => /* @__PURE__ */ B("circle", {
							cx: r.split(",")[0],
							cy: r.split(",")[1],
							r: 3,
							fill: i,
							children: /* @__PURE__ */ B("title", { children: `${e[a]}${t.name ? ` · ${t.name}` : ""}: ${v(t.data[a]) ? n(t.data[a]) : "–"}` })
						}, a))
					] }, r);
				}),
				/* @__PURE__ */ B("text", {
					x: 164,
					y: 48,
					className: "nb-tick",
					children: n(i)
				})
			]
		})
	});
}
function lr({ labels: e, series: t, stacked: n, format: r = (e) => d(e, 2) }) {
	let i = e.length * 26 + 24, a = Math.min(240, Math.max(90, ...e.map((e) => ir(e, 12) + 12))), o = e.map((e, r) => n ? t.reduce((e, t) => e + (v(t.data[r]) && t.data[r] > 0 ? t.data[r] : 0), 0) : Math.max(0, ...t.map((e) => v(e.data[r]) ? e.data[r] : 0))), s = Math.max(1, ...o), c = Math.min(160, Math.max(40, ...o.map((e) => ir(r(e), 12) + 12))), l = (e) => a + (720 - a - c) * e / s, u = n ? 18 : Math.max(3, 18 / t.length);
	return /* @__PURE__ */ B("div", {
		className: "nb-chart-wrap",
		children: /* @__PURE__ */ B("svg", {
			viewBox: `0 0 720 ${i}`,
			className: "nb-chart nb-hbars",
			role: "img",
			"aria-label": "bar chart",
			style: { aspectRatio: `720 / ${i}` },
			children: e.map((e, i) => {
				let s = 8 + i * 26, c = 0;
				return /* @__PURE__ */ V("g", { children: [
					/* @__PURE__ */ B("text", {
						x: a - 8,
						y: s + 13,
						className: "nb-tick",
						textAnchor: "end",
						children: ar(e, a - 10, 12)
					}),
					t.map((a, o) => {
						let d = v(a.data[i]) && a.data[i] > 0 ? a.data[i] : 0, f = n ? c : 0;
						n && (c += d);
						let p = n ? s + 4 : s + 4 + o * u;
						return /* @__PURE__ */ B("rect", {
							className: "nb-bar",
							x: l(f),
							y: p,
							width: Math.max(0, l(f + d) - l(f)),
							height: u - +!n,
							rx: 2,
							fill: $[o % $.length],
							children: /* @__PURE__ */ B("title", { children: `${e}${t.length > 1 ? ` · ${a.name}` : ""}: ${r(d)}` })
						}, o);
					}),
					/* @__PURE__ */ B("text", {
						x: l(o[i]) + 6,
						y: s + 13 + 4,
						className: "nb-tick nb-hbar-value",
						children: r(o[i])
					})
				] }, i);
			})
		})
	});
}
// src/report/ChartCard.tsx
var ur = 720, dr = 300, fr = 44, pr = 16, mr = Math.sin(35 * Math.PI / 180), hr = Math.cos(35 * Math.PI / 180);
function gr({ content: e, streaming: t, area: n, secondary: r, rotateLabels: i, labelEvery: a, format: o = (e) => d(e, 2), formatSecondary: s = (e) => d(e, 2), emptyText: c }) {
	var l, u;
	let { t: f } = C(), [p, m] = R(null), h = e, g = F(() => or(e.series), [e.series]), _ = (l = (u = e.xaxis) == null ? h.labels : u) == null ? h.categories : l, y = Array.isArray(_) ? _.map((e) => e == null ? "" : String(e)) : [];
	if (t && e.frame != null && !Array.isArray(e.series)) return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [/* @__PURE__ */ V("div", {
			className: "nb-eyebrow",
			children: [e.title || f("report.chart"), /* @__PURE__ */ B("span", { children: f("report.loadingChart") })]
		}), /* @__PURE__ */ B("div", {
			className: "nb-empty",
			children: f("report.chartArrives")
		})]
	});
	let b = e.error || (!g.length || !g.some((e) => e.data.some(v)) ? c || f("report.noNumericData") : null);
	if (b) return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [/* @__PURE__ */ B("div", {
			className: "nb-eyebrow",
			children: e.title || f("report.chart")
		}), /* @__PURE__ */ B("div", {
			className: c && !e.error ? "nb-empty" : "nb-error",
			children: b
		})]
	});
	let x = Math.min(y.length || Math.max(...g.map((e) => e.data.length)), ...g.map((e) => e.data.length)), S = y.length ? y.slice(0, x) : Array.from({ length: x }, (e, t) => String(t + 1)), w = e.kind === "line" || e.kind === "area" || e.kind === "pie" || e.kind === "donut" || e.kind === "radar" ? e.kind : "bar", T = !!e.stacked && g.length > 1 && (w === "bar" || w === "area"), E = n || w === "area", D = /* @__PURE__ */ V("div", {
		className: "nb-eyebrow",
		children: [e.title || "", /* @__PURE__ */ B("span", { children: e.truncated ? f("report.firstPoints", { count: x }) : "" })]
	});
	if (w === "pie" || w === "donut") return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [D, /* @__PURE__ */ B(sr, {
			labels: S,
			series: g[0],
			donut: w === "donut",
			format: o
		})]
	});
	if (w === "radar" && x >= 3) return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [
			D,
			g.length > 1 && /* @__PURE__ */ B("div", {
				className: "nb-legend",
				children: g.map((e, t) => /* @__PURE__ */ V("span", { children: [/* @__PURE__ */ B("i", { style: { background: $[t % $.length] } }), e.name] }, t))
			}),
			/* @__PURE__ */ B(cr, {
				labels: S,
				series: g,
				format: o
			})
		]
	});
	if (w === "bar" && e.horizontal) return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [
			D,
			(g.length > 1 || !!g[0].name) && /* @__PURE__ */ B("div", {
				className: "nb-legend",
				children: g.map((e, t) => /* @__PURE__ */ V("span", { children: [/* @__PURE__ */ B("i", { style: { background: $[t % $.length] } }), e.name] }, t))
			}),
			/* @__PURE__ */ B(lr, {
				labels: S,
				series: g,
				stacked: T,
				format: o
			})
		]
	});
	let O = w === "line" || w === "area" ? w : "bar", k = i == null ? S.some((e) => e.length > 6) || x > 12 : i, A = k ? 100 : 40, j = (e) => v(e) && e > 0 ? e : 0, M = g.map((e, t) => Array.from({ length: x }, (e, n) => g.slice(0, t).reduce((e, t) => e + j(t.data[n]), 0))), N = g.map((e, t) => e.data.slice(0, x).map((e, n) => M[t][n] + j(e))), P = T ? N.flat() : g.flatMap((e) => e.data.slice(0, x)).filter(v), I = Math.min(0, ...P), L = Math.max(0, ...P);
	I === L && (L = I + 1);
	let z = er(I, L, 5);
	I = z[0], L = z[z.length - 1];
	let H = (e) => pr + (284 - A) * (1 - (e - I) / (L - I)), U = Math.max(1, a == null ? Math.ceil(x / (k ? 30 : 16)) : a), W = Math.min(140, Math.max(fr, ...z.map((e) => ir(o(e), 12) + 12))), G = r ? (() => {
		let e = r.data.slice(0, x).map((e) => v(e) ? e : null), t = e.filter(v), n = er(Math.min(0, ...t), Math.max(1, ...t), z.length - 1), i = n[0], a = n[n.length - 1];
		return {
			name: r.name,
			data: e,
			ticks: n,
			y: (e) => pr + (284 - A) * (1 - (e - i) / (a - i)),
			color: $[g.length % $.length]
		};
	})() : null, K = G ? Math.min(140, Math.max(24, ...G.ticks.map((e) => ir(s(e), 12) + 14))) : 16, q = (ur - W - K) / x, J = g.length > 1 || !!g[0].name || !!G, ee = (e, t, n) => `${S[e]}${g.length > 1 ? ` · ${t.name}` : ""}: ${o(n)}`, Y = (e) => W + q * (e + .5), te = (e, t) => {
		let n = "", r = !1;
		return e.slice(0, x).forEach((e, i) => {
			v(e) ? (n += `${r ? "L" : "M"}${Y(i).toFixed(1)},${t(e).toFixed(1)} `, r = !0) : r = !1;
		}), n;
	}, ne = (e, t, n) => {
		let r = t(Math.max(I, 0)), i = "", a = -1, o = (e) => {
			if (a >= 0) {
				if (n) for (let r = e; r >= a; r--) i += `L${Y(r).toFixed(1)},${t(n[r]).toFixed(1)} `;
				else i += `L${Y(e).toFixed(1)},${r.toFixed(1)} L${Y(a).toFixed(1)},${r.toFixed(1)} `;
				i += "Z ";
			}
			a = -1;
		};
		return e.slice(0, x).forEach((e, n) => {
			if (!v(e)) return o(n - 1);
			i += `${a < 0 ? "M" : "L"}${Y(n).toFixed(1)},${t(e).toFixed(1)} `, a < 0 && (a = n);
		}), o(x - 1), i;
	}, re = (e) => {
		let t = e.currentTarget.getBoundingClientRect();
		if (!t.width) return;
		let n = (e.clientX - t.left) / t.width * ur, r = Math.floor((n - W) / q);
		m(r >= 0 && r < x ? r : null);
	}, ie = p == null ? [] : [...g.map((e, t) => ({
		name: e.name,
		color: $[t % $.length],
		text: v(e.data[p]) ? o(e.data[p]) : "–"
	})), ...G ? [{
		name: G.name,
		color: G.color,
		text: v(G.data[p]) ? s(G.data[p]) : "–"
	}] : []];
	return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [
			D,
			J && /* @__PURE__ */ V("div", {
				className: "nb-legend",
				children: [g.map((e, t) => /* @__PURE__ */ V("span", { children: [/* @__PURE__ */ B("i", { style: { background: $[t % $.length] } }), e.name] }, t)), G && /* @__PURE__ */ V("span", { children: [/* @__PURE__ */ B("i", {
					className: "nb-legend-line",
					style: { background: G.color }
				}), G.name] })]
			}),
			/* @__PURE__ */ V("div", {
				className: "nb-chart-wrap",
				children: [/* @__PURE__ */ V("svg", {
					viewBox: `0 0 ${ur} ${dr}`,
					className: "nb-chart",
					role: "img",
					"aria-label": e.title || "chart",
					onMouseMove: re,
					onMouseLeave: () => m(null),
					children: [
						e.title && /* @__PURE__ */ B("title", { children: e.title }),
						z.map((e) => /* @__PURE__ */ V("g", { children: [/* @__PURE__ */ B("line", {
							x1: W,
							x2: ur - K,
							y1: H(e),
							y2: H(e),
							className: "nb-grid"
						}), /* @__PURE__ */ B("text", {
							x: W - 8,
							y: H(e) + 4,
							className: "nb-tick",
							textAnchor: "end",
							children: o(e)
						})] }, e)),
						G && G.ticks.map((e) => /* @__PURE__ */ B("text", {
							x: ur - K + 8,
							y: G.y(e) + 4,
							className: "nb-tick",
							textAnchor: "start",
							children: s(e)
						}, `r${e}`)),
						S.map((e, t) => {
							if (t % U) return null;
							let n = Y(t), r = k ? Math.min((A - 18) / mr, (n - 2) / hr) : Math.min(q - 4, 2 * (n - 2), 2 * (ur - n - 2));
							return /* @__PURE__ */ B("text", {
								x: n,
								y: dr - A + 16,
								className: "nb-tick",
								textAnchor: k ? "end" : "middle",
								transform: k ? `rotate(-35 ${n} ${dr - A + 16})` : void 0,
								children: ar(e, r, 12)
							}, t);
						}),
						/* @__PURE__ */ B("line", {
							x1: W,
							x2: ur - K,
							y1: H(0),
							y2: H(0),
							className: "nb-axis"
						}),
						p != null && /* @__PURE__ */ B("line", {
							x1: Y(p),
							x2: Y(p),
							y1: pr,
							y2: dr - A,
							className: "nb-crosshair"
						}),
						O === "bar" ? g.map((e, t) => {
							let n = T ? q * .7 : Math.max(2, q * .7 / g.length);
							return e.data.slice(0, x).map((r, i) => {
								if (!v(r)) return null;
								let a = W + q * i + q * .15 + (T ? 0 : n * t), o = T ? N[t][i] : r, s = T ? M[t][i] : 0;
								return /* @__PURE__ */ B("rect", {
									className: "nb-bar",
									x: a,
									y: Math.min(H(o), H(s)),
									width: n,
									height: Math.abs(H(o) - H(s)),
									rx: T ? 0 : 2,
									fill: $[t % $.length],
									opacity: p == null || p === i ? 1 : .55,
									children: /* @__PURE__ */ B("title", { children: ee(i, e, r) })
								}, `${t}-${i}`);
							});
						}) : g.map((e, t) => {
							let n = $[t % $.length], r = T ? N[t] : e.data;
							return /* @__PURE__ */ V("g", { children: [
								E && /* @__PURE__ */ B("path", {
									d: ne(r, H, T ? M[t] : void 0),
									fill: n,
									opacity: T ? .55 : .14,
									className: "nb-area"
								}),
								/* @__PURE__ */ B("path", {
									d: te(r, H),
									fill: "none",
									stroke: n,
									strokeWidth: 2,
									strokeLinejoin: "round"
								}),
								e.data.slice(0, x).map((r, i) => v(r) ? /* @__PURE__ */ B("circle", {
									cx: Y(i),
									cy: H(T ? N[t][i] : r),
									r: p === i ? 4 : x > 60 ? 1.5 : 3,
									fill: n,
									children: /* @__PURE__ */ B("title", { children: ee(i, e, r) })
								}, i) : null)
							] }, t);
						}),
						G && /* @__PURE__ */ V("g", {
							className: "nb-secondary",
							children: [/* @__PURE__ */ B("path", {
								d: te(G.data, G.y),
								fill: "none",
								stroke: G.color,
								strokeWidth: 2,
								strokeLinejoin: "round"
							}), G.data.map((e, t) => v(e) ? /* @__PURE__ */ B("circle", {
								cx: Y(t),
								cy: G.y(e),
								r: p === t ? 4 : x > 60 ? 1.5 : 2.5,
								fill: G.color,
								stroke: "var(--nb-card, #fff)",
								strokeWidth: 1.5,
								children: /* @__PURE__ */ B("title", { children: `${S[t]} · ${G.name}: ${s(e)}` })
							}, t) : null)]
						})
					]
				}), p != null && /* @__PURE__ */ V("div", {
					className: "nb-chart-tip",
					role: "status",
					style: {
						left: `${(Y(p) / ur * 100).toFixed(2)}%`,
						transform: `translateX(${Y(p) > ur * .6 ? "-100%" : "0"})`
					},
					children: [/* @__PURE__ */ B("div", {
						className: "nb-chart-tip-label",
						children: S[p]
					}), ie.map((t, n) => /* @__PURE__ */ V("div", {
						className: "nb-chart-tip-row",
						children: [
							/* @__PURE__ */ B("i", { style: { background: t.color } }),
							/* @__PURE__ */ B("span", { children: t.name || e.title }),
							/* @__PURE__ */ B("b", { children: t.text })
						]
					}, n))]
				})]
			})
		]
	});
}
// src/report/HeatmapCard.tsx
function _r(e, t, n, r) {
	if (r === "diverging") {
		let r = Math.max(-1, Math.min(1, e / (Math.max(Math.abs(t), Math.abs(n)) || 1)));
		return r < 0 ? `hsl(210 70% ${(92 - 40 * -r).toFixed(0)}%)` : `hsl(0 70% ${(92 - 40 * r).toFixed(0)}%)`;
	}
	return `hsl(${(120 - 120 * (n > t ? Math.max(0, Math.min(1, (e - t) / (n - t))) : 0)).toFixed(0)} 60% 78%)`;
}
var vr = (e, t = 18) => e.length > t ? e.slice(0, t - 1) + "…" : e;
function yr({ content: e }) {
	var t;
	let { t: n } = C(), r = Array.isArray(e.xaxis) ? e.xaxis.map((e) => e == null ? "" : String(e)) : [], i = Array.isArray(e.yaxis) ? e.yaxis.map((e) => e == null ? "" : String(e)) : [], a = F(() => Array.isArray(e.values) ? e.values : [], [e.values]), o = e.scale === "diverging" ? "diverging" : "sequential", { min: s, max: c } = F(() => {
		let t = a.flat().filter(v);
		return {
			min: v(e.min) ? e.min : t.length ? Math.min(...t) : 0,
			max: v(e.max) ? e.max : t.length ? Math.max(...t) : 1
		};
	}, [
		a,
		e.min,
		e.max
	]), l = e.error || (!r.length || !i.length || !a.flat().some(v) ? n("report.noHeatmapData") : null);
	if (l) return /* @__PURE__ */ V("div", {
		className: "nb-viz nb-heatmap",
		children: [/* @__PURE__ */ B("div", {
			className: "nb-eyebrow",
			children: e.title || n("report.heatmap")
		}), /* @__PURE__ */ B("div", {
			className: "nb-error",
			children: l
		})]
	});
	let u = e.unit ? ` ${e.unit}` : "";
	return /* @__PURE__ */ V("div", {
		className: "nb-viz nb-heatmap",
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-eyebrow",
				children: [e.title || "", /* @__PURE__ */ B("span", { children: e.truncated ? n("report.heatmapTruncated") : "" })]
			}),
			/* @__PURE__ */ B("div", {
				className: "nb-heatmap-scroll",
				children: /* @__PURE__ */ V("table", {
					className: "nb-heatmap-grid",
					role: "grid",
					"aria-label": e.title || "heatmap",
					children: [/* @__PURE__ */ B("thead", { children: /* @__PURE__ */ V("tr", { children: [/* @__PURE__ */ B("th", {
						className: "nb-heatmap-corner",
						children: (t = e.y) == null ? "" : t
					}), r.map((e, t) => /* @__PURE__ */ B("th", {
						className: "nb-heatmap-col",
						title: e,
						children: vr(e, 12)
					}, t))] }) }), /* @__PURE__ */ B("tbody", { children: i.map((e, t) => /* @__PURE__ */ V("tr", { children: [/* @__PURE__ */ B("th", {
						className: "nb-heatmap-row",
						title: e,
						children: vr(e)
					}), r.map((n, r) => {
						var i;
						let l = (i = a[t]) == null ? void 0 : i[r];
						return v(l) ? /* @__PURE__ */ B("td", {
							className: "nb-heatmap-cell",
							style: { background: _r(l, s, c, o) },
							title: `${e} × ${n}: ${d(l, 2)}${u}`,
							children: d(l, 1)
						}, r) : /* @__PURE__ */ B("td", {
							className: "nb-heatmap-cell nb-heatmap-empty",
							title: `${e} × ${n}`
						}, r);
					})] }, t)) })]
				})
			}),
			/* @__PURE__ */ V("div", {
				className: "nb-heatmap-scale",
				children: [
					/* @__PURE__ */ V("span", { children: [d(s, 1), u] }),
					/* @__PURE__ */ B("i", { style: { background: o === "diverging" ? "linear-gradient(90deg, hsl(210 70% 52%), hsl(0 0% 92%), hsl(0 70% 52%))" : "linear-gradient(90deg, hsl(120 60% 78%), hsl(60 60% 78%), hsl(0 60% 78%))" } }),
					/* @__PURE__ */ V("span", { children: [d(c, 1), u] })
				]
			})
		]
	});
}
// src/report/GaugeStrip.tsx
var br = 140, xr = 140, Sr = 110, Cr = 16, wr = (e, t = Sr) => ({
	x: br + t * Math.cos(e * Math.PI / 180),
	y: xr - t * Math.sin(e * Math.PI / 180)
});
function Tr(e, t) {
	let n = wr(e), r = wr(t);
	return `M${n.x.toFixed(2)},${n.y.toFixed(2)} A${Sr},${Sr} 0 ${+(e - t > 180)} 1 ${r.x.toFixed(2)},${r.y.toFixed(2)}`;
}
var Er = (e) => 180 - 180 * Math.min(1, Math.max(0, e)), Dr = {
	good: "good",
	ok: "good",
	green: "good",
	healthy: "good",
	warning: "warning",
	warn: "warning",
	nominal: "warning",
	amber: "warning",
	yellow: "warning",
	watch: "warning",
	critical: "critical",
	bad: "critical",
	poor: "critical",
	red: "critical",
	alert: "critical"
}, Or = (e) => {
	var t;
	return (t = Dr[String(e == null ? "" : e).toLowerCase()]) == null ? null : t;
};
function kr(e, t) {
	let n = [...t].filter((e) => e && v(e.upTo)).sort((e, t) => e.upTo - t.upTo);
	for (let t of n) if (e <= t.upTo) return Or(t.state);
	return n.length ? Or(n[n.length - 1].state) : null;
}
function Ar({ content: e }) {
	let { t } = C(), n = Number(e.value), r = Number(e.max), i = v(Number(e.min)) ? Number(e.min) : 0;
	if (!v(n)) return /* @__PURE__ */ V("div", {
		className: "nb-gauge",
		children: [/* @__PURE__ */ B("div", {
			className: "nb-gauge-title",
			children: e.title || ""
		}), /* @__PURE__ */ B("div", {
			className: "nb-error",
			children: t("report.noValue")
		})]
	});
	let a = v(r) && r !== i, o = a ? Math.min(Math.max(n, Math.min(i, r)), Math.max(i, r)) : n, s = a ? (o - i) / (r - i) : 0, c = Array.isArray(e.thresholds) && e.thresholds.length ? kr(o, e.thresholds) : null, l = c ? tr[c] : "var(--nb-accent)", u = e.unit ? String(e.unit) : "", f = Number(e.target), p = {
		good: t("report.onTrack"),
		warning: t("report.watch"),
		critical: t("report.critical")
	}, m = [];
	return c && m.push(/* @__PURE__ */ V("span", { children: [/* @__PURE__ */ B("span", {
		className: "nb-dot",
		style: { background: l }
	}), p[c]] }, "state")), v(f) && m.push(/* @__PURE__ */ B("span", { children: t("report.target", { value: `${d(f, 1)}${u ? " " + u : ""}` }) }, "target")), /* @__PURE__ */ V("div", {
		className: "nb-gauge",
		"data-state": c == null ? void 0 : c,
		children: [
			/* @__PURE__ */ B("div", {
				className: "nb-gauge-title",
				children: e.title || ""
			}),
			a ? /* @__PURE__ */ V("svg", {
				viewBox: "0 0 280 170",
				className: "nb-dial",
				role: "img",
				"aria-label": `${e.title}: ${d(n, 1)}${u}`,
				children: [
					/* @__PURE__ */ B("path", {
						d: Tr(180, 0),
						className: "nb-track",
						strokeWidth: Cr
					}),
					s > 0 && /* @__PURE__ */ B("path", {
						d: Tr(180, Er(s)),
						stroke: l,
						fill: "none",
						strokeWidth: Cr,
						strokeLinecap: "round",
						"data-role": "value"
					}),
					v(f) && (() => {
						let e = Er((f - i) / (r - i)), t = wr(e, Sr - Cr / 2 - 5), n = wr(e, 123);
						return /* @__PURE__ */ B("line", {
							x1: t.x,
							y1: t.y,
							x2: n.x,
							y2: n.y,
							className: "nb-target",
							strokeWidth: 3
						});
					})(),
					/* @__PURE__ */ V("text", {
						x: br,
						y: 126,
						className: "nb-big",
						textAnchor: "middle",
						children: [d(n, 1), u && /* @__PURE__ */ V("tspan", {
							className: "nb-unit",
							children: [" ", u]
						})]
					}),
					/* @__PURE__ */ B("text", {
						x: 30,
						y: 162,
						className: "nb-tick",
						textAnchor: "middle",
						children: d(i, 1)
					}),
					/* @__PURE__ */ B("text", {
						x: 250,
						y: 162,
						className: "nb-tick",
						textAnchor: "middle",
						children: d(r, 1)
					})
				]
			}) : /* @__PURE__ */ V("div", {
				className: "nb-kpi",
				children: [d(n, 1), u && /* @__PURE__ */ V("span", {
					className: "nb-unit",
					children: [" ", u]
				})]
			}),
			m.length > 0 && /* @__PURE__ */ B("div", {
				className: "nb-gauge-foot",
				children: m.map((e, t) => /* @__PURE__ */ V("span", { children: [t > 0 && " · ", e] }, t))
			})
		]
	});
}
function jr({ strip: e }) {
	return /* @__PURE__ */ V("div", {
		className: "nb-viz nb-gauge-strip",
		children: [e.title && /* @__PURE__ */ B("div", {
			className: "nb-eyebrow",
			children: e.title
		}), /* @__PURE__ */ B("div", {
			className: "nb-gauges",
			children: e.gauges.map((e, t) => /* @__PURE__ */ B(Ar, { content: e }, t))
		})]
	});
}
// src/report/ProgressCard.tsx
function Mr({ content: e }) {
	let { t } = C(), n = (Array.isArray(e.items) ? e.items : []).filter((e) => e && v(Number(e.value))).map((e) => ({
		...e,
		value: Number(e.value)
	})), r = e.unit ? String(e.unit) : "";
	if (!n.length) return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [/* @__PURE__ */ B("div", {
			className: "nb-eyebrow",
			children: e.title || ""
		}), /* @__PURE__ */ B("div", {
			className: "nb-error",
			children: t("report.noItems")
		})]
	});
	let i = v(Number(e.max)) && Number(e.max) > 0 ? Number(e.max) : Math.max(...n.map((e) => e.value), ...n.map((e) => Number(e.compare) || 0), 0) || 1, a = !!e.compareLabel || n.some((e) => v(Number(e.compare)));
	return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [/* @__PURE__ */ V("div", {
			className: "nb-eyebrow",
			children: [e.title || "", /* @__PURE__ */ B("span", { children: r })]
		}), /* @__PURE__ */ V("div", {
			className: `nb-progress${a ? " nb-compare" : ""}`,
			children: [a && /* @__PURE__ */ V("div", {
				className: "nb-progress-head",
				children: [
					/* @__PURE__ */ B("span", {}),
					/* @__PURE__ */ B("span", {}),
					/* @__PURE__ */ B("span", {}),
					/* @__PURE__ */ B("span", { children: e.compareLabel || t("report.compare") })
				]
			}), n.map((e, t) => {
				var n;
				let o = Math.min(100, Math.max(0, e.value / i * 100));
				return /* @__PURE__ */ V("div", {
					className: "nb-progress-row",
					children: [
						/* @__PURE__ */ V("div", {
							className: "nb-progress-label",
							children: [(n = e.label) == null ? "" : n, e.sublabel && /* @__PURE__ */ B("small", { children: e.sublabel })]
						}),
						/* @__PURE__ */ B("div", {
							className: "nb-track",
							children: /* @__PURE__ */ B("div", {
								className: "nb-fill",
								style: { width: `${o.toFixed(1)}%` }
							})
						}),
						/* @__PURE__ */ V("div", {
							className: "nb-progress-value",
							children: [
								/* @__PURE__ */ B("b", { children: d(e.value) }),
								r ? ` ${r}` : "",
								e.caption && /* @__PURE__ */ B("small", { children: e.caption })
							]
						}),
						a && /* @__PURE__ */ B("div", {
							className: "nb-progress-compare",
							children: v(Number(e.compare)) ? `${d(Number(e.compare))}${r ? ` ${r}` : ""}` : "–"
						})
					]
				}, t);
			})]
		})]
	});
}
// src/report/HtmlCard.tsx
var Nr = 1e5, Pr = 4e3, Fr = 60, Ir = "<!DOCTYPE html><html><head><meta charset=\"utf-8\"><style>html,body{margin:0;overflow-x:hidden}body{padding:8px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,sans-serif;background:#fff;color:#333;box-sizing:border-box}svg,img,canvas,video{max-width:100%;height:auto}table{max-width:100%}</style></head><body>", Lr = "</body></html>";
function Rr(e) {
	for (let i of Array.from(e.querySelectorAll("svg"))) {
		var t, n, r;
		if ((t = i.parentElement) != null && t.closest("svg")) continue;
		let e = parseFloat((n = i.getAttribute("width")) == null ? "" : n), a = parseFloat((r = i.getAttribute("height")) == null ? "" : r);
		!i.hasAttribute("viewBox") && e > 0 && a > 0 && i.setAttribute("viewBox", `0 0 ${e} ${a}`), i.hasAttribute("viewBox") && (e > 0 && !i.style.maxWidth && (i.style.maxWidth = `${e}px`), i.removeAttribute("height"), i.setAttribute("width", "100%"), i.style.height = "auto");
	}
}
function zr({ content: e }) {
	let { t } = C(), n = L(null), [r, i] = R(300), a = Fn(), o = typeof e.html == "string" ? rt(e.html) : "";
	return M(() => {
		var e;
		let t = n.current;
		if (!t) return;
		let r = null, o = null, s = [], c = () => {
			let e = t.contentDocument, n = e == null ? void 0 : e.body;
			if (!e || !n) return;
			let r = Math.max(n.scrollHeight, e.documentElement.scrollHeight), a = Math.min(Pr, Math.max(Fr, r + 2));
			i((e) => Math.abs(a - e) > 2 ? a : e);
		}, l = () => {
			let e = t.contentDocument, n = e == null ? void 0 : e.body;
			if (!e || !n) return;
			let r = t.clientWidth;
			if (!r) return;
			n.style.zoom = "";
			let i = Math.max(e.documentElement.scrollWidth, n.scrollWidth);
			i > r + 2 && (n.style.zoom = String(Math.max(.3, r / i)));
		}, u = () => {
			let e = t.contentDocument;
			if (e && e.body) {
				Rr(e), o == null || o(), o = Rn(e, a), l(), c(), typeof ResizeObserver < "u" && (r == null || r.disconnect(), r = new ResizeObserver(c), r.observe(e.documentElement), r.observe(e.body));
				for (let e of [
					50,
					250,
					1e3
				]) s.push(setTimeout(() => {
					l(), c();
				}, e));
			}
		};
		return t.addEventListener("load", u), ((e = t.contentDocument) == null ? void 0 : e.readyState) === "complete" && t.contentDocument.body && u(), () => {
			t.removeEventListener("load", u), r == null || r.disconnect(), o == null || o();
			for (let e of s) clearTimeout(e);
		};
	}, [o, a]), e.error || !o.trim() ? /* @__PURE__ */ B("div", {
		className: "nb-viz nb-html",
		children: /* @__PURE__ */ B("div", {
			className: "nb-error",
			style: { padding: 12 },
			children: e.error || t("report.emptyVisualization")
		})
	}) : o.length > 1e5 ? /* @__PURE__ */ B("div", {
		className: "nb-viz nb-html",
		children: /* @__PURE__ */ B("div", {
			className: "nb-error",
			style: { padding: 12 },
			children: t("report.tooLarge", {
				size: o.length.toLocaleString(),
				max: Nr.toLocaleString()
			})
		})
	}) : /* @__PURE__ */ B("div", {
		className: "nb-viz nb-html",
		children: /* @__PURE__ */ B("iframe", {
			ref: n,
			className: "nb-htmlviz",
			title: "Visualization",
			sandbox: "allow-same-origin",
			scrolling: "no",
			srcDoc: Ir + o + Lr,
			style: { height: r }
		})
	});
}
// src/report/LogTable.tsx
function Br(e) {
	switch (e.toUpperCase()) {
		case "EMERGENCY":
		case "ALERT":
		case "CRITICAL":
		case "ERROR": return "nb-sev nb-sev-error";
		case "WARNING": return "nb-sev nb-sev-warning";
		case "NOTICE":
		case "INFO": return "nb-sev nb-sev-info";
		default: return "nb-sev";
	}
}
function Vr(e) {
	let t = new Date(e);
	if (Number.isNaN(t.getTime())) return e;
	let n = (e) => String(e).padStart(2, "0");
	return `${t.getMonth() + 1}/${t.getDate()} ${n(t.getHours())}:${n(t.getMinutes())}:${n(t.getSeconds())}`;
}
var Hr = (e) => e.textPayload || e.jsonPayload && e.jsonPayload.split("\n")[0].trim() || "(structured payload)";
function Ur(e) {
	if (!(e.jsonPayload || e.labels || e.resourceType)) return null;
	let t = {};
	if (e.resourceType && (t.resourceType = e.resourceType), e.labels && (t.labels = e.labels), e.jsonPayload) try {
		t.payload = JSON.parse(e.jsonPayload);
	} catch {
		t.payload = e.jsonPayload;
	}
	return JSON.stringify(t, null, 2);
}
function Wr({ content: e }) {
	var t;
	let { t: n } = C(), i = Array.isArray(e.entries) ? e.entries : [], a = (t = e.count) == null ? i.length : t;
	return /* @__PURE__ */ V("div", {
		className: "nb-viz",
		children: [/* @__PURE__ */ V("div", {
			className: "nb-eyebrow",
			children: [a > 0 ? n("report.logsCount", { count: a }) : n("report.logs"), /* @__PURE__ */ V("span", {
				className: "nb-log-head",
				children: [
					/* @__PURE__ */ B(r, {
						size: "sm",
						children: n("report.namespace", { ns: e.namespace })
					}),
					e.since && /* @__PURE__ */ B(r, {
						size: "sm",
						children: n("report.since", { since: e.since })
					}),
					e.truncated && /* @__PURE__ */ B(r, {
						size: "sm",
						children: n("report.truncated")
					})
				]
			})]
		}), i.length ? i.map((e, t) => {
			let n = Ur(e), r = /* @__PURE__ */ V(z, { children: [
				/* @__PURE__ */ B("span", {
					className: "nb-log-ts",
					children: Vr(e.timestamp)
				}),
				/* @__PURE__ */ B("span", {
					className: Br(e.severity),
					children: e.severity
				}),
				/* @__PURE__ */ B("span", {
					className: "nb-log-msg",
					children: Hr(e)
				})
			] });
			return n ? /* @__PURE__ */ V("details", {
				className: "nb-log-entry",
				children: [/* @__PURE__ */ B("summary", { children: r }), /* @__PURE__ */ B("pre", { children: n })]
			}, t) : /* @__PURE__ */ B("div", {
				className: "nb-log-entry",
				children: r
			}, t);
		}) : /* @__PURE__ */ B("div", {
			className: "nb-empty",
			children: n("report.noLogs")
		})]
	});
}
// src/report/widgets.tsx
var Gr = (e) => {
	var t;
	return (t = e.value) == null ? e.label : t;
};
function Kr({ content: e, onSubmit: t, disabled: n, resolvedAnswer: i, loadOptions: a }) {
	var o, s, c;
	let { t: l } = C(), [u, d] = R(/* @__PURE__ */ new Set()), [p, m] = R(""), [h, g] = R(!1), [_, v] = R(null);
	M(() => {
		if (!e.source || !a) return;
		let t = !0;
		return a(e.source).then((e) => t && v(e)).catch(() => {}), () => {
			t = !1;
		};
	}, [e.source, a]);
	let y = (o = _ == null ? e.options : _) == null ? [] : o, b = e.multiSelect === !0, x = !(e.source && a && _ === null) && y.length === 0 && !e.source, S = e.allowFreeText !== !1 || x, w = e.prompt || (x ? l("options.malformed") : ""), T = e.key || "answer", E = h || !!i && i !== "", D = n || E, O = (e) => {
		g(!0), t == null || t({
			text: e,
			answers: { [T]: e }
		});
	}, k = (e, t) => {
		D || (b ? d((t) => {
			let n = new Set(t);
			return n.has(e) ? n.delete(e) : n.add(e), n;
		}) : (d(/* @__PURE__ */ new Set([e])), O(Gr(t))));
	}, A = (() => {
		if (u.size) return y.filter((e, t) => u.has(t)).map((e) => e.label);
		if (h && p.trim()) return [p.trim()];
		if (i) {
			let e = i.split(", ").map((e) => y.find((t) => Gr(t) === e || t.label === e)).filter((e) => !!e);
			return e.length ? e.map((e) => e.label) : [i];
		}
		return [];
	})();
	return E ? /* @__PURE__ */ V("div", {
		className: "nb-widget nb-resolved",
		children: [w && /* @__PURE__ */ B(Q, {
			className: "nb-widget-prompt",
			text: w
		}), /* @__PURE__ */ B("div", {
			className: "nb-chips",
			children: A.map((e, t) => /* @__PURE__ */ B(r, {
				selected: !0,
				children: e
			}, t))
		})]
	}) : /* @__PURE__ */ V("div", {
		className: "nb-widget",
		"data-widget": "options",
		children: [
			w && /* @__PURE__ */ B(Q, {
				className: "nb-widget-prompt",
				text: w
			}),
			y.length > 0 && /* @__PURE__ */ V("div", {
				className: "nb-chips",
				children: [y.map((e, t) => /* @__PURE__ */ B(r, {
					selected: u.has(t),
					onClick: () => k(t, e),
					disabled: D,
					children: e.label
				}, t)), b && u.size > 0 && !D && /* @__PURE__ */ B(f, {
					size: "sm",
					onClick: () => O(y.filter((e, t) => u.has(t)).map(Gr).join(", ")),
					children: (s = e.submitLabel) == null ? l("options.submit") : s
				})]
			}),
			S && /* @__PURE__ */ V("div", {
				className: "nb-widget-free",
				children: [/* @__PURE__ */ B("input", {
					className: "nb-input",
					placeholder: x ? l("options.rephrasePlaceholder") : (c = e.freeTextPlaceholder) == null ? l("options.freeTextPlaceholder") : c,
					value: p,
					disabled: D,
					onChange: (e) => m(e.target.value),
					onKeyDown: (e) => {
						e.key === "Enter" && !e.shiftKey && p.trim() && (e.preventDefault(), O(p.trim()));
					}
				}), p.trim() && !D && /* @__PURE__ */ B(f, {
					size: "sm",
					onClick: () => O(p.trim()),
					children: l("options.send")
				})]
			})
		]
	});
}
function qr({ content: e, onSubmit: t, disabled: n, resolvedAnswer: i }) {
	var a, o;
	let { t: s } = C(), [c, l] = R(""), [u, d] = R(""), [p, m] = R(""), [h, g] = R(null), _ = e.key || "answer", v = h !== null || !!i && i !== "", y = n || v, b = (a = e.submitLabel) == null ? s("options.submit") : a, x = (e) => {
		!y && e.trim() && (g(e.trim()), t == null || t({
			text: e.trim(),
			answers: { [_]: e.trim() }
		}));
	};
	if (v) return /* @__PURE__ */ V("div", {
		className: "nb-widget nb-resolved",
		children: [e.prompt && /* @__PURE__ */ B(Q, {
			className: "nb-widget-prompt",
			text: e.prompt
		}), /* @__PURE__ */ B(r, {
			selected: !0,
			children: h == null ? i : h
		})]
	});
	let S = `nb-dl-${_}`;
	return /* @__PURE__ */ V("div", {
		className: "nb-widget",
		"data-widget": "input",
		children: [e.prompt && e.inputType !== "autocomplete" && /* @__PURE__ */ B(Q, {
			className: "nb-widget-prompt",
			text: e.prompt
		}), e.inputType === "date_range" ? /* @__PURE__ */ V("div", {
			className: "nb-widget-row",
			children: [
				/* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [/* @__PURE__ */ B("span", { children: s("options.dateFrom") }), /* @__PURE__ */ B("input", {
						className: "nb-input",
						type: "date",
						value: u,
						onChange: (e) => d(e.target.value),
						disabled: y
					})]
				}),
				/* @__PURE__ */ V("label", {
					className: "nb-field",
					children: [/* @__PURE__ */ B("span", { children: s("options.dateTo") }), /* @__PURE__ */ B("input", {
						className: "nb-input",
						type: "date",
						value: p,
						onChange: (e) => m(e.target.value),
						disabled: y
					})]
				}),
				/* @__PURE__ */ B(f, {
					size: "sm",
					disabled: y || !u || !p,
					onClick: () => x(s("options.fromTo", {
						from: u,
						to: p
					})),
					children: b
				})
			]
		}) : /* @__PURE__ */ V("div", {
			className: "nb-widget-row",
			children: [
				/* @__PURE__ */ B("input", {
					className: "nb-input",
					type: e.inputType === "date" ? "date" : e.inputType === "number" ? "number" : "text",
					list: e.inputType === "autocomplete" ? S : void 0,
					placeholder: e.inputType === "date" ? s("options.selectDate") : e.prompt,
					"aria-label": e.prompt,
					value: c,
					disabled: y,
					onChange: (e) => l(e.target.value),
					onKeyDown: (e) => {
						e.key === "Enter" && x(c);
					}
				}),
				e.inputType === "autocomplete" && /* @__PURE__ */ B("datalist", {
					id: S,
					children: ((o = e.options) == null ? [] : o).map((e, t) => /* @__PURE__ */ B("option", {
						value: Gr(e),
						children: e.label
					}, t))
				}),
				/* @__PURE__ */ B(f, {
					size: "sm",
					disabled: y || !c.trim(),
					onClick: () => x(c),
					children: b
				})
			]
		})]
	});
}
var Jr = (e) => e.kind === "chip" || e.kind === "free" && e.text.trim().length > 0, Yr = (e) => {
	var t;
	return e.kind === "chip" ? (t = e.value) == null ? e.label : t : e.kind === "free" ? e.text.trim() : "";
}, Xr = (e, t) => {
	var n, r, i;
	return (n = (r = ((i = e.options) == null ? [] : i).find((e) => Gr(e) === t)) == null ? void 0 : r.label) == null ? t : n;
};
function Zr(e, t) {
	let n = t.map((t) => ({
		key: t.key,
		idx: e.indexOf(`${t.key}:`)
	}));
	if (n.some((e) => e.idx === -1)) return null;
	n.sort((e, t) => e.idx - t.idx);
	let r = {};
	return n.forEach((t, i) => {
		let a = t.idx + t.key.length + 1, o = i + 1 < n.length ? n[i + 1].idx : e.length, s = e.slice(a, o).trim();
		s.endsWith(",") && (s = s.slice(0, -1).trim()), r[t.key] = s;
	}), r;
}
function Qr({ content: e, onSubmit: t, disabled: n, resolvedAnswer: i }) {
	var a, o;
	let { t: s } = C(), c = (a = e.questions) == null ? [] : a, [l, u] = R(() => c.map(() => ({ kind: "none" }))), [d, p] = R(!1), m = d || !!i && i !== "", h = n || m, g = F(() => l.length === c.length && l.every(Jr), [l, c.length]);
	if (!c.length) return null;
	let _ = () => {
		if (h || !g) return;
		p(!0);
		let e = {};
		c.forEach((t, n) => e[t.key] = Yr(l[n])), t == null || t({
			text: c.map((t) => `${t.key}: ${e[t.key]}`).join(", "),
			answers: e
		});
	};
	if (m) {
		let t = d ? null : i ? Zr(i, c) : null, n = !d && !!i && t === null;
		return /* @__PURE__ */ V("div", {
			className: "nb-widget nb-resolved",
			children: [e.prompt && /* @__PURE__ */ B(Q, {
				className: "nb-widget-prompt nb-strong",
				text: e.prompt
			}), n ? /* @__PURE__ */ B(r, {
				selected: !0,
				children: i
			}) : c.map((e, n) => {
				var i, a;
				return /* @__PURE__ */ V("div", { children: [/* @__PURE__ */ B(Q, {
					className: "nb-widget-prompt",
					text: e.prompt
				}), /* @__PURE__ */ B(r, {
					selected: !0,
					children: Xr(e, d ? Yr(l[n]) : (i = t == null ? void 0 : t[e.key]) == null ? "" : i)
				})] }, (a = e.key) == null ? n : a);
			})]
		});
	}
	return /* @__PURE__ */ V("div", {
		className: "nb-widget",
		"data-widget": "questionnaire",
		children: [
			e.prompt && /* @__PURE__ */ B(Q, {
				className: "nb-widget-prompt nb-strong",
				text: e.prompt
			}),
			c.map((e, t) => {
				var n, i, a;
				let o = l[t], c = e.allowFreeText !== !1;
				return /* @__PURE__ */ V("div", {
					className: "nb-questionnaire-q",
					children: [
						/* @__PURE__ */ B(Q, {
							className: "nb-widget-prompt",
							text: e.prompt
						}),
						/* @__PURE__ */ B("div", {
							className: "nb-chips",
							children: ((n = e.options) == null ? [] : n).map((e, n) => /* @__PURE__ */ B(r, {
								selected: o.kind === "chip" && o.index === n,
								disabled: h,
								onClick: () => u((r) => r.map((r, i) => i === t ? {
									kind: "chip",
									index: n,
									label: e.label,
									value: e.value
								} : r)),
								children: e.label
							}, n))
						}),
						c && /* @__PURE__ */ B("div", {
							className: "nb-widget-free",
							children: /* @__PURE__ */ B("input", {
								className: "nb-input",
								placeholder: (i = e.freeTextPlaceholder) == null ? s("options.freeTextPlaceholder") : i,
								value: o.kind === "free" ? o.text : "",
								disabled: h,
								onChange: (e) => u((n) => n.map((n, r) => r === t ? {
									kind: "free",
									text: e.target.value
								} : n))
							})
						})
					]
				}, (a = e.key) == null ? t : a);
			}),
			/* @__PURE__ */ B(f, {
				size: "sm",
				onClick: _,
				disabled: h || !g,
				children: (o = e.submitLabel) == null ? s("options.submit") : o
			})
		]
	});
}
// src/report/ReportRows.tsx
function $r({ row: e, p: t }) {
	switch (e.type) {
		case "insights": return /* @__PURE__ */ B(Q, {
			className: "nb-insights",
			text: e.content.text
		});
		case "table": return /* @__PURE__ */ B($n, {
			content: e.content,
			streaming: t.streaming,
			onOpenEntity: t.onOpenEntity
		});
		case "chart": return /* @__PURE__ */ B(gr, {
			content: e.content,
			streaming: t.streaming
		});
		case "heatmap": return /* @__PURE__ */ B(yr, { content: e.content });
		case "gauge": return /* @__PURE__ */ B(jr, { strip: { gauges: [e.content] } });
		case "progress": return /* @__PURE__ */ B(Mr, { content: e.content });
		case "html": return t.allowHtml === !1 ? null : /* @__PURE__ */ B(zr, { content: e.content });
		case "log": return /* @__PURE__ */ B(Wr, { content: e.content });
		case "options": return /* @__PURE__ */ B(Kr, {
			content: e.content,
			onSubmit: t.onClarificationSubmit,
			disabled: t.clarificationDisabled,
			resolvedAnswer: t.resolvedClarification,
			loadOptions: t.loadOptions
		});
		case "input": return /* @__PURE__ */ B(qr, {
			content: e.content,
			onSubmit: t.onClarificationSubmit,
			disabled: t.clarificationDisabled,
			resolvedAnswer: t.resolvedClarification
		});
		case "questionnaire": return /* @__PURE__ */ B(Qr, {
			content: e.content,
			onSubmit: t.onClarificationSubmit,
			disabled: t.clarificationDisabled,
			resolvedAnswer: t.resolvedClarification
		});
		default: return null;
	}
}
function ei(e) {
	let t = Jn((Array.isArray(e.rows) ? e.rows : []).filter((e) => e && e.type && e.content));
	return /* @__PURE__ */ B(z, { children: t.map((t) => t.kind === "pair" ? /* @__PURE__ */ V("div", {
		className: "nb-pair",
		"data-pair": !0,
		children: [/* @__PURE__ */ B($r, {
			row: t.first,
			p: e
		}), /* @__PURE__ */ B($r, {
			row: t.second,
			p: e
		})]
	}, t.index) : t.kind === "gauges" ? t.strips.map((e, n) => /* @__PURE__ */ B(jr, { strip: e }, `${t.index}-${n}`)) : /* @__PURE__ */ B($r, {
		row: t.row,
		p: e
	}, t.index)) });
}
// src/report/ClarificationContext.tsx
function ti({ entries: e }) {
	return e != null && e.length ? /* @__PURE__ */ B("div", {
		className: "nb-clarification-context",
		children: e.map((e, t) => /* @__PURE__ */ V(r, {
			size: "sm",
			selected: !0,
			children: [e.key ? `${e.key}: ` : "", e.answer]
		}, t))
	}) : null;
}
// src/report/ReportView.tsx
function ni({ report: e, streaming: t, className: n, ...r }) {
	let i = e;
	if (!i.heading && !(Array.isArray(i.rows) && i.rows.length) && typeof i.answer == "string" && /^\s*[`{]/.test(i.answer)) {
		let e = ft(i.answer);
		e && (e.heading || e.answer || e.rows.length) && (i = {
			...i,
			heading: e.heading,
			answer: e.answer,
			rows: e.rows
		});
	}
	let a = Array.isArray(i.rows) ? i.rows : [], o = !!(i.answer && i.answer.trim());
	return !i.heading && !o && !a.length && !i.note ? null : /* @__PURE__ */ V("section", {
		className: [
			"nb-report",
			t ? "nb-streaming" : "",
			n
		].filter(Boolean).join(" "),
		children: [
			i.heading && /* @__PURE__ */ B("h2", {
				className: "nb-report-heading",
				children: i.heading
			}),
			i.clarificationContext && i.clarificationContext.length > 0 && /* @__PURE__ */ B(ti, { entries: i.clarificationContext }),
			o && /* @__PURE__ */ B(Q, {
				className: "nb-summary",
				text: i.answer
			}),
			/* @__PURE__ */ B(ei, {
				rows: a,
				streaming: t,
				...r
			}),
			i.note && /* @__PURE__ */ B("div", {
				className: "nb-note",
				children: i.note
			})
		]
	});
}
// src/drawers/FeedbackDrawers.tsx
var ri = (e) => {
	if (!e) return "";
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : t.toLocaleString(void 0, {
		dateStyle: "medium",
		timeStyle: "short"
	});
}, ii = (e) => e.filter((e) => !e.userSeenAt).length;
function ai({ open: e, onClose: t, client: n, onUnreadChange: i }) {
	var a;
	let { t: o } = C(), [s, u] = R(null), [d, p] = R(null), [m, g] = R(null), _ = A(async () => {
		try {
			let e = await n.feedback.mine();
			u(e), p(null), i == null || i(ii(e));
			let t = e.filter((e) => !e.userSeenAt);
			if (t.length) {
				await Promise.all(t.map((e) => n.feedback.seen(e.id).catch(() => {})));
				let r = (/* @__PURE__ */ new Date()).toISOString();
				u(e.map((e) => e.userSeenAt ? e : {
					...e,
					userSeenAt: r
				})), i == null || i(0);
			}
		} catch (e) {
			p(e.message), u([]);
		}
	}, [n, i]);
	M(() => {
		e && _();
	}, [e, _]);
	let v = async () => {
		if (!m) return;
		let { id: e, comment: t } = m;
		g(null);
		try {
			let r = await n.feedback.customerHandled(e, t.trim() || void 0);
			u((t) => (t == null ? [] : t).map((t) => {
				var n;
				return t.id === e ? {
					...t,
					customerHandledAt: (n = r.customerHandledAt) == null ? (/* @__PURE__ */ new Date()).toISOString() : n
				} : t;
			}));
		} catch (e) {
			p(e.message);
		}
	};
	return /* @__PURE__ */ V(c, {
		open: e,
		onClose: t,
		title: o("chat.feedbackResponses"),
		closeLabel: o("common.close"),
		children: [
			d && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: d
			}),
			s === null ? /* @__PURE__ */ B(l, { size: 16 }) : s.length ? /* @__PURE__ */ B("ul", {
				className: "nb-list",
				children: s.map((e) => /* @__PURE__ */ V("li", {
					className: "nb-list-item",
					"data-reply-id": e.id,
					children: [
						/* @__PURE__ */ V("div", {
							className: "nb-list-head",
							children: [/* @__PURE__ */ B("h4", {
								className: "nb-list-title",
								children: e.userQuestion
							}), /* @__PURE__ */ B("span", {
								className: "nb-list-date",
								children: ri(e.handledAt)
							})]
						}),
						e.userComment && /* @__PURE__ */ V("p", {
							className: "nb-list-preview",
							children: [
								"“",
								e.userComment,
								"”"
							]
						}),
						/* @__PURE__ */ V("p", {
							className: "nb-reply",
							children: [
								/* @__PURE__ */ B("b", { children: o("chat.feedbackAnsweredBy") }),
								" ",
								e.handledBy || "—",
								": ",
								e.handledComment
							]
						}),
						/* @__PURE__ */ B("div", {
							className: "nb-list-actions",
							children: e.customerHandledAt ? /* @__PURE__ */ V(r, {
								size: "sm",
								selected: !0,
								children: [
									o("chat.feedbackResolved"),
									" · ",
									ri(e.customerHandledAt)
								]
							}) : /* @__PURE__ */ B(f, {
								size: "sm",
								variant: "secondary",
								onClick: () => g({
									id: e.id,
									comment: ""
								}),
								children: o("chat.feedbackMarkResolved")
							})
						})
					]
				}, e.id))
			}) : /* @__PURE__ */ B("div", {
				className: "nb-empty-state",
				children: o("chat.noFeedbackResponses")
			}),
			/* @__PURE__ */ B(h, {
				open: m !== null,
				onClose: () => g(null),
				title: o("chat.feedbackMarkResolved"),
				closeLabel: o("common.close"),
				maxWidth: 440,
				footer: /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(f, {
					variant: "ghost",
					onClick: () => g(null),
					children: o("common.cancel")
				}), /* @__PURE__ */ B(f, {
					onClick: () => void v(),
					children: o("chat.feedbackMarkResolved")
				})] }),
				children: /* @__PURE__ */ B("textarea", {
					className: "nb-textarea",
					"aria-label": o("chat.feedbackResolveComment"),
					placeholder: o("chat.feedbackResolveComment"),
					value: (a = m == null ? void 0 : m.comment) == null ? "" : a,
					onChange: (e) => g((t) => t && {
						...t,
						comment: e.target.value
					}),
					rows: 3
				})
			})
		]
	});
}
var oi = 20;
function si({ open: e, onClose: t, client: n, canChooseScope: i, featureFeedbackResponses: a = !0 }) {
	var s, u;
	let { t: d } = C(), [p, m] = R(i ? "tenant" : "system"), [g, _] = R(""), [v, y] = R(""), [b, x] = R([]), [S, w] = R(0), [T, E] = R(1), [D, O] = R(!1), [k, j] = R(null), [N, P] = R(null), [F, I] = R(null), L = A(async (e, t) => {
		O(!0);
		try {
			let r = await n.feedback.list({
				scope: p,
				page: e,
				pageSize: oi,
				feedback: g || void 0,
				handled: v || void 0
			});
			w(r.total), x((e) => t ? [...e, ...r.items] : r.items), j(null);
		} catch (e) {
			j(e.message);
		} finally {
			O(!1);
		}
	}, [
		n,
		p,
		g,
		v
	]);
	M(() => {
		e && (E(1), L(1, !1));
	}, [e, L]);
	let H = async () => {
		if (!F) return;
		let { id: e, comment: t, showToUser: r } = F;
		I(null);
		try {
			await n.feedback.setHandled(e, {
				handled: !0,
				comment: t.trim() || null,
				showToUser: r
			}), x((n) => n.map((n) => n.id === e ? {
				...n,
				handledAt: (/* @__PURE__ */ new Date()).toISOString(),
				handledComment: t,
				showToUser: r
			} : n));
		} catch (e) {
			j(e.message);
		}
	}, U = async (e) => {
		try {
			await n.feedback.setHandled(e, { handled: !1 }), x((t) => t.map((t) => t.id === e ? {
				...t,
				handledAt: null,
				handledComment: null,
				showToUser: !1
			} : t));
		} catch (e) {
			j(e.message);
		}
	}, W = b.find((e) => e.id === N);
	return /* @__PURE__ */ V(c, {
		open: e,
		onClose: t,
		title: d("chat.adminFeedbackTitle"),
		closeLabel: d("common.close"),
		width: 520,
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-filters",
				children: [i && /* @__PURE__ */ B("div", {
					className: "nb-segment",
					role: "radiogroup",
					"aria-label": "scope",
					children: [
						"tenant",
						"system",
						"all"
					].map((e) => /* @__PURE__ */ B("button", {
						type: "button",
						role: "radio",
						"aria-checked": p === e,
						className: `nb-segment-btn${p === e ? " nb-selected" : ""}`,
						onClick: () => m(e),
						children: d(`chat.feedbackScope${e[0].toUpperCase()}${e.slice(1)}`)
					}, e))
				}), /* @__PURE__ */ V("div", {
					className: "nb-chips",
					children: [
						/* @__PURE__ */ B(r, {
							size: "sm",
							selected: g === "",
							onClick: () => _(""),
							children: d("chat.feedbackFilterAll")
						}),
						/* @__PURE__ */ B(r, {
							size: "sm",
							selected: g === "up",
							icon: /* @__PURE__ */ B(Re, { size: 12 }),
							onClick: () => _(g === "up" ? "" : "up"),
							children: d("chat.feedbackFilterUp")
						}),
						/* @__PURE__ */ B(r, {
							size: "sm",
							selected: g === "down",
							icon: /* @__PURE__ */ B(Le, { size: 12 }),
							onClick: () => _(g === "down" ? "" : "down"),
							children: d("chat.feedbackFilterDown")
						}),
						/* @__PURE__ */ B(r, {
							size: "sm",
							selected: v === "unhandled",
							onClick: () => y(v === "unhandled" ? "" : "unhandled"),
							children: d("chat.feedbackFilterUnhandled")
						}),
						/* @__PURE__ */ B(r, {
							size: "sm",
							selected: v === "handled",
							onClick: () => y(v === "handled" ? "" : "handled"),
							children: d("chat.feedbackFilterHandled")
						})
					]
				})]
			}),
			k && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: k
			}),
			D && !b.length && /* @__PURE__ */ B(l, { size: 16 }),
			!D && !b.length && /* @__PURE__ */ B("div", {
				className: "nb-empty-state",
				children: d("chat.noFeedbackResponses")
			}),
			/* @__PURE__ */ B("ul", {
				className: "nb-list",
				children: b.map((e) => /* @__PURE__ */ V("li", {
					className: "nb-list-item",
					"data-feedback-id": e.id,
					children: [
						/* @__PURE__ */ V("div", {
							className: "nb-list-head",
							children: [/* @__PURE__ */ V("h4", {
								className: "nb-list-title",
								children: [e.feedback === "up" ? /* @__PURE__ */ B(Re, { size: 14 }) : /* @__PURE__ */ B(Le, { size: 14 }), e.userQuestion || d("history.untitled")]
							}), /* @__PURE__ */ B("span", {
								className: "nb-list-date",
								children: ri(e.createdAt)
							})]
						}),
						/* @__PURE__ */ V("div", {
							className: "nb-list-meta",
							children: [
								e.userCode,
								e.systemName ? ` · ${e.systemName}` : "",
								e.model ? ` · ${e.model}` : ""
							]
						}),
						e.comment && /* @__PURE__ */ V("p", {
							className: "nb-list-preview",
							children: [
								"“",
								e.comment,
								"”"
							]
						}),
						e.handledAt && /* @__PURE__ */ V("p", {
							className: "nb-reply",
							children: [
								/* @__PURE__ */ B("b", { children: d("chat.feedbackHandledBy") }),
								" ",
								e.handledBy || "—",
								" ",
								d("chat.feedbackHandledAt"),
								" ",
								ri(e.handledAt),
								e.handledComment ? `: ${e.handledComment}` : "",
								e.showToUser ? ` · ${d("chat.feedbackShowToUser")}` : "",
								e.customerHandledAt ? ` · ${d("chat.feedbackResolved")}` : ""
							]
						}),
						/* @__PURE__ */ V("div", {
							className: "nb-list-actions",
							children: [!!(e.report || e.aiResponse) && /* @__PURE__ */ B(f, {
								size: "sm",
								variant: "ghost",
								onClick: () => P(e.id),
								children: d("feedback.preview")
							}), e.handledAt ? /* @__PURE__ */ B(f, {
								size: "sm",
								variant: "ghost",
								onClick: () => void U(e.id),
								children: d("chat.feedbackUnhandle")
							}) : /* @__PURE__ */ B(f, {
								size: "sm",
								variant: "secondary",
								onClick: () => I({
									id: e.id,
									comment: "",
									showToUser: !1
								}),
								children: d("chat.feedbackMarkHandled")
							})]
						})
					]
				}, e.id))
			}),
			b.length < S && /* @__PURE__ */ B("div", {
				style: {
					textAlign: "center",
					marginTop: 12
				},
				children: /* @__PURE__ */ B(f, {
					size: "sm",
					variant: "ghost",
					loading: D,
					onClick: () => (E(T + 1), void L(T + 1, !0)),
					children: d("chat.feedbackLoadMore")
				})
			}),
			/* @__PURE__ */ B(h, {
				open: !!W,
				onClose: () => P(null),
				title: (W == null ? void 0 : W.userQuestion) || d("feedback.preview"),
				closeLabel: d("common.close"),
				maxWidth: 860,
				children: W && /* @__PURE__ */ B("div", {
					className: "nb-preview",
					children: /* @__PURE__ */ B(ni, {
						report: J((s = W.report) == null ? W.aiResponse : s),
						allowHtml: !1
					})
				})
			}),
			/* @__PURE__ */ V(h, {
				open: F !== null,
				onClose: () => I(null),
				title: d("chat.feedbackMarkHandled"),
				closeLabel: d("common.close"),
				maxWidth: 480,
				footer: /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(f, {
					variant: "ghost",
					onClick: () => I(null),
					children: d("common.cancel")
				}), /* @__PURE__ */ B(f, {
					onClick: () => void H(),
					children: d("chat.feedbackMarkHandled")
				})] }),
				children: [/* @__PURE__ */ B("textarea", {
					className: "nb-textarea",
					"aria-label": d("chat.feedbackMarkHandledComment"),
					placeholder: d("chat.feedbackMarkHandledComment"),
					rows: 3,
					value: (u = F == null ? void 0 : F.comment) == null ? "" : u,
					onChange: (e) => I((t) => t && {
						...t,
						comment: e.target.value
					})
				}), a && /* @__PURE__ */ B("div", {
					style: { marginTop: 10 },
					children: /* @__PURE__ */ B(o, {
						checked: !!(F != null && F.showToUser),
						onChange: (e) => I((t) => t && {
							...t,
							showToUser: e
						}),
						label: d("chat.feedbackShowToUser")
					})
				})]
			})
		]
	});
}
// src/drawers/CustomerDocumentsDrawer.tsx
var ci = ".pdf,.docx,.md,.markdown,.txt,.html,.htm", li = 3e3, ui = (e) => e === "pending" || e === "indexing", di = (e) => {
	if (!e) return "";
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : t.toLocaleString(void 0, {
		dateStyle: "medium",
		timeStyle: "short"
	});
}, fi = (e) => e >= 1048576 ? `${(e / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(e / 1024))} KB`, pi = {
	unsupported_file: "chat.customerDocsErrorUnsupported",
	file_too_large: "chat.customerDocsErrorTooLarge",
	too_large: "chat.customerDocsErrorTooLarge",
	too_many_files: "chat.customerDocsErrorTooMany",
	unreadable_file: "chat.customerDocsErrorUnreadable",
	feature_disabled: "chat.customerDocsErrorDisabled"
};
function mi({ open: e, onClose: t, client: r, canChooseScope: i }) {
	let { t: a } = C(), [o, s] = R([]), [u, d] = R(!1), [p, m] = R(null), [h, g] = R([]), [_, v] = R(""), [y, b] = R("system"), [x, S] = R(null), [w, T] = R(!1), [E, D] = R(null), O = L(null), k = A((e) => {
		let t = e instanceof H && e.code ? pi[e.code] : void 0;
		return t ? a(t) : e.message;
	}, [a]), j = A(async (e = !1) => {
		e || d(!0);
		try {
			s(await r.customerDocs.list()), m(null);
		} catch (e) {
			m(k(e));
		} finally {
			e || d(!1);
		}
	}, [r, k]);
	M(() => {
		e && (D(null), j());
	}, [e, j]), M(() => {
		if (!e || !i) return;
		let t = !0;
		return r.me().then((e) => t && S(e.organizationId || null)).catch(() => t && S(null)), () => {
			t = !1;
		};
	}, [
		e,
		i,
		r
	]);
	let N = o.some((e) => ui(e.status));
	M(() => {
		if (!e || !N) return;
		let t = setInterval(() => void j(!0), li);
		return () => clearInterval(t);
	}, [
		e,
		N,
		j
	]);
	let P = async () => {
		if (h.length) {
			T(!0), m(null);
			try {
				let e = y === "organization" && x ? { organizationId: x } : {}, t = await r.customerDocs.upload(h, {
					...e,
					title: h.length === 1 ? _ : void 0
				});
				s((e) => [...t, ...e.filter((e) => !t.some((t) => t.id === e.id))]), g([]), v(""), O.current && (O.current.value = "");
			} catch (e) {
				m(k(e));
			} finally {
				T(!1);
			}
		}
	}, F = async (e) => {
		try {
			let t = await r.customerDocs.reindex(e);
			s((n) => n.map((n) => n.id === e ? t : n));
		} catch (e) {
			m(k(e));
		}
	}, I = async (e) => {
		D(null);
		try {
			await r.customerDocs.remove(e), s((t) => t.filter((t) => t.id !== e));
		} catch (e) {
			m(k(e));
		}
	}, z = async (e) => {
		try {
			It(await r.customerDocs.download(e.id), e.fileName);
		} catch (e) {
			m(k(e));
		}
	}, U = (e) => a(`chat.customerDocsStatus${e[0].toUpperCase()}${e.slice(1)}`), W = (e) => e.organizationId ? a("chat.customerDocsScopeOrganization") : a("chat.customerDocsScopeSystem");
	return /* @__PURE__ */ V(c, {
		open: e,
		onClose: t,
		title: a("chat.customerDocsTitle"),
		closeLabel: a("common.close"),
		width: 520,
		children: [
			/* @__PURE__ */ B("p", {
				className: "nb-hint nb-cdoc-intro",
				children: a("chat.customerDocsIntro")
			}),
			/* @__PURE__ */ V("div", {
				className: "nb-cdoc-upload",
				"data-testid": "customer-docs-upload",
				children: [
					/* @__PURE__ */ B("input", {
						ref: O,
						type: "file",
						className: "nb-input nb-cdoc-file",
						multiple: !0,
						accept: ci,
						"aria-label": a("chat.customerDocsChooseFiles"),
						onChange: (e) => {
							var t;
							return g(Array.from((t = e.target.files) == null ? [] : t));
						}
					}),
					h.length === 1 && /* @__PURE__ */ B("input", {
						className: "nb-input",
						"aria-label": a("chat.customerDocsTitleField"),
						placeholder: a("chat.customerDocsTitleField"),
						value: _,
						onChange: (e) => v(e.target.value)
					}),
					i && x && /* @__PURE__ */ B("div", {
						className: "nb-segment",
						role: "radiogroup",
						"aria-label": a("chat.customerDocsFor"),
						children: ["system", "organization"].map((e) => /* @__PURE__ */ B("button", {
							type: "button",
							role: "radio",
							"aria-checked": y === e,
							className: `nb-segment-btn${y === e ? " nb-selected" : ""}`,
							onClick: () => b(e),
							children: a(e === "system" ? "chat.customerDocsScopeSystem" : "chat.customerDocsScopeOrganization")
						}, e))
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-cdoc-upload-row",
						children: [/* @__PURE__ */ B("span", {
							className: "nb-hint nb-cdoc-accepted",
							children: a("chat.customerDocsAccepted")
						}), /* @__PURE__ */ B(f, {
							size: "sm",
							disabled: !h.length,
							loading: w,
							onClick: () => void P(),
							children: a(w ? "chat.customerDocsUploading" : "chat.customerDocsUpload")
						})]
					})
				]
			}),
			p && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: p
			}),
			u && !o.length && /* @__PURE__ */ B(l, { size: 16 }),
			!u && !o.length && /* @__PURE__ */ B("div", {
				className: "nb-empty-state",
				children: a("chat.customerDocsEmpty")
			}),
			/* @__PURE__ */ B("ul", {
				className: "nb-list",
				children: o.map((e) => /* @__PURE__ */ V("li", {
					className: "nb-list-item nb-cdoc",
					"data-doc-id": e.id,
					"data-doc-status": e.status,
					children: [
						/* @__PURE__ */ V("div", {
							className: "nb-list-head",
							children: [/* @__PURE__ */ B("h4", {
								className: "nb-list-title",
								children: e.title || e.fileName
							}), /* @__PURE__ */ V("span", {
								className: `nb-chip nb-chip-sm nb-cdoc-status nb-cdoc-status-${e.status}`,
								children: [ui(e.status) && /* @__PURE__ */ B(l, { size: 10 }), U(e.status)]
							})]
						}),
						/* @__PURE__ */ V("div", {
							className: "nb-list-meta",
							children: [
								e.fileName,
								" · ",
								fi(e.size),
								" · ",
								W(e),
								e.status === "ready" && e.chunks ? ` · ${a("chat.customerDocsSections", { count: e.chunks })}` : ""
							]
						}),
						/* @__PURE__ */ V("div", {
							className: "nb-list-meta",
							children: [di(e.createdAt), e.uploadedBy ? ` · ${a("chat.customerDocsUploadedBy", { user: e.uploadedBy })}` : ""]
						}),
						e.status === "failed" && e.error && /* @__PURE__ */ B("p", {
							className: "nb-cdoc-error",
							children: e.error
						}),
						E === e.id ? /* @__PURE__ */ V("div", {
							className: "nb-list-actions nb-cdoc-confirm",
							role: "alert",
							children: [
								/* @__PURE__ */ B("span", {
									className: "nb-cdoc-confirm-text",
									children: a("chat.customerDocsConfirmDelete", { title: e.title || e.fileName })
								}),
								/* @__PURE__ */ B(f, {
									size: "sm",
									variant: "ghost",
									onClick: () => D(null),
									children: a("common.cancel")
								}),
								/* @__PURE__ */ B(f, {
									size: "sm",
									variant: "danger",
									onClick: () => void I(e.id),
									children: a("chat.customerDocsDelete")
								})
							]
						}) : /* @__PURE__ */ V("div", {
							className: "nb-list-actions",
							children: [
								/* @__PURE__ */ B(n, {
									label: a("chat.customerDocsDownload"),
									onClick: () => void z(e),
									children: /* @__PURE__ */ B(pe, { size: 16 })
								}),
								/* @__PURE__ */ B(n, {
									label: a("chat.customerDocsReindex"),
									disabled: ui(e.status),
									onClick: () => void F(e.id),
									children: /* @__PURE__ */ B(Ae, { size: 16 })
								}),
								/* @__PURE__ */ B(n, {
									label: a("chat.customerDocsDelete"),
									onClick: () => D(e.id),
									children: /* @__PURE__ */ B(ze, { size: 16 })
								})
							]
						})
					]
				}, e.id))
			})
		]
	});
}
// src/drawers/SavedResponsesDrawer.tsx
var hi = (e) => {
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : t.toLocaleDateString(void 0, { dateStyle: "medium" });
}, gi = (e) => e.split(/[,;]/).map((e) => e.trim()).filter(Boolean);
function _i({ open: e, onClose: t, initial: n, onSave: r, title: i }) {
	let { t: a } = C(), [o, s] = R({
		title: "",
		description: "",
		tags: ""
	}), [c, l] = R(!1);
	M(() => {
		var t, r, i;
		e && s({
			title: (t = n == null ? void 0 : n.title) == null ? "" : t,
			description: (r = n == null ? void 0 : n.description) == null ? "" : r,
			tags: (i = n == null ? void 0 : n.tags) == null ? "" : i
		});
	}, [
		e,
		n == null ? void 0 : n.title,
		n == null ? void 0 : n.description,
		n == null ? void 0 : n.tags
	]);
	let d = async () => {
		if (o.title.trim()) {
			l(!0);
			try {
				await r({
					title: o.title.trim(),
					description: o.description.trim() || void 0,
					tags: gi(o.tags)
				}), t();
			} finally {
				l(!1);
			}
		}
	};
	return /* @__PURE__ */ B(h, {
		open: e,
		onClose: t,
		title: i == null ? a("saved.saveTitle") : i,
		closeLabel: a("common.close"),
		maxWidth: 480,
		footer: /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(f, {
			variant: "ghost",
			onClick: t,
			disabled: c,
			children: a("common.cancel")
		}), /* @__PURE__ */ B(f, {
			onClick: () => void d(),
			loading: c,
			disabled: !o.title.trim(),
			children: a("common.save")
		})] }),
		children: /* @__PURE__ */ V("form", {
			className: "nb-form",
			onSubmit: (e) => {
				e.preventDefault(), d();
			},
			children: [
				/* @__PURE__ */ B(u, {
					label: a("saved.title"),
					value: o.title,
					onChange: (e) => s((t) => ({
						...t,
						title: e.target.value
					})),
					autoFocus: !0,
					required: !0
				}),
				/* @__PURE__ */ B(u, {
					label: a("saved.description"),
					value: o.description,
					onChange: (e) => s((t) => ({
						...t,
						description: e.target.value
					})),
					multiline: !0,
					rows: 2
				}),
				/* @__PURE__ */ B(u, {
					label: a("saved.tags"),
					hint: a("saved.tagsHint"),
					value: o.tags,
					onChange: (e) => s((t) => ({
						...t,
						tags: e.target.value
					}))
				})
			]
		})
	});
}
function vi({ open: e, onClose: t, client: i, onRun: a, refreshKey: o }) {
	var s, u;
	let { t: d } = C(), [p, m] = R(null), [h, g] = R(""), [_, v] = R(null), [y, b] = R(!1), [x, S] = R(null), [w, T] = R(null), E = A(async () => {
		try {
			let e = await i.saved.list({
				search: h.trim() || void 0,
				favorites: y || void 0,
				tags: _ ? [_] : void 0,
				limit: 100
			});
			m(e.items), S(null);
		} catch (e) {
			S(e.message), m([]);
		}
	}, [
		i,
		h,
		y,
		_
	]);
	M(() => {
		if (!e) return;
		let t = setTimeout(() => void E(), h ? 250 : 0);
		return () => clearTimeout(t);
	}, [
		e,
		E,
		o,
		h
	]);
	let D = F(() => [...new Set((p == null ? [] : p).flatMap((e) => {
		var t;
		return (t = e.tags) == null ? [] : t;
	}))].sort(), [p]), O = async (e) => {
		m((t) => (t == null ? [] : t).map((t) => t.id === e.id ? {
			...t,
			isFavorite: !t.isFavorite
		} : t));
		try {
			let t = await i.saved.toggleFavorite(e.id);
			m((n) => (n == null ? [] : n).map((n) => n.id === e.id ? {
				...n,
				isFavorite: t.isFavorite
			} : n));
		} catch (e) {
			S(e.message), E();
		}
	}, k = async (e) => {
		if (typeof window > "u" || typeof window.confirm != "function" || window.confirm(d("saved.deleteConfirm"))) {
			m((t) => (t == null ? [] : t).filter((t) => t.id !== e.id));
			try {
				await i.saved.remove(e.id);
			} catch (e) {
				S(e.message), E();
			}
		}
	};
	return /* @__PURE__ */ V(c, {
		open: e,
		onClose: t,
		title: d("chat.savedQueries"),
		closeLabel: d("common.close"),
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-filters",
				children: [/* @__PURE__ */ B("input", {
					className: "nb-input",
					type: "search",
					"aria-label": d("saved.search"),
					placeholder: d("saved.search"),
					value: h,
					onChange: (e) => g(e.target.value)
				}), /* @__PURE__ */ V("div", {
					className: "nb-chips",
					children: [/* @__PURE__ */ B(r, {
						size: "sm",
						selected: y,
						icon: /* @__PURE__ */ B(Ie, { size: 12 }),
						onClick: () => b((e) => !e),
						children: d("saved.favorites")
					}), D.map((e) => /* @__PURE__ */ B(r, {
						size: "sm",
						selected: _ === e,
						onClick: () => v(_ === e ? null : e),
						children: e
					}, e))]
				})]
			}),
			x && /* @__PURE__ */ B("div", {
				className: "nb-login-error",
				children: x
			}),
			p === null ? /* @__PURE__ */ B(l, { size: 16 }) : p.length ? /* @__PURE__ */ B("ul", {
				className: "nb-list",
				children: p.map((e) => {
					var t;
					return /* @__PURE__ */ V("li", {
						className: "nb-list-item",
						"data-saved-id": e.id,
						children: [
							/* @__PURE__ */ V("div", {
								className: "nb-list-head",
								children: [/* @__PURE__ */ B("h4", {
									className: "nb-list-title",
									children: e.title
								}), /* @__PURE__ */ B("span", {
									className: "nb-list-date",
									children: hi(e.updatedAt || e.createdAt)
								})]
							}),
							e.description && /* @__PURE__ */ B("p", {
								className: "nb-list-preview",
								children: e.description
							}),
							/* @__PURE__ */ B("p", {
								className: "nb-saved-question",
								children: e.userQuestion
							}),
							!!((t = e.tags) != null && t.length) && /* @__PURE__ */ B("div", {
								className: "nb-chips",
								children: e.tags.map((e) => /* @__PURE__ */ B(r, {
									size: "sm",
									children: e
								}, e))
							}),
							/* @__PURE__ */ V("div", {
								className: "nb-list-actions",
								children: [
									/* @__PURE__ */ B(f, {
										size: "sm",
										variant: "secondary",
										icon: /* @__PURE__ */ B(Oe, { size: 14 }),
										onClick: () => a(e, { refresh: !1 }),
										children: d("saved.run")
									}),
									/* @__PURE__ */ B(n, {
										label: d("saved.runRefresh"),
										onClick: () => a(e, { refresh: !0 }),
										children: /* @__PURE__ */ B(Ae, { size: 16 })
									}),
									/* @__PURE__ */ B(n, {
										label: e.isFavorite ? d("history.unstar") : d("saved.favorite"),
										active: e.isFavorite,
										onClick: () => void O(e),
										children: /* @__PURE__ */ B(Ie, {
											size: 16,
											fill: e.isFavorite ? "currentColor" : "none"
										})
									}),
									/* @__PURE__ */ B(n, {
										label: d("saved.edit"),
										onClick: () => T(e),
										children: /* @__PURE__ */ B(De, { size: 16 })
									}),
									/* @__PURE__ */ B(n, {
										label: d("common.delete"),
										onClick: () => void k(e),
										children: /* @__PURE__ */ B(ze, { size: 16 })
									})
								]
							})
						]
					}, e.id);
				})
			}) : /* @__PURE__ */ V("div", {
				className: "nb-empty-state",
				children: [/* @__PURE__ */ B("p", { children: d("saved.empty") }), /* @__PURE__ */ B("p", {
					className: "nb-hint",
					children: d("saved.emptyHint")
				})]
			}),
			/* @__PURE__ */ B(_i, {
				open: w !== null,
				onClose: () => T(null),
				title: d("saved.edit"),
				initial: w ? {
					title: w.title,
					description: (s = w.description) == null ? "" : s,
					tags: ((u = w.tags) == null ? [] : u).join(", ")
				} : void 0,
				onSave: async (e) => {
					if (!w) return;
					let t = e, n = await i.saved.update(w.id, t);
					m((e) => (e == null ? [] : e).map((e) => e.id === w.id ? {
						...e,
						...t,
						...n
					} : e));
				}
			})
		]
	});
}
// src/voice/player.ts
var yi;
function bi() {
	var e;
	if (yi) return yi;
	if (typeof window > "u") return;
	let t = (e = window.AudioContext) == null ? window.webkitAudioContext : e;
	if (t) return yi = new t(), yi;
}
function xi() {
	let e = bi();
	(e == null ? void 0 : e.state) === "suspended" && e.resume().catch(() => void 0);
}
async function Si(e) {
	let t = bi();
	if (!t) throw Error("audio playback is not available");
	t.state === "suspended" && await t.resume().catch(() => void 0);
	let n = await t.decodeAudioData(e.slice(0)), r = t.createBufferSource();
	r.buffer = n, r.connect(t.destination);
	let i = () => {}, a = new Promise((e) => i = e);
	return r.onended = () => i(), r.start(), {
		done: a,
		stop: () => {
			try {
				r.stop();
			} catch {}
			i();
		}
	};
}
function Ci(e) {
	let t = bi();
	t && t.state === "running" && (e === "sent" ? [660, 880] : [880]).forEach((e, n) => {
		let r = t.createOscillator(), i = t.createGain(), a = t.currentTime + n * .12;
		r.frequency.value = e, i.gain.setValueAtTime(1e-4, a), i.gain.exponentialRampToValueAtTime(.08, a + .02), i.gain.exponentialRampToValueAtTime(1e-4, a + .18), r.connect(i).connect(t.destination), r.start(a), r.stop(a + .2);
	});
}
// src/voice/useSpeaker.tsx
function wi(e) {
	let [t, n] = R(null), [r, i] = R(null), a = L(null), o = A(() => {
		var e;
		let t = a.current;
		a.current = null, t == null || t.abort.abort(), t == null || (e = t.playback) == null || e.stop(), n(null);
	}, []);
	return M(() => o, [o]), {
		current: t,
		speak: A(async (t) => {
			o(), xi(), i(null);
			let r = {
				id: t,
				abort: new AbortController()
			};
			a.current = r, n({
				id: t,
				phase: "loading"
			});
			try {
				let i = await e(t, r.abort.signal);
				if (a.current !== r) return;
				if (r.playback = await Si(i), a.current !== r) {
					r.playback.stop();
					return;
				}
				n({
					id: t,
					phase: "playing"
				}), await r.playback.done;
			} catch (e) {
				a.current === r && (e == null ? void 0 : e.name) !== "AbortError" && i((e == null ? void 0 : e.code) === "limit_exceeded" ? "limit" : "speakFailed");
			} finally {
				a.current === r && (a.current = null, n(null));
			}
		}, [e, o]),
		stop: o,
		error: r
	};
}
var Ti = O(null), Ei = ({ speaker: e, children: t }) => /* @__PURE__ */ B(Ti.Provider, {
	value: e,
	children: t
}), Di = () => j(Ti), Oi = (e = /* @__PURE__ */ new Date()) => `nycebuddy-${e.toISOString().slice(0, 10)}.pdf`;
function ki({ message: e, canSave: t, canExportPdf: n, onSave: r, exportPdf: i, onExported: a, canSchedule: o, onSchedule: s, canCreateAgent: c, onCreateAgent: l }) {
	var u;
	let { t: d } = C(), f = x(), [p, m] = R(!1), [h, g] = R(!1), _ = e.report, v = Di(), y = (v == null || (u = v.current) == null ? void 0 : u.id) === e.id ? v.current.phase : null, b = !!v && !!e.result && !e.error && !!(_ != null && _.answer || _ != null && _.spoken), S = async () => {
		await Bt([_ == null ? void 0 : _.heading, _ == null ? void 0 : _.answer].filter(Boolean).join("\n\n") || e.text) && (m(!0), setTimeout(() => m(!1), 1500));
	}, w = async () => {
		if (i) {
			g(!0);
			try {
				It(await i(e.id), Oi()), a == null || a(e.id);
			} catch (e) {
				f(e.message || d("pdf.failed"), "error");
			} finally {
				g(!1);
			}
		}
	};
	return /* @__PURE__ */ V(z, { children: [
		((_ == null ? void 0 : _.answer) || e.text) && /* @__PURE__ */ B("button", {
			type: "button",
			className: "nb-iconbtn",
			title: d(p ? "chat.copied" : "chat.copyAnswer"),
			"aria-label": d("chat.copyAnswer"),
			onClick: S,
			children: B(p ? le : fe, { size: 14 })
		}),
		b && /* @__PURE__ */ B("button", {
			type: "button",
			className: "nb-iconbtn nb-speak",
			"data-state": y == null ? "idle" : y,
			title: d(y ? "voice.stopSpeaking" : "voice.speak"),
			"aria-label": d(y ? "voice.stopSpeaking" : "voice.speak"),
			"aria-pressed": !!y,
			onClick: () => y ? v.stop() : void v.speak(e.id),
			children: y === "loading" ? /* @__PURE__ */ B(X, {
				size: 14,
				className: "nb-spin"
			}) : B(y ? Fe : Be, { size: 14 })
		}),
		t && _ && r && /* @__PURE__ */ B("button", {
			type: "button",
			className: "nb-iconbtn",
			title: d("saved.save"),
			"aria-label": d("saved.save"),
			onClick: () => r(e),
			children: /* @__PURE__ */ B(ae, { size: 14 })
		}),
		n && _ && i && /* @__PURE__ */ B("button", {
			type: "button",
			className: "nb-iconbtn",
			title: d("pdf.export"),
			"aria-label": d("pdf.export"),
			onClick: () => void w(),
			disabled: h,
			"aria-busy": h || void 0,
			children: h ? /* @__PURE__ */ B(X, {
				size: 14,
				className: "nb-icon-spin",
				"aria-hidden": "true"
			}) : /* @__PURE__ */ B(ge, { size: 14 })
		}),
		o && _ && s && /* @__PURE__ */ B("button", {
			type: "button",
			className: "nb-iconbtn nb-schedule-btn",
			title: d("schedule.action"),
			"aria-label": d("schedule.action"),
			onClick: () => s(e),
			children: /* @__PURE__ */ B(ce, { size: 14 })
		}),
		c && _ && l && /* @__PURE__ */ B("button", {
			type: "button",
			className: "nb-iconbtn nb-agent-btn",
			title: d("agent.action"),
			"aria-label": d("agent.action"),
			onClick: () => l(e),
			children: /* @__PURE__ */ B(oe, { size: 14 })
		})
	] });
}
// src/hooks/useRoles.ts
var Ai = Y(null);
function ji(e, t) {
	let [n, r] = R(Ai);
	return M(() => {
		let t = !0;
		if (e) return Promise.resolve(e.getToken()).then((e) => t && r(Y(e))).catch(() => {}), () => {
			t = !1;
		};
	}, [e, t]), n;
}
// src/chat/types.ts
var Mi = {
	history: !0,
	savedResponses: !0,
	usage: !0,
	settings: !0,
	feedback: !0,
	pdfExport: !0,
	debug: !1,
	thinkingPicker: !0,
	fileUpload: !1,
	memory: !0,
	adminFeedback: !1,
	htmlRows: !0,
	sendMail: !1,
	monitors: !1,
	mcp: !1,
	scheduledReports: !0,
	responseAgents: !1,
	customerDocs: !1,
	customerDocsAdmin: !1
}, Ni = O(null);
function Pi() {
	let e = j(Ni);
	if (!e) throw Error("useBuddy must be used inside <BuddyProvider> / <NyceBuddyChat>");
	return e;
}
function Fi() {
	return j(Ni);
}
function Ii() {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
	} catch {
		return "UTC";
	}
}
function Li(e) {
	let { baseUrl: t, auth: n, system: r, client: i, storage: a, features: o, debug: s, language: c, context: l } = e, u = e.formContext ? JSON.stringify(e.formContext) : "", d = F(() => {
		var t;
		return (t = e.formContext) == null ? null : t;
	}, [u]), f = A((t) => {
		var n;
		return (n = e.onEvent) == null ? void 0 : n.call(e, t);
	}, [e.onEvent]), p = F(() => i || W({
		baseUrl: t,
		system: r,
		auth: {
			getToken: () => n.getToken(),
			refresh: n.refresh ? () => n.refresh() : void 0,
			onAuthExpired: (e) => {
				var t;
				(t = n.onAuthExpired) == null || t.call(n, e), f({
					type: "auth-expired",
					reason: e
				});
			}
		}
	}), [
		i,
		t,
		r,
		n,
		f
	]), m = F(() => {
		var e;
		return St({
			prefix: a == null ? void 0 : a.prefix,
			scope: (e = a == null ? void 0 : a.scope) == null ? "session" : e,
			adapter: a == null ? void 0 : a.adapter
		});
	}, [
		a == null ? void 0 : a.prefix,
		a == null ? void 0 : a.scope,
		a == null ? void 0 : a.adapter
	]), h = F(() => (a == null ? void 0 : a.scope) === "memory" || a != null && a.adapter ? m : m.scope("local"), [m, a]), g = ji(n), _ = F(() => ({
		...Mi,
		adminFeedback: g.isSystemAdmin,
		debug: !!s,
		...o
	}), [
		o,
		g.isSystemAdmin,
		s
	]), v = F(() => {
		var i, a, o;
		return {
			client: p,
			auth: n,
			baseUrl: t,
			system: r,
			storage: m,
			prefs: h,
			features: _,
			roles: g,
			layout: (i = e.layout) == null ? "app" : i,
			hideScope: (a = e.hideScope) != null && a,
			actionsSlot: (o = e.actionsSlot) == null ? null : o,
			theme: e.theme,
			onThemeChange: e.onThemeChange,
			debug: !!s,
			language: c == null ? "en" : c,
			timezone: Ii(),
			context: l,
			formContext: d,
			userName: e.userName,
			userCode: e.userCode,
			systemName: e.systemName,
			organizationName: e.organizationName,
			tenantName: e.tenantName,
			limitStatus: e.limitStatus,
			showRawData: e.showRawData,
			emit: f,
			onOpenEntity: e.onOpenEntity,
			onLogoutRequested: e.onLogoutRequested
		};
	}, [
		p,
		n,
		t,
		r,
		e.theme,
		e.onThemeChange,
		m,
		h,
		_,
		g,
		e.layout,
		e.hideScope,
		e.actionsSlot,
		s,
		c,
		l,
		d,
		e.userName,
		e.userCode,
		e.systemName,
		e.organizationName,
		e.tenantName,
		e.limitStatus,
		e.showRawData,
		f,
		e.onOpenEntity,
		e.onLogoutRequested
	]), y = F(() => ({ renderMath: e.renderMath }), [e.renderMath]), b = A((e) => p.images.fetch(e), [p]);
	return /* @__PURE__ */ B(Ni.Provider, {
		value: v,
		children: /* @__PURE__ */ B(bn.Provider, {
			value: y,
			children: /* @__PURE__ */ B(Ln, {
				fetch: b,
				children: /* @__PURE__ */ B(kn, {
					actions: e.artifactActions,
					children: e.children
				})
			})
		})
	});
}
// src/hooks/useUserFilters.ts
function Ri({ client: e, enabled: t = !0 }) {
	let [n, r] = R(null), [i, a] = R(t), [o, s] = R(null);
	return M(() => {
		if (!t) {
			a(!1);
			return;
		}
		let n = !0;
		return a(!0), e.userFilters().then((e) => {
			n && (r(e), s(null));
		}).catch((e) => {
			n && (r(null), s(e.message));
		}).finally(() => {
			n && a(!1);
		}), () => {
			n = !1;
		};
	}, [e, t]), {
		filters: n,
		loading: i,
		error: o
	};
}
// src/assets/index.ts
var zi = {
	logoBlack: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20viewBox='0%200%201080%20190.6'%3e%3c!--%20Generator:%20Adobe%20Illustrator%2029.6.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%202.1.1%20Build%209)%20--%3e%3cdefs%3e%3cstyle%3e%20.st0%20{%20fill:%20%231e2228;%20}%20%3c/style%3e%3c/defs%3e%3cg%3e%3cpolygon%20class='st0'%20points='102.3%2059.8%2056%2033.1%2056%2086.5%20102.3%2059.8'/%3e%3cpolygon%20class='st0'%20points='58.2%2092.4%20104.5%20119.1%20104.5%2065.7%2058.2%2092.4'/%3e%3cpolygon%20class='st0'%20points='55.7%20151.7%20102%20125%2055.7%2098.3%2055.7%20151.7'/%3e%3cpolygon%20class='st0'%20points='2.3%20124.7%2048.6%20151.4%2048.6%2098%202.3%20124.7'/%3e%3cpolygon%20class='st0'%20points='46.2%2092.6%200%2065.9%200%20119.3%2046.2%2092.6'/%3e%3cpolygon%20class='st0'%20points='2.3%2060.1%2048.6%2086.8%2048.6%2033.4%202.3%2060.1'/%3e%3c/g%3e%3cpath%20class='st0'%20d='M204.4,88.9c0-12.7-7-19.7-17.9-19.7s-17.9,7-17.9,19.7v50.6h-28.5V46.4h28.5v12.4c5.7-7.8,15.7-13.4,28.2-13.4,21.5,0,35.9,14.7,35.9,39.7v54.4h-28.4v-50.6Z'/%3e%3cpath%20class='st0'%20d='M309.1,45.8h30.9l-58.5,137.5h-30.7l21.4-47.5-37.9-90.1h31.9l21.6,58.3,21.4-58.3Z'/%3e%3cpath%20class='st0'%20d='M383.1,44.5c23.4,0,39.9,12.9,44.8,35.1h-30.4c-2.3-6.5-7-10.7-14.9-10.7s-17.2,8-17.2,23.6,7,23.6,17.2,23.6,12.4-3.8,14.9-10.7h30.4c-4.8,21.6-21.4,35.1-44.8,35.1s-46.8-18.4-46.8-48,19.4-48,46.8-48Z'/%3e%3cpath%20class='st0'%20d='M480.8,140.4c-27.4,0-47.1-18.4-47.1-48s19.4-48,47.1-48,46.4,18,46.4,46.4-.2,5.5-.5,8.4h-64.7c1,12.2,8.5,17.9,17.7,17.9s12.5-4,14.9-9h30.4c-4.5,18.2-21.1,32.2-44.3,32.2ZM462.2,83.4h35.8c0-10.2-8-16-17.5-16s-16.5,5.7-18.2,16Z'/%3e%3cg%3e%3cpath%20class='st0'%20d='M623,78.7c4,3.2,7.2,7.1,9.6,11.8,2.4,4.7,3.5,9.7,3.5,15.1s-1.7,12.8-5.2,18.2c-3.4,5.4-8.4,9.7-15,12.8-6.6,3.1-14.3,4.7-23.2,4.7h-49.6V8.2h47.7c9,0,16.7,1.5,23.1,4.5,6.4,3,11.1,7,14.3,12.1,3.2,5.1,4.8,10.8,4.8,17.2s-2.1,14.4-6.4,19.6c-4.3,5.2-9.9,8.9-16.9,11.2,4.8.8,9.3,2.7,13.3,5.9ZM560.5,65.7h29.2c8.1,0,14.4-1.9,18.9-5.7,4.5-3.8,6.7-9.1,6.7-15.8s-2.2-12-6.7-15.8c-4.5-3.8-10.9-5.7-19.3-5.7h-28.8v43.2ZM611.4,120.9c4.8-4.1,7.3-9.7,7.3-17s-2.5-13.2-7.6-17.5c-5.1-4.3-11.9-6.4-20.4-6.4h-30.2v47h30.7c8.7,0,15.4-2,20.2-6.1Z'/%3e%3cpath%20class='st0'%20d='M738.5,36.7v104.6h-17.4v-15.5c-3.3,5.3-7.9,9.5-13.8,12.5-5.9,3-12.4,4.5-19.6,4.5s-15.5-1.7-22-5.1c-6.5-3.4-11.6-8.4-15.4-15.2-3.8-6.7-5.6-15-5.6-24.6v-61.3h17.2v59c0,10.3,2.6,18.2,7.8,23.8,5.2,5.5,12.3,8.3,21.4,8.3s16.6-2.9,22-8.6c5.4-5.7,8-14.1,8-25v-57.5h17.4Z'/%3e%3cpath%20class='st0'%20d='M757.8,60.4c4.3-8.1,10.3-14.3,17.9-18.8,7.6-4.5,16.1-6.7,25.5-6.7s15.7,1.9,22.7,5.6c7,3.8,12.3,8.7,16,14.8V0h17.6v141.3h-17.6v-19.7c-3.4,6.2-8.5,11.4-15.3,15.4-6.8,4-14.6,6-23.7,6s-17.7-2.3-25.3-6.9c-7.6-4.6-13.5-11-17.9-19.3-4.3-8.3-6.5-17.7-6.5-28.3s2.2-20.1,6.5-28.2ZM835.1,68.2c-3.2-5.9-7.5-10.3-12.9-13.5-5.4-3.1-11.4-4.7-17.9-4.7s-12.4,1.5-17.8,4.6c-5.4,3.1-9.6,7.5-12.8,13.4-3.2,5.9-4.8,12.7-4.8,20.6s1.6,15,4.8,20.9c3.2,5.9,7.4,10.4,12.8,13.6,5.3,3.1,11.3,4.7,17.8,4.7s12.4-1.6,17.9-4.7c5.4-3.1,9.7-7.6,12.9-13.6,3.2-5.9,4.8-12.8,4.8-20.7s-1.6-14.8-4.8-20.6Z'/%3e%3cpath%20class='st0'%20d='M873.1,60.4c4.3-8.1,10.3-14.3,17.9-18.8,7.6-4.5,16.1-6.7,25.5-6.7s15.7,1.9,22.7,5.6c7,3.8,12.3,8.7,16,14.8V0h17.6v141.3h-17.6v-19.7c-3.4,6.2-8.5,11.4-15.3,15.4-6.8,4-14.6,6-23.7,6s-17.7-2.3-25.3-6.9c-7.6-4.6-13.5-11-17.9-19.3-4.3-8.3-6.5-17.7-6.5-28.3s2.2-20.1,6.5-28.2ZM950.4,68.2c-3.2-5.9-7.5-10.3-12.9-13.5-5.4-3.1-11.4-4.7-17.9-4.7s-12.4,1.5-17.8,4.6c-5.4,3.1-9.6,7.5-12.8,13.4-3.2,5.9-4.8,12.7-4.8,20.6s1.6,15,4.8,20.9c3.2,5.9,7.4,10.4,12.8,13.6,5.3,3.1,11.3,4.7,17.8,4.7s12.4-1.6,17.9-4.7c5.4-3.1,9.7-7.6,12.9-13.6,3.2-5.9,4.8-12.8,4.8-20.7s-1.6-14.8-4.8-20.6Z'/%3e%3cpath%20class='st0'%20d='M1079.3,36.7l-63,153.9h-17.9l20.6-50.4-42.2-103.5h19.3l32.8,84.8,32.5-84.8h17.9Z'/%3e%3c/g%3e%3c/svg%3e",
	logoWhite: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20viewBox='0%200%201080%20190.6'%3e%3c!--%20Generator:%20Adobe%20Illustrator%2029.6.1,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%202.1.1%20Build%209)%20--%3e%3cdefs%3e%3cstyle%3e%20.st0%20{%20fill:%20%23fff;%20}%20%3c/style%3e%3c/defs%3e%3cg%3e%3cpolygon%20class='st0'%20points='102.3%2059.8%2056%2033.1%2056%2086.5%20102.3%2059.8'/%3e%3cpolygon%20class='st0'%20points='58.2%2092.4%20104.5%20119.1%20104.5%2065.7%2058.2%2092.4'/%3e%3cpolygon%20class='st0'%20points='55.7%20151.7%20102%20125%2055.7%2098.3%2055.7%20151.7'/%3e%3cpolygon%20class='st0'%20points='2.3%20124.7%2048.6%20151.4%2048.6%2098%202.3%20124.7'/%3e%3cpolygon%20class='st0'%20points='46.2%2092.6%200%2065.9%200%20119.3%2046.2%2092.6'/%3e%3cpolygon%20class='st0'%20points='2.3%2060.1%2048.6%2086.8%2048.6%2033.4%202.3%2060.1'/%3e%3c/g%3e%3cpath%20class='st0'%20d='M204.4,88.9c0-12.7-7-19.7-17.9-19.7s-17.9,7-17.9,19.7v50.6h-28.5V46.4h28.5v12.4c5.7-7.8,15.7-13.4,28.2-13.4,21.5,0,35.9,14.7,35.9,39.7v54.4h-28.4v-50.6Z'/%3e%3cpath%20class='st0'%20d='M309.1,45.8h30.9l-58.5,137.5h-30.7l21.4-47.5-37.9-90.1h31.9l21.6,58.3,21.4-58.3Z'/%3e%3cpath%20class='st0'%20d='M383.1,44.5c23.4,0,39.9,12.9,44.8,35.1h-30.4c-2.3-6.5-7-10.7-14.9-10.7s-17.2,8-17.2,23.6,7,23.6,17.2,23.6,12.4-3.8,14.9-10.7h30.4c-4.8,21.6-21.4,35.1-44.8,35.1s-46.8-18.4-46.8-48,19.4-48,46.8-48Z'/%3e%3cpath%20class='st0'%20d='M480.8,140.4c-27.4,0-47.1-18.4-47.1-48s19.4-48,47.1-48,46.4,18,46.4,46.4-.2,5.5-.5,8.4h-64.7c1,12.2,8.5,17.9,17.7,17.9s12.5-4,14.9-9h30.4c-4.5,18.2-21.1,32.2-44.3,32.2ZM462.2,83.4h35.8c0-10.2-8-16-17.5-16s-16.5,5.7-18.2,16Z'/%3e%3cg%3e%3cpath%20class='st0'%20d='M623,78.7c4,3.2,7.2,7.1,9.6,11.8,2.4,4.7,3.5,9.7,3.5,15.1s-1.7,12.8-5.2,18.2c-3.4,5.4-8.4,9.7-15,12.8-6.6,3.1-14.3,4.7-23.2,4.7h-49.6V8.2h47.7c9,0,16.7,1.5,23.1,4.5,6.4,3,11.1,7,14.3,12.1,3.2,5.1,4.8,10.8,4.8,17.2s-2.1,14.4-6.4,19.6c-4.3,5.2-9.9,8.9-16.9,11.2,4.8.8,9.3,2.7,13.3,5.9ZM560.5,65.7h29.2c8.1,0,14.4-1.9,18.9-5.7,4.5-3.8,6.7-9.1,6.7-15.8s-2.2-12-6.7-15.8c-4.5-3.8-10.9-5.7-19.3-5.7h-28.8v43.2ZM611.4,120.9c4.8-4.1,7.3-9.7,7.3-17s-2.5-13.2-7.6-17.5c-5.1-4.3-11.9-6.4-20.4-6.4h-30.2v47h30.7c8.7,0,15.4-2,20.2-6.1Z'/%3e%3cpath%20class='st0'%20d='M738.5,36.7v104.6h-17.4v-15.5c-3.3,5.3-7.9,9.5-13.8,12.5-5.9,3-12.4,4.5-19.6,4.5s-15.5-1.7-22-5.1c-6.5-3.4-11.6-8.4-15.4-15.2-3.8-6.7-5.6-15-5.6-24.6v-61.3h17.2v59c0,10.3,2.6,18.2,7.8,23.8,5.2,5.5,12.3,8.3,21.4,8.3s16.6-2.9,22-8.6c5.4-5.7,8-14.1,8-25v-57.5h17.4Z'/%3e%3cpath%20class='st0'%20d='M757.8,60.4c4.3-8.1,10.3-14.3,17.9-18.8,7.6-4.5,16.1-6.7,25.5-6.7s15.7,1.9,22.7,5.6c7,3.8,12.3,8.7,16,14.8V0h17.6v141.3h-17.6v-19.7c-3.4,6.2-8.5,11.4-15.3,15.4-6.8,4-14.6,6-23.7,6s-17.7-2.3-25.3-6.9c-7.6-4.6-13.5-11-17.9-19.3-4.3-8.3-6.5-17.7-6.5-28.3s2.2-20.1,6.5-28.2ZM835.1,68.2c-3.2-5.9-7.5-10.3-12.9-13.5-5.4-3.1-11.4-4.7-17.9-4.7s-12.4,1.5-17.8,4.6c-5.4,3.1-9.6,7.5-12.8,13.4-3.2,5.9-4.8,12.7-4.8,20.6s1.6,15,4.8,20.9c3.2,5.9,7.4,10.4,12.8,13.6,5.3,3.1,11.3,4.7,17.8,4.7s12.4-1.6,17.9-4.7c5.4-3.1,9.7-7.6,12.9-13.6,3.2-5.9,4.8-12.8,4.8-20.7s-1.6-14.8-4.8-20.6Z'/%3e%3cpath%20class='st0'%20d='M873.1,60.4c4.3-8.1,10.3-14.3,17.9-18.8,7.6-4.5,16.1-6.7,25.5-6.7s15.7,1.9,22.7,5.6c7,3.8,12.3,8.7,16,14.8V0h17.6v141.3h-17.6v-19.7c-3.4,6.2-8.5,11.4-15.3,15.4-6.8,4-14.6,6-23.7,6s-17.7-2.3-25.3-6.9c-7.6-4.6-13.5-11-17.9-19.3-4.3-8.3-6.5-17.7-6.5-28.3s2.2-20.1,6.5-28.2ZM950.4,68.2c-3.2-5.9-7.5-10.3-12.9-13.5-5.4-3.1-11.4-4.7-17.9-4.7s-12.4,1.5-17.8,4.6c-5.4,3.1-9.6,7.5-12.8,13.4-3.2,5.9-4.8,12.7-4.8,20.6s1.6,15,4.8,20.9c3.2,5.9,7.4,10.4,12.8,13.6,5.3,3.1,11.3,4.7,17.8,4.7s12.4-1.6,17.9-4.7c5.4-3.1,9.7-7.6,12.9-13.6,3.2-5.9,4.8-12.8,4.8-20.7s-1.6-14.8-4.8-20.6Z'/%3e%3cpath%20class='st0'%20d='M1079.3,36.7l-63,153.9h-17.9l20.6-50.4-42.2-103.5h19.3l32.8,84.8,32.5-84.8h17.9Z'/%3e%3c/g%3e%3c/svg%3e",
	botIcon: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='uuid-91cf7adc-32c1-484c-a27a-068a13e30d2b'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20848.35%20963.14'%3e%3cpolygon%20points='830.33%20216.81%20454.79%200%20454.79%20433.63%20830.33%20216.81'%20fill='%23000000'%20stroke-width='0'/%3e%3cpolygon%20points='472.82%20481.53%20848.35%20698.35%20848.35%20264.72%20472.82%20481.53'%20fill='%23000000'%20stroke-width='0'/%3e%3cpolygon%20points='452.41%20963.14%20827.95%20746.33%20452.41%20529.5%20452.41%20963.14'%20fill='%23000000'%20stroke-width='0'/%3e%3cpolygon%20points='19.07%20743.66%20394.61%20960.48%20394.61%20526.84%2019.07%20743.66'%20fill='%23000000'%20stroke-width='0'/%3e%3cpolygon%20points='375.53%20482.86%200%20266.04%200%20699.68%20375.53%20482.86'%20fill='%23000000'%20stroke-width='0'/%3e%3cpolygon%20points='19.07%20219.4%20394.61%20436.21%20394.61%202.58%2019.07%20219.4'%20fill='%23000000'%20stroke-width='0'/%3e%3c/svg%3e",
	botIconWhite: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='uuid-91cf7adc-32c1-484c-a27a-068a13e30d2b'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20848.35%20963.14'%3e%3cpolygon%20points='830.33%20216.81%20454.79%200%20454.79%20433.63%20830.33%20216.81'%20fill='%23ffffff'%20stroke-width='0'/%3e%3cpolygon%20points='472.82%20481.53%20848.35%20698.35%20848.35%20264.72%20472.82%20481.53'%20fill='%23ffffff'%20stroke-width='0'/%3e%3cpolygon%20points='452.41%20963.14%20827.95%20746.33%20452.41%20529.5%20452.41%20963.14'%20fill='%23ffffff'%20stroke-width='0'/%3e%3cpolygon%20points='19.07%20743.66%20394.61%20960.48%20394.61%20526.84%2019.07%20743.66'%20fill='%23ffffff'%20stroke-width='0'/%3e%3cpolygon%20points='375.53%20482.86%200%20266.04%200%20699.68%20375.53%20482.86'%20fill='%23ffffff'%20stroke-width='0'/%3e%3cpolygon%20points='19.07%20219.4%20394.61%20436.21%20394.61%202.58%2019.07%20219.4'%20fill='%23ffffff'%20stroke-width='0'/%3e%3c/svg%3e"
};
// src/chat/ChatHeader.tsx
function Bi(e, t, n) {
	let r = [{
		value: "",
		label: n
	}, ...e.map((e) => ({
		value: String(e.value),
		label: e.label
	}))];
	return t != null && !e.some((e) => String(e.value) === String(t)) && r.push({
		value: String(t),
		label: `#${t}`
	}), r;
}
var Vi = (e, t, n) => {
	if (e === "") return n({ [t]: null });
	let r = Number(e);
	Number.isFinite(r) && n({ [t]: r });
};
function Hi({ onLogout: e, onOpen: t, feedbackBadge: a, scope: o, onExportConversation: c, canExportConversation: l, exportingConversation: u }) {
	let { t: d } = C(), { client: f, features: p, context: m, emit: h, layout: _, hideScope: v, actionsSlot: y, userName: b, systemName: x, organizationName: S, tenantName: w, onLogoutRequested: T } = Pi(), E = S || w, { filters: D } = Ri({
		client: f,
		enabled: !v && _ === "app" && !!o
	}), O = !v && _ === "app" && !!o && !!D && D.available !== !1, k = [];
	!v && !O && (m == null ? void 0 : m.clientId) != null && k.push(`${d("chat.clientFilter")} ${m.clientId}`), !v && !O && (m == null ? void 0 : m.warehouseId) != null && k.push(`${d("chat.warehouseFilter")} ${m.warehouseId}`);
	let A = (e) => () => {
		h({
			type: "open",
			panel: e
		}), t == null || t({
			type: "open",
			panel: e
		});
	}, j = [
		p.history && {
			key: "history",
			label: d("chat.conversationHistory"),
			icon: /* @__PURE__ */ B(be, { size: 20 }),
			onSelect: A("history")
		},
		p.savedResponses && {
			key: "saved",
			label: d("chat.savedQueries"),
			icon: /* @__PURE__ */ B(ae, { size: 20 }),
			onSelect: A("saved")
		},
		p.usage && {
			key: "usage",
			label: d("chat.tokenUsage"),
			icon: /* @__PURE__ */ B(ie, { size: 20 }),
			onSelect: A("usage")
		},
		p.feedback && {
			key: "feedback",
			label: d("chat.feedbackResponses"),
			icon: /* @__PURE__ */ B(we, { size: 20 }),
			onSelect: A("feedback"),
			badge: a
		},
		p.adminFeedback && {
			key: "adminFeedback",
			label: d("chat.adminFeedback"),
			icon: /* @__PURE__ */ B(Ne, { size: 20 }),
			onSelect: A("adminFeedback")
		},
		p.customerDocsAdmin && {
			key: "customerDocs",
			label: d("chat.customerDocuments"),
			icon: /* @__PURE__ */ B(ve, { size: 20 }),
			onSelect: A("customerDocs")
		},
		p.pdfExport && c && l && {
			key: "exportConversation",
			label: d("pdf.exportConversation"),
			icon: u ? /* @__PURE__ */ B(X, {
				size: 20,
				className: "nb-icon-spin",
				"aria-hidden": "true"
			}) : /* @__PURE__ */ B(ge, { size: 20 }),
			onSelect: c,
			disabled: u,
			busy: u
		},
		p.settings && {
			key: "settings",
			label: d("chat.settings"),
			icon: /* @__PURE__ */ B(Me, { size: 20 }),
			onSelect: A("settings")
		},
		_ === "app" && (e || T) && {
			key: "logout",
			label: d("chat.logout"),
			icon: /* @__PURE__ */ B(Ce, { size: 20 }),
			onSelect: () => {
				h({ type: "logout-requested" }), T == null || T(), e == null || e();
			}
		}
	].filter(Boolean), M = _ === "panel", N = M ? /* @__PURE__ */ B(g, {
		label: d("chat.moreActions"),
		items: j,
		badge: a,
		children: u ? /* @__PURE__ */ B(X, {
			size: 20,
			className: "nb-icon-spin",
			"aria-hidden": "true"
		}) : /* @__PURE__ */ B(Ee, { size: 20 })
	}) : j.map((e) => /* @__PURE__ */ B(n, {
		label: e.label,
		onClick: e.onSelect,
		badge: e.badge,
		disabled: e.disabled,
		"aria-busy": e.busy || void 0,
		children: e.icon
	}, e.key));
	return y && M && !O && k.length === 0 ? /* @__PURE__ */ B(i, {
		container: y,
		children: N
	}) : /* @__PURE__ */ V("header", {
		className: "nb-header",
		children: [/* @__PURE__ */ V("div", {
			className: "nb-header-main",
			children: [
				_ === "app" && /* @__PURE__ */ V("div", {
					className: "nb-logo",
					children: [/* @__PURE__ */ B("img", {
						src: zi.logoBlack,
						alt: "nyceBuddy"
					}), /* @__PURE__ */ B("p", {
						className: "nb-tagline",
						children: d("chat.tagline")
					})]
				}),
				O && o && D && /* @__PURE__ */ V("div", {
					className: "nb-scope",
					"data-testid": "scope",
					children: [/* @__PURE__ */ V("label", {
						className: "nb-scope-field",
						children: [/* @__PURE__ */ B("span", {
							className: "nb-scope-label",
							children: d("chat.clientFilter")
						}), /* @__PURE__ */ B(s, {
							className: "nb-scope-select",
							"aria-label": d("chat.clientFilter"),
							value: o.clientId == null ? "" : String(o.clientId),
							disabled: o.busy,
							options: Bi(D.clients, o.clientId, d("chat.allMyClients")),
							onChange: (e) => Vi(e, "selectedClientId", o.onChange)
						})]
					}), /* @__PURE__ */ V("label", {
						className: "nb-scope-field",
						children: [/* @__PURE__ */ B("span", {
							className: "nb-scope-label",
							children: d("chat.warehouseFilter")
						}), /* @__PURE__ */ B(s, {
							className: "nb-scope-select",
							"aria-label": d("chat.warehouseFilter"),
							value: o.warehouseId == null ? "" : String(o.warehouseId),
							disabled: o.busy,
							options: Bi(D.warehouses, o.warehouseId, d("chat.allMyWarehouses")),
							onChange: (e) => Vi(e, "selectedWarehouseId", o.onChange)
						})]
					})]
				}),
				k.length > 0 && /* @__PURE__ */ B("div", {
					className: "nb-context",
					children: k.map((e) => /* @__PURE__ */ B(r, {
						size: "sm",
						children: e
					}, e))
				})
			]
		}), /* @__PURE__ */ V("div", {
			className: "nb-header-actions",
			children: [_ === "app" && (b || x || E) && /* @__PURE__ */ B("span", {
				className: "nb-header-user",
				title: [
					E,
					x,
					b
				].filter(Boolean).join(" · "),
				children: [
					E,
					x,
					b
				].filter(Boolean).join(" · ")
			}), y ? /* @__PURE__ */ B(i, {
				container: y,
				children: N
			}) : N]
		})]
	});
}
// src/chat/attachments.ts
var Ui = {
	maxFiles: 5,
	maxImages: 4,
	maxBytes: 20971520
}, Wi = new Set(".png,.jpg,.jpeg,.webp,.gif,.pdf,.csv,.tsv,.xlsx,.xlsm,.xls,.txt,.md,.log,.json,.xml,.yaml,.yml,.html,.htm,.sql".split(",").map((e) => e.slice(1))), Gi = /* @__PURE__ */ new Set([
	"png",
	"jpg",
	"jpeg",
	"webp",
	"gif"
]), Ki = (e) => (e.split(".").pop() || "").toLowerCase().trim(), qi = (e) => e.type.startsWith("image/") || Gi.has(Ki(e.name));
function Ji(e, t) {
	let n = [], r = [], i = t.length, a = t.filter((e) => e.kind === "image").length, o = !1, s = !1;
	for (let t of e) Wi.has(Ki(t.name)) ? t.size > Ui.maxBytes ? r.push({
		code: "file_too_large",
		fileName: t.name,
		maxMb: Ui.maxBytes / 1048576
	}) : i >= Ui.maxFiles ? (o || r.push({
		code: "too_many_files",
		max: Ui.maxFiles
	}), o = !0) : qi(t) && a >= Ui.maxImages ? (s || r.push({
		code: "too_many_images",
		max: Ui.maxImages
	}), s = !0) : (n.push(t), i++, qi(t) && a++) : r.push({
		code: "unsupported_file",
		fileName: t.name
	});
	return {
		accepted: n,
		rejected: r
	};
}
function Yi(e) {
	if (e == null || !isFinite(e) || e < 0) return "";
	if (e < 1024) return `${e} B`;
	let t = e / 1024;
	if (t < 1024) return `${Math.round(t)} kB`;
	let n = t / 1024;
	return `${n < 10 ? n.toFixed(1) : Math.round(n)} MB`;
}
var Xi = (e) => {
	var t;
	return {
		id: e.id,
		fileName: e.fileName,
		kind: e.kind,
		size: e.size,
		rows: (t = e.rows) == null ? void 0 : t
	};
}, Zi = {
	image: xe,
	pdf: ve,
	table: _e,
	text: ve
};
function Qi({ files: e, pending: t = [], onRemove: n, className: r }) {
	let { t: i } = C();
	return !e.length && !t.length ? null : /* @__PURE__ */ V("ul", {
		className: ["nb-attachments", r].filter(Boolean).join(" "),
		children: [e.map((e) => {
			var t, r;
			let a = (t = Zi[e.kind]) == null ? Z : t, o = e.rows == null ? Yi((r = e.size) == null ? void 0 : r) : i("attachments.rowCount", { count: e.rows });
			return /* @__PURE__ */ V("li", {
				className: "nb-attachment",
				"data-kind": e.kind,
				children: [
					/* @__PURE__ */ B(a, {
						size: 14,
						"aria-hidden": "true"
					}),
					/* @__PURE__ */ B("span", {
						className: "nb-attachment-name",
						title: e.fileName,
						children: e.fileName
					}),
					o && /* @__PURE__ */ B("span", {
						className: "nb-attachment-meta",
						children: o
					}),
					n && /* @__PURE__ */ B("button", {
						type: "button",
						className: "nb-attachment-remove",
						"aria-label": i("attachments.remove", { name: e.fileName }),
						onClick: () => n(e.id),
						children: /* @__PURE__ */ B(Ve, { size: 12 })
					})
				]
			}, e.id);
		}), t.map((e) => /* @__PURE__ */ V("li", {
			className: "nb-attachment nb-attachment-pending",
			"aria-busy": "true",
			children: [
				/* @__PURE__ */ B(Z, {
					size: 14,
					"aria-hidden": "true"
				}),
				/* @__PURE__ */ B("span", {
					className: "nb-attachment-name",
					title: e,
					children: e
				}),
				/* @__PURE__ */ B("span", {
					className: "nb-attachment-meta",
					children: i("attachments.uploading")
				})
			]
		}, `pending:${e}`))]
	});
}
// src/chat/FrameTable.tsx
function $i({ client: e, messageId: t, frame: n, title: r, pageSize: i = 100, initialRows: a, onOpenEntity: o }) {
	let { t: s } = C(), [c, u] = R(a == null ? [] : a), [d, p] = R([]), [m, h] = R(null), [g, _] = R(!1), [v, y] = R(!1), [b, x] = R(null), S = A(async (r) => {
		_(!0), x(null);
		try {
			let a = await e.frame(t, n, {
				offset: r,
				limit: i
			});
			return p(a.columns), h(a.total), u((e) => r === 0 ? a.rows : [...e, ...a.rows]), a;
		} catch (e) {
			return x(e.message), null;
		} finally {
			_(!1);
		}
	}, [
		e,
		t,
		n,
		i
	]);
	M(() => {
		S(0);
	}, [S]);
	let w = async () => {
		y(!0);
		try {
			let i = [], a = 0, o = d;
			for (;;) {
				let r = await e.frame(t, n, {
					offset: a,
					limit: 1e3
				});
				if (o = r.columns, i = i.concat(r.rows), a += r.rows.length, !r.rows.length || a >= r.total) break;
			}
			zt(i, Rt(r, `frame-${n}`), o);
		} catch (e) {
			x(e.message);
		} finally {
			y(!1);
		}
	}, { toolbar: T, visible: E } = Zn(c, d, {
		hideIds: !0,
		fileName: r
	}), D = m != null && c.length < m;
	return /* @__PURE__ */ V("div", {
		className: "nb-viz nb-frame",
		"data-frame": n,
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-eyebrow",
				children: [
					r || s("report.table"),
					/* @__PURE__ */ V("span", { children: [
						m == null ? s("report.loadingRows") : s("report.rowsShown", {
							count: m.toLocaleString(),
							shown: c.length.toLocaleString()
						}),
						" · ",
						s("report.frame", { n })
					] }),
					c.length > 0 && T
				]
			}),
			b && /* @__PURE__ */ B("div", {
				className: "nb-error",
				children: b
			}),
			c.length > 0 ? /* @__PURE__ */ B(Qn, {
				rows: c,
				visibleColumns: E.length ? E : void 0,
				maxRows: 1e4,
				onOpenEntity: o
			}) : g ? /* @__PURE__ */ B(l, { size: 16 }) : /* @__PURE__ */ B("div", {
				className: "nb-empty",
				children: s("report.emptyRows")
			}),
			/* @__PURE__ */ V("div", {
				className: "nb-actions",
				children: [D && /* @__PURE__ */ B(f, {
					size: "sm",
					variant: "ghost",
					loading: g,
					onClick: () => void S(c.length),
					children: s("report.loadMore", { n: Math.min(i, (m == null ? 0 : m) - c.length) })
				}), m != null && m > 0 && /* @__PURE__ */ B(f, {
					size: "sm",
					variant: "ghost",
					loading: v,
					onClick: () => void w(),
					children: s("report.downloadAllCsv", { n: m.toLocaleString() })
				})]
			})
		]
	});
}
// src/chat/EvidencePanel.tsx
var ea = (e) => Array.isArray(e) ? e : null;
function ta({ q: e, index: t, highlight: n }) {
	var r, i, a, o, s, c;
	let { t: l } = C(), u = ea(e.rows), d = [
		e.frame == null ? null : l("report.frame", { n: e.frame }),
		e.status == null ? null : `HTTP ${e.status}`,
		u ? l("report.rows", { count: ((r = e.rowCount) == null ? u.length : r).toLocaleString() }) : null,
		e.attempts && e.attempts > 1 ? l("report.repaired", { n: e.attempts - 1 }) : null,
		e.ms == null ? null : `${e.ms} ms`
	].filter(Boolean);
	return /* @__PURE__ */ V("div", {
		className: `nb-card${n ? " nb-highlight" : ""}`,
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-card-head",
				children: [/* @__PURE__ */ V("span", { children: [
					"#",
					t + 1,
					" ",
					e.purpose || ""
				] }), /* @__PURE__ */ B("small", { children: d.join(" · ") })]
			}),
			/* @__PURE__ */ B("pre", {
				className: "nb-q",
				children: e.query
			}),
			(((i = e.scope) == null || (i = i.options) == null ? void 0 : i.length) || ((a = e.scope) == null ? void 0 : a.where) || ((o = e.scope) == null ? void 0 : o.clientId) != null || ((s = e.scope) == null ? void 0 : s.warehouseId) != null) && /* @__PURE__ */ B("div", {
				className: "nb-q-scope",
				children: [
					(c = e.scope.options) != null && c.length ? l("report.scopeOptions", { options: e.scope.options.join(", ") }) : null,
					e.scope.where ? l("report.scopeWhere", { where: e.scope.where }) : null,
					e.scope.clientId == null ? null : l("chat.scopeClient", { code: String(e.scope.clientId) }),
					e.scope.warehouseId == null ? null : l("chat.scopeWarehouse", { code: String(e.scope.warehouseId) })
				].filter(Boolean).join(" · ")
			}),
			e.status === 200 && u ? /* @__PURE__ */ B(Qn, {
				rows: u,
				maxRows: 200
			}) : e.error ? /* @__PURE__ */ B("div", {
				className: "nb-error",
				children: e.error
			}) : null,
			/* @__PURE__ */ V("div", {
				className: "nb-actions",
				children: [u && u.length > 0 && /* @__PURE__ */ B("button", {
					type: "button",
					onClick: () => zt(u, `query-${t + 1}`),
					children: l("report.downloadCsv")
				}), /* @__PURE__ */ B("button", {
					type: "button",
					onClick: () => Bt(e.query),
					children: l("report.copyQuery")
				})]
			})
		]
	});
}
var na = (e) => e === "search_docs" || e === "search_config_tool";
function ra({ tc: e, highlight: t }) {
	var n;
	let { t: r } = C(), i = (n = ea(e.rows)) == null ? ea(e.hits) : n, a = typeof e.args == "string" ? e.args : JSON.stringify(e.args, null, 2);
	return /* @__PURE__ */ V("div", {
		className: `nb-card${t ? " nb-highlight" : ""}`,
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-card-head",
				children: [/* @__PURE__ */ B("span", { children: e.tool }), /* @__PURE__ */ B("small", { children: [
					e.frame == null ? null : r("report.frame", { n: e.frame }),
					e.error ? r("report.failed") : e.summary || null,
					e.ms == null ? null : `${e.ms} ms`
				].filter(Boolean).join(" · ") })]
			}),
			/* @__PURE__ */ B("pre", {
				className: "nb-q",
				children: a
			}),
			e.error ? /* @__PURE__ */ B("div", {
				className: "nb-error",
				children: e.error
			}) : na(e.tool) && i ? /* @__PURE__ */ B("div", {
				className: "nb-docs",
				children: i.map((e, t) => {
					var n, r, i, a;
					let o = String((n = e.url) == null ? "" : n), s = String((r = e.title) == null ? o : r), c = String((i = e.source) == null ? "" : i), l = String((a = e.type) == null ? "" : a);
					return /* @__PURE__ */ V("details", { children: [/* @__PURE__ */ V("summary", { children: [
						o ? /* @__PURE__ */ B("a", {
							href: o,
							target: "_blank",
							rel: "noopener noreferrer",
							children: s
						}) : /* @__PURE__ */ B("span", { children: s }),
						c && /* @__PURE__ */ V("span", {
							style: { color: "var(--nb-muted)" },
							children: [" · ", c]
						}),
						l && /* @__PURE__ */ V("span", {
							className: "nb-doc-type",
							children: [" · ", l]
						}),
						e.distance != null && /* @__PURE__ */ V("span", {
							style: { color: "var(--nb-muted)" },
							children: [" · distance ", String(e.distance)]
						})
					] }), e.excerpt != null && /* @__PURE__ */ B("pre", {
						className: "nb-dict",
						children: String(e.excerpt)
					})] }, t);
				})
			}) : i ? /* @__PURE__ */ B(Qn, {
				rows: i,
				maxRows: 200
			}) : null,
			i && i.length > 0 && !na(e.tool) && /* @__PURE__ */ B("div", {
				className: "nb-actions",
				children: /* @__PURE__ */ B("button", {
					type: "button",
					onClick: () => zt(i, e.tool),
					children: r("report.downloadCsv")
				})
			})
		]
	});
}
function ia({ a: e }) {
	var t;
	let { t: n } = C(), r = ea(e.output);
	return /* @__PURE__ */ V("div", {
		className: "nb-card",
		children: [
			/* @__PURE__ */ V("div", {
				className: "nb-card-head",
				children: [/* @__PURE__ */ B("span", { children: n("report.analysis") }), /* @__PURE__ */ B("small", { children: [
					e.frame == null ? null : n("report.frame", { n: e.frame }),
					e.error ? n("report.failed") : e.kind,
					r ? n("report.rows", { count: (t = e.rows) == null ? r.length : t }) : null,
					e.attempts && e.attempts > 1 ? n("report.run", { n: e.attempts }) : null
				].filter(Boolean).join(" · ") })]
			}),
			/* @__PURE__ */ V("details", { children: [/* @__PURE__ */ B("summary", { children: n("report.codeLines", { n: (e.code || "").split("\n").length }) }), /* @__PURE__ */ B("pre", {
				className: "nb-code",
				children: e.code
			})] }),
			e.error ? /* @__PURE__ */ B("div", {
				className: "nb-error",
				children: e.error
			}) : e.kind === "table" && r ? /* @__PURE__ */ B(Qn, {
				rows: r,
				maxRows: 200
			}) : e.output === void 0 ? null : /* @__PURE__ */ B("pre", {
				className: "nb-dict",
				children: typeof e.output == "string" ? e.output : JSON.stringify(e.output, null, 2)
			}),
			e.stdout && /* @__PURE__ */ B("div", {
				className: "nb-stdout",
				children: e.stdout
			}),
			r && r.length > 0 && /* @__PURE__ */ B("div", {
				className: "nb-actions",
				children: /* @__PURE__ */ B("button", {
					type: "button",
					onClick: () => zt(r, "analysis"),
					children: n("report.downloadCsv")
				})
			})
		]
	});
}
function aa({ result: e, debug: t, showRawData: n, messageId: r, client: i, onOpenEntity: a }) {
	var o, s, c, l, u, d;
	let { t: f } = C(), p = (o = e.queries) == null ? [] : o, m = (s = e.toolCalls) == null ? [] : s;
	if (!p.length && !m.length && !e.analysis && !(t && (c = e.log) != null && c.length)) return null;
	let h = new Set((l = e.showFrames) == null ? [] : l), g = [p.length === 1 ? f("chat.query") : f("chat.queries", { n: p.length })];
	return m.length && g.push(m.length === 1 ? f("chat.lookup") : f("chat.lookups", { n: m.length })), e.analysis && g.push(f("report.pythonAnalysis")), /* @__PURE__ */ V("details", {
		className: "nb-evidence",
		children: [
			/* @__PURE__ */ V("summary", { children: [
				f("report.dataBehind"),
				" · ",
				g.join(" · ")
			] }),
			m.map((e, t) => /* @__PURE__ */ B(ra, {
				tc: e,
				highlight: h.size > 0 && e.frame != null && h.has(e.frame)
			}, `t${t}`)),
			e.analysis && /* @__PURE__ */ B(ia, { a: e.analysis }),
			p.map((e, t) => /* @__PURE__ */ B(ta, {
				q: e,
				index: t,
				highlight: h.size > 0 && e.frame != null && h.has(e.frame)
			}, `q${t}`)),
			n && i && r && [...p.map((e, t) => ({
				frame: e.frame,
				title: e.purpose || `#${t + 1}`,
				rows: e.rows
			})), ...((u = e.analysis) == null ? void 0 : u.frame) == null ? [] : [{
				frame: e.analysis.frame,
				title: f("report.analysis"),
				rows: (d = ea(e.analysis.output)) == null ? void 0 : d
			}]].filter((e) => e.frame != null).map((e) => /* @__PURE__ */ B($i, {
				client: i,
				messageId: r,
				frame: e.frame,
				title: e.title,
				initialRows: e.rows,
				onOpenEntity: a
			}, `f${e.frame}`)),
			t && e.log && e.log.length > 0 && /* @__PURE__ */ B("pre", {
				className: "nb-debug",
				children: e.log.join("\n")
			})
		]
	});
}
// src/chat/DebugPanel.tsx
var oa = [
	"notes",
	"summary",
	"digests",
	"frames"
];
function sa({ usage: e, nyce: t, weightedTokens: n, model: r, thinking: i, steps: a, elapsedMs: o, timings: s, log: c }) {
	var l, u, f, p, m, h, g;
	let { t: _ } = C();
	if (!e && !(c != null && c.length)) return null;
	let v = e == null ? void 0 : e.context, y = v ? Math.max(v.total, oa.reduce((e, t) => e + (v[t] || 0), 0)) : 0, b = v != null && v.budget && v.budget > 0 ? v.budget : y;
	return /* @__PURE__ */ V("details", {
		className: "nb-debug-panel",
		children: [
			/* @__PURE__ */ V("summary", { children: [
				_("debug.title"),
				r && /* @__PURE__ */ V("span", {
					className: "nb-debug-meta",
					children: [" · ", r]
				}),
				i && /* @__PURE__ */ V("span", {
					className: "nb-debug-meta",
					children: [" · ", i]
				}),
				a != null && /* @__PURE__ */ V("span", {
					className: "nb-debug-meta",
					children: [" · ", _("chat.steps", { n: a })]
				}),
				o != null && /* @__PURE__ */ V("span", {
					className: "nb-debug-meta",
					children: [" · ", _("chat.elapsed", { s: (o / 1e3).toFixed(1) })]
				}),
				s && /* @__PURE__ */ V("span", {
					className: "nb-debug-meta",
					children: [
						" ",
						"· setup ",
						(s.setupMs / 1e3).toFixed(1),
						" s · engine ",
						(s.engineMs / 1e3).toFixed(1),
						" s · finish ",
						(s.finishMs / 1e3).toFixed(1),
						" s"
					]
				})
			] }),
			e && /* @__PURE__ */ V("div", {
				className: "nb-tablewrap",
				children: [/* @__PURE__ */ V("table", {
					className: "nb-table nb-debug-table",
					children: [/* @__PURE__ */ B("thead", { children: /* @__PURE__ */ V("tr", { children: [
						/* @__PURE__ */ B("th", { children: _("debug.step") }),
						/* @__PURE__ */ B("th", { children: _("debug.model") }),
						/* @__PURE__ */ B("th", {
							className: "nb-num",
							children: _("debug.prompt")
						}),
						/* @__PURE__ */ B("th", {
							className: "nb-num",
							children: _("debug.cached")
						}),
						/* @__PURE__ */ B("th", {
							className: "nb-num",
							children: _("debug.fresh")
						}),
						/* @__PURE__ */ B("th", {
							className: "nb-num",
							children: _("debug.output")
						}),
						/* @__PURE__ */ B("th", {
							className: "nb-num",
							children: _("debug.thoughts")
						}),
						/* @__PURE__ */ B("th", { children: _("debug.cacheMode") }),
						/* @__PURE__ */ B("th", {
							className: "nb-num",
							children: _("debug.ms")
						})
					] }) }), /* @__PURE__ */ V("tbody", { children: [((l = e.steps) == null ? [] : l).map((e) => {
						var t, n, r, i;
						return /* @__PURE__ */ V("tr", { children: [
							/* @__PURE__ */ B("td", { children: e.step }),
							/* @__PURE__ */ B("td", { children: (t = (n = e.tool) == null ? e.model : n) == null ? "" : t }),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.prompt)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.cached)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d((r = e.fresh) == null ? Math.max(0, e.prompt - e.cached) : r)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.output)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.thoughts)
							}),
							/* @__PURE__ */ B("td", { children: (i = e.cacheMode) == null ? "" : i }),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: e.ms == null ? "" : d(e.ms)
							})
						] }, e.step);
					}), /* @__PURE__ */ V("tr", {
						className: "nb-debug-total",
						children: [
							/* @__PURE__ */ B("td", { children: "Σ" }),
							/* @__PURE__ */ B("td", { children: _("debug.calls", { n: e.calls }) }),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.prompt)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.cached)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d((u = e.fresh) == null ? Math.max(0, e.prompt - e.cached) : u)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.output)
							}),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d(e.thoughts)
							}),
							/* @__PURE__ */ B("td", { children: (f = e.cacheMode) == null ? "" : f }),
							/* @__PURE__ */ B("td", {
								className: "nb-num",
								children: d((p = (m = t == null ? void 0 : t.total) == null ? n : m) == null ? 0 : p)
							})
						]
					})] })]
				}), (t || n != null) && /* @__PURE__ */ V("div", {
					className: "nb-debug-nyce",
					children: [_("debug.nyceTokens", { n: d((h = (g = t == null ? void 0 : t.total) == null ? n : g) == null ? 0 : h) }), t && /* @__PURE__ */ V("span", {
						className: "nb-debug-meta",
						children: [
							" ",
							"· ",
							_("usage.inputTokens"),
							" ",
							d(t.input),
							" · ",
							_("usage.cachedTokens"),
							" ",
							d(t.cached),
							" ",
							"· ",
							_("usage.outputTokens"),
							" ",
							d(t.output),
							" · ",
							_("usage.thinkingTokens"),
							" ",
							d(t.thoughts)
						]
					})]
				})]
			}),
			v && /* @__PURE__ */ V("div", {
				className: "nb-context",
				"data-testid": "context-budget",
				children: [
					/* @__PURE__ */ V("div", {
						className: "nb-eyebrow",
						children: [_("debug.context"), /* @__PURE__ */ B("span", { children: _("debug.contextUsed", {
							used: d(y),
							budget: d(b)
						}) })]
					}),
					/* @__PURE__ */ B("div", {
						className: "nb-context-bar",
						role: "img",
						"aria-label": _("debug.context"),
						children: oa.map((e) => v[e] > 0 ? /* @__PURE__ */ B("span", {
							className: `nb-context-part nb-context-${e}`,
							style: { width: `${(v[e] / b * 100).toFixed(2)}%` },
							title: `${_(`debug.${e}`)}: ${d(v[e])}`
						}, e) : null)
					}),
					/* @__PURE__ */ B("div", {
						className: "nb-legend",
						children: oa.map((e) => /* @__PURE__ */ V("span", { children: [
							/* @__PURE__ */ B("i", { className: `nb-context-${e}` }),
							_(`debug.${e}`),
							" ",
							d(v[e])
						] }, e))
					}),
					v.dropped.length > 0 && /* @__PURE__ */ V("div", {
						className: "nb-hint",
						children: [
							_("debug.dropped"),
							": ",
							v.dropped.join(", ")
						]
					})
				]
			}),
			c && c.length > 0 && /* @__PURE__ */ B("pre", {
				className: "nb-debug",
				children: c.join("\n")
			})
		]
	});
}
// src/chat/FeedbackBar.tsx
function ca({ messageId: e, value: t, disabled: r, onSubmit: i }) {
	let { t: a } = C(), [o, s] = R(null), [c, l] = R(""), [u, d] = R(!1), p = async (e, t) => {
		d(!0);
		try {
			await i(e, (t == null ? void 0 : t.trim()) || void 0), s(null), l("");
		} finally {
			d(!1);
		}
	};
	return /* @__PURE__ */ V("span", {
		className: "nb-feedback",
		"data-message-id": e,
		children: [
			/* @__PURE__ */ B(n, {
				label: a("feedback.up"),
				active: t === "up",
				disabled: r || u,
				onClick: () => void p("up"),
				children: /* @__PURE__ */ B(Re, { size: 14 })
			}),
			/* @__PURE__ */ B(n, {
				label: a("feedback.down"),
				active: t === "down",
				disabled: r || u,
				onClick: () => s("down"),
				children: /* @__PURE__ */ B(Le, { size: 14 })
			}),
			/* @__PURE__ */ V(h, {
				open: o !== null,
				onClose: () => s(null),
				title: a("feedback.commentTitle"),
				closeLabel: a("common.close"),
				maxWidth: 480,
				footer: /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(f, {
					variant: "ghost",
					onClick: () => s(null),
					disabled: u,
					children: a("common.cancel")
				}), /* @__PURE__ */ B(f, {
					onClick: () => o && void p(o, c),
					loading: u,
					children: a("feedback.send")
				})] }),
				children: [/* @__PURE__ */ B("p", {
					className: "nb-settings-desc",
					children: a("feedback.commentHelp")
				}), /* @__PURE__ */ B("textarea", {
					className: "nb-textarea",
					"aria-label": a("feedback.comment"),
					value: c,
					onChange: (e) => l(e.target.value),
					placeholder: a("feedback.commentPlaceholder"),
					rows: 4
				})]
			})
		]
	});
}
// src/chat/Messages.tsx
var la = (e) => {
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? "" : t.toLocaleTimeString([], {
		hour: "2-digit",
		minute: "2-digit"
	});
};
function ua(e) {
	return e >= 1e6 ? `${(e / 1e6).toFixed(1)}M` : e >= 1e3 ? `${(e / 1e3).toFixed(1)}k` : e.toLocaleString();
}
function da({ message: e, onReuse: t }) {
	var n;
	let { t: r } = C();
	return /* @__PURE__ */ V("div", {
		className: "nb-message nb-message-user",
		children: [/* @__PURE__ */ B("div", {
			className: "nb-avatar",
			"aria-hidden": "true",
			children: r("chat.you").slice(0, 1)
		}), /* @__PURE__ */ V("div", {
			className: "nb-message-content",
			children: [
				/* @__PURE__ */ B("div", {
					className: "nb-bubble",
					onClick: t ? () => t(e.text) : void 0,
					title: t ? r("chat.reuseQuestion") : void 0,
					children: e.text
				}),
				(n = e.attachments) != null && n.length ? /* @__PURE__ */ B(Qi, {
					files: e.attachments,
					className: "nb-message-attachments"
				}) : null,
				/* @__PURE__ */ B("div", {
					className: "nb-time",
					children: la(e.timestamp)
				})
			]
		})]
	});
}
function fa({ message: e, isLatest: t, clarificationAnswer: n, onClarificationSubmit: r, onSaveResponse: i, onFeedback: a, exportPdf: o, onExported: s, onSchedule: c, scheduledIds: l, onCreateAgent: u, agentIds: d }) {
	var f, p, m, h, g, _, v;
	let { t: y } = C(), { features: b, debug: x, onOpenEntity: S, client: w, showRawData: T } = Pi(), E = e.result, D = e.report, [O, k] = R(!1), A = (f = E == null || (p = E.nyceTokens) == null ? void 0 : p.total) == null ? E == null ? void 0 : E.weightedTokens : f, j = [];
	(E == null ? void 0 : E.elapsedMs) != null && j.push(y("chat.elapsed", { s: (E.elapsedMs / 1e3).toFixed(1) }));
	let M = [];
	E != null && E.steps && M.push(y("chat.steps", { n: E.steps })), E != null && (m = E.queries) != null && m.length && M.push(E.queries.length === 1 ? y("chat.query") : y("chat.queries", { n: E.queries.length })), E != null && E.thinking && M.push(y("chat.thinkingLevel", { level: String(E.thinking).toLowerCase() })), A != null && M.push(y("chat.nyceTokens", { n: A.toLocaleString() })), E != null && E.model && M.push(E.model), x && E != null && E.tokenUsage && M.push(`in ${E.tokenUsage.prompt.toLocaleString()} · out ${E.tokenUsage.output.toLocaleString()}`);
	let N = [];
	return E != null && (h = E.scope) != null && (h = h.client) != null && h.code && N.push(y("chat.scopeClient", { code: E.scope.client.code })), E != null && (g = E.scope) != null && (g = g.warehouse) != null && g.code && N.push(y("chat.scopeWarehouse", { code: E.scope.warehouse.code })), !N.length && (E == null || (_ = E.scope) == null ? void 0 : _.mode) === "all" && N.push(y("chat.scopeAll")), N.length && M.push(N.join(" · ")), /* @__PURE__ */ V("div", {
		className: "nb-message nb-message-bot",
		"data-message-id": e.id,
		children: [/* @__PURE__ */ B("div", {
			className: "nb-avatar",
			children: /* @__PURE__ */ B("img", {
				src: zi.botIcon,
				alt: "",
				width: 22,
				height: 22
			})
		}), /* @__PURE__ */ V("div", {
			className: "nb-message-content",
			children: [
				/* @__PURE__ */ V("div", {
					className: "nb-bubble",
					children: [
						e.error ? /* @__PURE__ */ B("div", {
							className: "nb-bubble-error",
							children: e.error
						}) : null,
						e.text && !e.error && /* @__PURE__ */ B("div", { children: e.text }),
						D && /* @__PURE__ */ B(ni, {
							report: D,
							allowHtml: b.htmlRows,
							onOpenEntity: S,
							onClarificationSubmit: r ? (t) => r(t, e) : void 0,
							clarificationDisabled: !t,
							resolvedClarification: n
						}),
						E && /* @__PURE__ */ B(aa, {
							result: E,
							debug: x,
							showRawData: T,
							messageId: e.id,
							client: w,
							onOpenEntity: S
						}),
						x && E && /* @__PURE__ */ B(sa, {
							usage: E.tokenUsage,
							nyce: E.nyceTokens,
							weightedTokens: E.weightedTokens,
							model: E.model,
							thinking: E.thinking,
							steps: E.steps,
							elapsedMs: E.elapsedMs,
							timings: E.timings,
							log: E.log
						})
					]
				}),
				/* @__PURE__ */ V("div", {
					className: "nb-message-meta",
					children: [
						/* @__PURE__ */ B("span", { children: la(e.timestamp) }),
						j.map((e, t) => /* @__PURE__ */ B("span", { children: e }, t)),
						A != null && /* @__PURE__ */ B("span", {
							className: "nb-message-nyce",
							title: y("chat.nyceTokens", { n: A.toLocaleString() }),
							children: ua(A)
						}),
						M.length > 0 && /* @__PURE__ */ B("button", {
							type: "button",
							className: "nb-iconbtn nb-message-info",
							"aria-expanded": O,
							title: y("chat.details"),
							"aria-label": y("chat.details"),
							onClick: () => k((e) => !e),
							children: /* @__PURE__ */ B(Se, { size: 14 })
						}),
						/* @__PURE__ */ B(ki, {
							message: e,
							canSave: b.savedResponses && !!E && !e.error,
							canExportPdf: b.pdfExport && !!E && !e.error,
							onSave: i,
							exportPdf: o,
							onExported: s,
							canSchedule: b.scheduledReports && !!E && !e.error,
							onSchedule: c,
							canCreateAgent: !!b.responseAgents && !!(E != null && (v = E.queries) != null && v.length) && !e.error,
							onCreateAgent: u
						}),
						(l == null ? void 0 : l.has(e.id)) && /* @__PURE__ */ V("span", {
							className: "nb-scheduled-mark",
							"data-testid": "scheduled-mark",
							children: [
								/* @__PURE__ */ B(ce, { size: 12 }),
								" ",
								y("schedule.scheduledMark")
							]
						}),
						(d == null ? void 0 : d.has(e.id)) && /* @__PURE__ */ V("span", {
							className: "nb-scheduled-mark nb-agent-mark",
							"data-testid": "agent-mark",
							children: [
								/* @__PURE__ */ B(oe, { size: 12 }),
								" ",
								y("agent.mark")
							]
						}),
						b.feedback && E && !e.error && a && /* @__PURE__ */ B(ca, {
							messageId: e.id,
							value: e.feedback,
							onSubmit: (t, n) => a(e, t, n)
						})
					]
				}),
				O && M.length > 0 && /* @__PURE__ */ B("div", {
					className: "nb-message-details",
					children: M.join(" · ")
				})
			]
		})]
	});
}
function pa({ messages: t, onReuse: n, onClarificationSubmit: r, ...i }) {
	let { t: a } = C(), { theme: o } = e();
	if (!t.length) return /* @__PURE__ */ V("div", {
		className: "nb-welcome",
		children: [/* @__PURE__ */ B("img", {
			src: o === "light" ? zi.logoBlack : zi.logoWhite,
			alt: "nyceBuddy"
		}), /* @__PURE__ */ B("p", { children: a("chat.welcomeMessage") })]
	});
	let s = -1;
	for (let e = t.length - 1; e >= 0; e--) if (t[e].role === "assistant") {
		s = e;
		break;
	}
	return /* @__PURE__ */ B("div", {
		className: "nb-message-list",
		children: t.map((e, a) => {
			if (e.role === "user") return e.isClarificationResponse ? null : /* @__PURE__ */ B(da, {
				message: e,
				onReuse: n
			}, e.id);
			let o = t[a + 1], c = o && o.role === "user" && o.isClarificationResponse ? o.text : void 0;
			return /* @__PURE__ */ B(fa, {
				message: e,
				isLatest: a === s,
				clarificationAnswer: c,
				onClarificationSubmit: r,
				...i
			}, e.id);
		})
	});
}
// src/chat/ActivityList.tsx
function ma(e) {
	if (!e || typeof e != "object") return null;
	let t = e;
	return Array.isArray(t.sampleRows) ? e : t.output && Array.isArray(t.output.sampleRows) ? t.output : null;
}
function ha(e, t) {
	return e.nyceTokens == null ? t("chat.modelCallsPlain", { calls: e.calls }) : t("chat.modelCalls", {
		calls: e.calls,
		nyce: e.nyceTokens.toLocaleString()
	});
}
var ga = (e) => "items" in e, _a = (e) => {
	var t;
	return e.tool ? `${e.tool}:${(t = e.titleKey) == null ? e.title : t}` : null;
};
function va(e) {
	let t = [];
	for (let n of e) {
		let e = _a(n), r = t[t.length - 1];
		if (e && r) {
			if (ga(r) && r.key === e) {
				r.items.push(n);
				continue;
			}
			if (!ga(r) && _a(r) === e) {
				t[t.length - 1] = {
					id: `group:${r.id}`,
					key: e,
					items: [r, n]
				};
				continue;
			}
		}
		t.push(n);
	}
	return t;
}
function ya(e) {
	let t = (t) => e.some((e) => e.state === t);
	return t("running") ? "running" : t("failed") ? "failed" : t("interrupted") ? "interrupted" : "completed";
}
function ba({ activities: e, running: t, usage: n, now: r, status: i, elapsed: a, onCancel: o }) {
	let { t: s, has: c } = C(), l = L(null), [u, d] = R(() => /* @__PURE__ */ new Set()), f = (e) => d((t) => {
		let n = new Set(t);
		return n.has(e) ? n.delete(e) : n.add(e), n;
	});
	if (M(() => {
		let e = l.current;
		e && e.scrollHeight - e.scrollTop - e.clientHeight < 80 && (e.scrollTop = e.scrollHeight);
	}, [e.length, e]), !e.length && !i && !(t && o)) return null;
	let p = (e) => D(s, c, {
		titleKey: e.titleKey,
		stage: e.stage,
		state: e.state,
		tool: e.tool,
		message: e.title
	}), m = (e) => `${(Math.max(0, e) / 1e3).toFixed(1)} s`, h = (e) => {
		var t, n;
		return e.reused ? "" : m((t = e.duration) == null ? ((n = e.endedAt) == null ? r : n) - e.startedAt : t);
	}, g = (e) => {
		let t = e.filter((e) => !e.reused);
		if (!t.length) return "";
		let n = Math.min(...t.map((e) => e.startedAt)), i = Math.max(...t.map((e) => {
			var t;
			return (t = e.endedAt) == null ? r : t;
		}));
		return m(i - n);
	}, _ = (e, n = !1) => {
		var r, i, a, o, c, l, d, m, g, _;
		let v = ma((r = e.data) == null ? void 0 : r.preview), y = !!((i = e.data) != null && i.query || (a = e.data) != null && a.code || (o = e.data) != null && o.error || (c = e.data) != null && c.preview), b = e.detail || (e.state === "interrupted" && !t ? s("chat.stepStopped") : ""), x = y || b.length > 60, S = u.has(e.id), C = /* @__PURE__ */ V(z, { children: [
			/* @__PURE__ */ B("span", {
				className: "nb-step-title",
				children: p(e)
			}),
			/* @__PURE__ */ B("small", {
				className: "nb-step-time",
				children: h(e)
			}),
			b && !S && /* @__PURE__ */ B("span", {
				className: "nb-step-detail",
				title: b,
				children: b
			})
		] });
		return /* @__PURE__ */ V("li", {
			className: `nb-step nb-${e.state}${x ? " nb-step-expandable" : ""}${n ? " nb-step-nested" : ""}`,
			children: [x ? /* @__PURE__ */ B("button", {
				type: "button",
				className: "nb-step-toggle",
				"aria-expanded": S,
				onClick: () => f(e.id),
				children: /* @__PURE__ */ B(ue, {
					size: 12,
					className: "nb-step-chevron",
					"aria-hidden": "true"
				})
			}) : /* @__PURE__ */ B("span", {
				className: "nb-step-mark",
				"aria-hidden": "true"
			}), /* @__PURE__ */ V("div", {
				className: "nb-step-body",
				children: [x ? /* @__PURE__ */ B("button", {
					type: "button",
					className: "nb-step-line",
					onClick: () => f(e.id),
					children: C
				}) : /* @__PURE__ */ B("span", {
					className: "nb-step-line",
					children: C
				}), S && /* @__PURE__ */ V("div", {
					className: "nb-step-data",
					children: [
						b && /* @__PURE__ */ B("div", {
							className: "nb-step-detail-full",
							children: b
						}),
						((l = e.data) == null ? void 0 : l.query) && /* @__PURE__ */ B("pre", { children: e.data.query }),
						((d = e.data) == null ? void 0 : d.code) && /* @__PURE__ */ B("pre", { children: e.data.code }),
						((m = e.data) == null ? void 0 : m.error) && /* @__PURE__ */ B("pre", { children: e.data.error }),
						v ? /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", { children: s("chat.previewRows", {
							count: v.rowCount,
							shown: Math.min(5, v.sampleRows.length)
						}) }), /* @__PURE__ */ B(Qn, {
							rows: v.sampleRows.slice(0, 5).map((e) => Object.fromEntries(v.columns.map((t, n) => [t, e[n]]))),
							maxRows: 5
						})] }) : (g = e.data) != null && g.preview && !((_ = e.data) != null && _.error) ? /* @__PURE__ */ B("pre", { children: JSON.stringify(e.data.preview, null, 2) }) : null
					]
				})]
			})]
		}, e.id);
	}, v = (e) => {
		let t = u.has(e.id), n = ya(e.items), r = e.items.filter((e) => e.state === "failed").length;
		return /* @__PURE__ */ V("li", {
			className: `nb-step nb-${n} nb-step-expandable nb-step-group`,
			children: [/* @__PURE__ */ B("button", {
				type: "button",
				className: "nb-step-toggle",
				"aria-expanded": t,
				onClick: () => f(e.id),
				children: /* @__PURE__ */ B(ue, {
					size: 12,
					className: "nb-step-chevron",
					"aria-hidden": "true"
				})
			}), /* @__PURE__ */ V("div", {
				className: "nb-step-body",
				children: [/* @__PURE__ */ V("button", {
					type: "button",
					className: "nb-step-line",
					onClick: () => f(e.id),
					children: [
						/* @__PURE__ */ B("span", {
							className: "nb-step-title",
							children: p(e.items[0])
						}),
						/* @__PURE__ */ V("small", {
							className: "nb-step-count",
							children: [s(e.items[0].tool === "run_query" ? "chat.queries" : "chat.steps", { n: e.items.length }), r > 0 && ` · ${s("chat.stepsFailed", { n: r })}`]
						}),
						/* @__PURE__ */ B("small", {
							className: "nb-step-time",
							children: g(e.items)
						})
					]
				}), t && /* @__PURE__ */ B("ol", {
					className: "nb-steps nb-step-group-items",
					children: e.items.map((e) => _(e, !0))
				})]
			})]
		}, e.id);
	};
	return /* @__PURE__ */ V("div", {
		className: `nb-activity${t ? " nb-activity-running" : ""}`,
		children: [(e.length > 0 || i) && /* @__PURE__ */ V("ol", {
			className: "nb-steps",
			ref: l,
			children: [!e.length && i && /* @__PURE__ */ V("li", {
				className: "nb-step nb-running",
				children: [/* @__PURE__ */ B("span", {
					className: "nb-step-mark",
					"aria-hidden": "true"
				}), /* @__PURE__ */ B("span", {
					className: "nb-step-line",
					children: /* @__PURE__ */ B("span", {
						className: "nb-step-title",
						children: i
					})
				})]
			}), va(e).map((e) => ga(e) ? v(e) : _(e))]
		}), (o || n) && /* @__PURE__ */ V("div", {
			className: "nb-activity-foot",
			children: [
				n && /* @__PURE__ */ B("span", {
					className: "nb-activity-meta",
					children: ha(n, s)
				}),
				a && t && /* @__PURE__ */ B("span", {
					className: "nb-activity-elapsed nb-elapsed",
					children: s("chat.elapsed", { s: a })
				}),
				o && t && /* @__PURE__ */ V("button", {
					type: "button",
					className: "nb-cancel",
					onClick: o,
					title: s("chat.cancelRequest"),
					children: [
						/* @__PURE__ */ B(de, { size: 14 }),
						" ",
						s("chat.cancelRequest")
					]
				})
			]
		})]
	});
}
// src/chat/StreamingIndicator.tsx
function xa(e, t = 100) {
	let [n, r] = R(() => Date.now());
	return M(() => {
		if (!e) return;
		r(Date.now());
		let n = setInterval(() => r(Date.now()), t);
		return () => clearInterval(n);
	}, [e, t]), n;
}
function Sa({ state: e, onCancel: t, allowHtml: n }) {
	let { t: r, has: i } = C(), a = e.status === "queued" || e.status === "running" || e.status === "answering", o = xa(a), s = !!e.partial, c = L(null), [l, u] = R(0);
	if (P(() => {
		u(0);
	}, [e.startedAt]), P(() => {
		var e, t;
		let n = (e = (t = c.current) == null ? void 0 : t.offsetHeight) == null ? 0 : e;
		n > l && u(n);
	}), !a) return null;
	let d = e.current, f = e.connection === "reconnecting", p = f ? r("chat.reconnecting") : d ? D(r, i, {
		titleKey: d.titleKey,
		stage: d.stage,
		state: d.state,
		tool: d.tool,
		message: d.title
	}) : e.status === "queued" ? r("chat.connectingStatus") : r("chat.starting"), m = `${d != null && d.step && !f ? `#${d.step} · ` : ""}${p}`, h = e.startedAt ? ((o - e.startedAt) / 1e3).toFixed(1) : "0.0";
	return /* @__PURE__ */ V("div", {
		className: `nb-message nb-message-bot nb-typing${f ? " nb-reconnecting" : ""}`,
		"aria-busy": "true",
		"aria-live": "polite",
		children: [/* @__PURE__ */ B("div", {
			className: "nb-avatar",
			children: /* @__PURE__ */ B("img", {
				src: zi.botIconWhite,
				alt: "",
				className: "nb-logo-pulse"
			})
		}), /* @__PURE__ */ B("div", {
			className: "nb-message-content",
			children: /* @__PURE__ */ V("div", {
				className: "nb-bubble",
				ref: c,
				style: l ? { minHeight: l } : void 0,
				children: [
					/* @__PURE__ */ B(ba, {
						activities: s ? [] : e.activities,
						running: a,
						usage: s ? void 0 : e.usage,
						now: o,
						status: s ? void 0 : m,
						elapsed: h,
						onCancel: t
					}),
					e.partial && /* @__PURE__ */ B(ni, {
						report: e.partial,
						streaming: !0,
						allowHtml: n
					}),
					!e.partial && /* @__PURE__ */ V("div", {
						className: "nb-typing-dots",
						"aria-hidden": "true",
						children: [
							/* @__PURE__ */ B("span", {}),
							/* @__PURE__ */ B("span", {}),
							/* @__PURE__ */ B("span", {})
						]
					})
				]
			})
		})]
	});
}
// src/voice/recorder.ts
var Ca = 6e4;
function wa() {
	var e;
	if (typeof window > "u" || typeof navigator > "u" || !((e = navigator.mediaDevices) != null && e.getUserMedia) || typeof MediaRecorder > "u" || window.isSecureContext === !1) return !1;
	let t = document.featurePolicy;
	return !t || t.allowsFeature("microphone");
}
async function Ta() {
	var e;
	let t = await navigator.mediaDevices.getUserMedia({ audio: {
		echoCancellation: !0,
		noiseSuppression: !0,
		channelCount: 1
	} }), n = new MediaRecorder(t), r = [];
	n.ondataavailable = (e) => {
		e.data.size && r.push(e.data);
	};
	let i, a;
	try {
		i = new AudioContext(), a = i.createAnalyser(), a.fftSize = 512, i.createMediaStreamSource(t).connect(a);
	} catch {
		a = void 0;
	}
	let o = new Uint8Array((e = a == null ? void 0 : a.fftSize) == null ? 0 : e), s = () => {
		t.getTracks().forEach((e) => e.stop()), i == null || i.close().catch(() => void 0);
	};
	return n.start(), {
		stop: () => new Promise((e) => {
			n.state === "inactive" ? (s(), e(new Blob(r, { type: n.mimeType }))) : (n.onstop = () => {
				s(), e(new Blob(r, { type: n.mimeType }));
			}, n.stop());
		}),
		cancel: () => {
			n.onstop = null, n.state !== "inactive" && n.stop(), s();
		},
		level: () => {
			if (!a) return 0;
			a.getByteTimeDomainData(o);
			let e = 0;
			for (let t of o) e += ((t - 128) / 128) ** 2;
			return Math.min(1, Math.sqrt(e / o.length) * 4);
		}
	};
}
// src/voice/wav.ts
var Ea = 16e3;
function Da(e, t = Ea) {
	let n = /* @__PURE__ */ new ArrayBuffer(44 + e.length * 2), r = new DataView(n), i = (e, t) => {
		for (let n = 0; n < t.length; n++) r.setUint8(e + n, t.charCodeAt(n));
	};
	i(0, "RIFF"), r.setUint32(4, 36 + e.length * 2, !0), i(8, "WAVE"), i(12, "fmt "), r.setUint32(16, 16, !0), r.setUint16(20, 1, !0), r.setUint16(22, 1, !0), r.setUint32(24, t, !0), r.setUint32(28, t * 2, !0), r.setUint16(32, 2, !0), r.setUint16(34, 16, !0), i(36, "data"), r.setUint32(40, e.length * 2, !0);
	for (let t = 0; t < e.length; t++) {
		let n = Math.max(-1, Math.min(1, e[t]));
		r.setInt16(44 + t * 2, n < 0 ? n * 32768 : n * 32767, !0);
	}
	return n;
}
var Oa = () => {
	var e;
	return typeof window > "u" ? void 0 : (e = window.AudioContext) == null ? window.webkitAudioContext : e;
};
async function ka(e) {
	let t = Oa();
	if (!t || typeof OfflineAudioContext > "u") throw Error("audio decoding is not available");
	let n = new t();
	try {
		let t = await n.decodeAudioData(await e.arrayBuffer()), r = Math.max(1, Math.ceil(t.duration * Ea)), i = new OfflineAudioContext(1, r, Ea), a = i.createBufferSource();
		a.buffer = t, a.connect(i.destination), a.start();
		let o = await i.startRendering();
		return new Blob([Da(o.getChannelData(0))], { type: "audio/wav" });
	} finally {
		n.close();
	}
}
// src/voice/useDictation.ts
function Aa(e, t) {
	let [n, r] = R("idle"), [i, a] = R(null), [o, s] = R(0), c = L(null), l = L(void 0), u = L(void 0), d = L(!0);
	M(() => () => {
		var e;
		d.current = !1, (e = c.current) == null || e.cancel(), clearTimeout(l.current), u.current && cancelAnimationFrame(u.current);
	}, []);
	let f = A(async () => {
		let n = c.current;
		if (n) {
			c.current = null, clearTimeout(l.current), u.current && cancelAnimationFrame(u.current), s(0), r("transcribing");
			try {
				let r = await e(await ka(await n.stop()));
				if (!d.current) return;
				r.text.trim() ? t(r) : a("empty");
			} catch (e) {
				d.current && a((e == null ? void 0 : e.code) === "limit_exceeded" ? "limit" : "failed");
			} finally {
				d.current && r("idle");
			}
		}
	}, [e, t]), p = A(async () => {
		if (c.current || n !== "idle") return;
		a(null);
		try {
			c.current = await Ta();
		} catch (e) {
			let t = e == null ? void 0 : e.name;
			a(t === "NotFoundError" || t === "OverconstrainedError" ? "noMicrophone" : t === "NotAllowedError" || t === "SecurityError" ? "denied" : "failed");
			return;
		}
		r("recording"), l.current = setTimeout(() => void f(), Ca);
		let e = () => {
			var t, n;
			s((t = (n = c.current) == null ? void 0 : n.level()) == null ? 0 : t), u.current = requestAnimationFrame(e);
		};
		u.current = requestAnimationFrame(e);
	}, [n, f]), m = A(() => {
		var e;
		(e = c.current) == null || e.cancel(), c.current = null, clearTimeout(l.current), u.current && cancelAnimationFrame(u.current), s(0), r("idle");
	}, []);
	return {
		state: n,
		error: i,
		level: o,
		toggle: A(() => n === "recording" ? void f() : void p(), [
			n,
			p,
			f
		]),
		cancel: m,
		clearError: () => a(null)
	};
}
// src/chat/Composer.tsx
var ja = [
	{
		level: "normal",
		icon: /* @__PURE__ */ B(He, { size: 18 }),
		key: "chat.thinkingNormal"
	},
	{
		level: "high",
		icon: /* @__PURE__ */ B(se, { size: 18 }),
		key: "chat.thinkingHigh"
	},
	{
		level: "expert",
		icon: /* @__PURE__ */ B(Pe, { size: 18 }),
		key: "chat.thinkingExpert"
	}
];
function Ma({ value: e, onChange: t, disabled: n }) {
	var r;
	let { t: i } = C(), [a, o] = R(!1), s = L(null);
	M(() => {
		if (!a) return;
		let e = (e) => {
			s.current && !s.current.contains(e.target) && o(!1);
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, [a]);
	let c = (r = ja.find((t) => t.level === e)) == null ? ja[0] : r;
	return /* @__PURE__ */ V("div", {
		className: "nb-thinking",
		ref: s,
		children: [/* @__PURE__ */ B("button", {
			type: "button",
			className: `nb-thinking-btn nb-${e}`,
			title: i(c.key),
			"aria-label": i(c.key),
			disabled: n,
			onClick: () => o((e) => !e),
			children: c.icon
		}), a && /* @__PURE__ */ B("div", {
			className: "nb-thinking-picker",
			role: "menu",
			children: ja.map((n) => /* @__PURE__ */ B("button", {
				type: "button",
				role: "menuitemradio",
				"aria-checked": n.level === e,
				className: `nb-thinking-opt nb-${n.level}${n.level === e ? " nb-selected" : ""}`,
				title: i(n.key),
				onClick: () => {
					t(n.level), o(!1);
				},
				children: n.icon
			}, n.level))
		})]
	});
}
function Na(e) {
	var t, n;
	let r = (t = e == null ? void 0 : e.scope) == null ? e == null || (n = e.scopes) == null || (n = n.find((e) => e.isExceeded)) == null ? void 0 : n.scope : t;
	return r === "organization" ? "chat.limitScopeOrganization" : r === "tenant" ? "chat.limitScopeTenant" : r === "system" ? "chat.limitScopeSystem" : "chat.tokenLimitReached";
}
function Pa({ status: e }) {
	var t;
	let { t: n } = C();
	if (!(e != null && e.isExceeded)) return null;
	let r = e.resetDate;
	try {
		r = new Date(e.resetDate).toLocaleDateString();
	} catch {}
	let i = Na(e), a = i !== "chat.tokenLimitReached";
	return /* @__PURE__ */ V("div", {
		className: "nb-limit-banner",
		role: "alert",
		"data-limit-scope": (t = e.scope) == null ? void 0 : t,
		children: [/* @__PURE__ */ B("span", { children: "⚠️" }), /* @__PURE__ */ B("span", { children: a ? n("chat.tokenLimitBannerScoped", {
			title: n(i),
			days: e.daysUntilReset,
			date: r
		}) : n("chat.tokenLimitBanner", {
			days: e.daysUntilReset,
			date: r
		}) })]
	});
}
function Fa(e, t) {
	switch (t.code) {
		case "unsupported_file": return e("attachments.unsupported", { name: t.fileName });
		case "file_too_large": return e("attachments.tooLarge", {
			name: t.fileName,
			max: t.maxMb
		});
		case "too_many_files": return e("attachments.tooManyFiles", { max: t.max });
		case "too_many_images": return e("attachments.tooManyImages", { max: t.max });
	}
}
var Ia = k(function(e, t) {
	var n;
	let { t: r } = C(), { onSend: i, onNewConversation: a, busy: o, disabled: s, limitStatus: c, showThinkingPicker: l = !0, thinking: u, onThinkingChange: d, draft: f, draftKey: p, onDraftChange: m, onUpload: h, contextChip: g, onTranscribe: _, handsFree: v } = e, y = !!v && v.mode !== "off", [b, x] = R(f == null ? "" : f), S = L(null), w = L(null), [T, E] = R([]), [D, O] = R([]), [k, A] = R(null), [j, P] = R(!1), F = !!s || !!(c != null && c.isExceeded), I = !!h && !o && !F, H = L(void 0), U = L(async () => ({
		text: "",
		seconds: 0,
		ms: 0
	})), W = Aa(_ == null ? U.current : _, (e) => {
		var t;
		H.current = (t = e.usageId) == null ? void 0 : t, x((t) => {
			let n = t.trim() ? `${t.trimEnd()} ${e.text}` : e.text;
			return m == null || m(n), n;
		}), requestAnimationFrame(() => {
			var e;
			return (e = S.current) == null ? void 0 : e.focus();
		});
	}), G = async (e) => {
		if (!h || !e.length) return;
		A(null);
		let { accepted: t, rejected: n } = Ji(e, T);
		if (n.length && A(n.map((e) => Fa(r, e)).join(" ")), !t.length) return;
		let i = t.map((e) => e.name);
		O((e) => [...e, ...i]);
		try {
			let e = await h(t);
			E((t) => [...t, ...e].slice(0, Ui.maxFiles));
		} catch (e) {
			let t = e == null ? void 0 : e.code, n = t ? `attachments.${t}` : "", i = n ? r(n) : "";
			A(i && i !== n ? i : (e == null ? void 0 : e.message) || r("attachments.uploadFailed"));
		} finally {
			O((e) => e.filter((e) => !i.includes(e)));
		}
	}, K = (e) => {
		e != null && e.length && G(Array.from(e)), w.current && (w.current.value = "");
	};
	M(() => {
		if (f !== void 0 && p !== void 0) {
			var e;
			x(f), (e = S.current) == null || e.focus();
		}
	}, [f, p]), M(() => {
		let e = S.current;
		if (!e) return;
		e.style.height = "auto";
		let t = Number.parseFloat(window.getComputedStyle(e).maxHeight) || e.scrollHeight;
		e.style.height = `${Math.min(e.scrollHeight, t)}px`, e.style.overflowY = e.scrollHeight > t ? "auto" : "hidden";
	}, [b]), M(() => {
		var e;
		o || (e = S.current) == null || e.focus();
	}, [o]), N(t, () => ({
		focus: () => {
			var e;
			return (e = S.current) == null ? void 0 : e.focus();
		},
		setText: x
	}), []);
	let q = () => {
		let e = b.trim();
		!e || o || F || D.length || (H.current === void 0 ? i(e, u, T) : i(e, u, T, { usageId: H.current }), H.current = void 0, x(""), E([]), A(null), m == null || m(""), S.current && (S.current.style.height = "auto", S.current.style.overflowY = "hidden"), requestAnimationFrame(() => {
			var e;
			return (e = S.current) == null ? void 0 : e.focus();
		}));
	};
	return /* @__PURE__ */ V("div", {
		className: "nb-composer",
		children: [
			/* @__PURE__ */ B(Pa, { status: c }),
			/* @__PURE__ */ V("form", {
				className: "nb-composer-form",
				onSubmit: (e) => {
					e.preventDefault(), q();
				},
				onDragOver: I ? (e) => e.preventDefault() : void 0,
				onDragEnter: I ? () => P(!0) : void 0,
				onDragLeave: I ? (e) => {
					e.currentTarget.contains(e.relatedTarget) || P(!1);
				} : void 0,
				onDrop: I ? (e) => {
					var t, n;
					e.preventDefault(), P(!1), K((t = (n = e.dataTransfer) == null ? void 0 : n.files) == null ? null : t);
				} : void 0,
				"data-dragging": j ? "true" : void 0,
				children: [
					j && /* @__PURE__ */ B("div", {
						className: "nb-drop-hint",
						children: r("attachments.dropHint")
					}),
					g,
					/* @__PURE__ */ B(Qi, {
						files: T,
						pending: D,
						onRemove: (e) => E((t) => t.filter((t) => t.id !== e)),
						className: "nb-composer-attachments"
					}),
					y && /* @__PURE__ */ V("div", {
						className: "nb-handsfree-status",
						role: "status",
						"aria-live": "polite",
						"data-mode": v.mode,
						children: [/* @__PURE__ */ B("span", {
							className: "nb-handsfree-dot",
							"aria-hidden": "true"
						}), r(`voice.hf${v.mode[0].toUpperCase()}${v.mode.slice(1)}`)]
					}),
					(W.error || (v == null ? void 0 : v.error)) && /* @__PURE__ */ B("div", {
						className: "nb-composer-file-error nb-voice-error",
						role: "alert",
						children: r(`voice.${(n = W.error) == null ? v == null ? void 0 : v.error : n}`)
					}),
					k && /* @__PURE__ */ B("div", {
						className: "nb-composer-file-error",
						role: "alert",
						children: k
					}),
					/* @__PURE__ */ V("div", {
						className: "nb-input-container",
						children: [
							l && /* @__PURE__ */ B(Ma, {
								value: u,
								onChange: d,
								disabled: o
							}),
							h && /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("input", {
								ref: w,
								type: "file",
								className: "nb-file-input",
								multiple: !0,
								accept: ".png,.jpg,.jpeg,.webp,.gif,.pdf,.csv,.tsv,.xlsx,.xlsm,.xls,.txt,.md,.log,.json,.xml,.yaml,.yml,.html,.htm,.sql",
								hidden: !0,
								"aria-hidden": "true",
								tabIndex: -1,
								onChange: (e) => K(e.target.files)
							}), /* @__PURE__ */ B("button", {
								type: "button",
								className: "nb-attach",
								"aria-label": r("attachments.attach"),
								title: r("attachments.attach"),
								onClick: () => {
									var e;
									return (e = w.current) == null ? void 0 : e.click();
								},
								disabled: !I || T.length >= Ui.maxFiles,
								children: /* @__PURE__ */ B(Z, { size: 20 })
							})] }),
							/* @__PURE__ */ B("textarea", {
								ref: S,
								className: "nb-composer-input",
								value: b,
								rows: 1,
								placeholder: c != null && c.isExceeded ? r(Na(c)) : r("chat.inputPlaceholder"),
								disabled: o || F,
								onChange: (e) => {
									e.target.value.trim() || (H.current = void 0), x(e.target.value), m == null || m(e.target.value);
								},
								onPaste: I ? (e) => {
									var t, n;
									let r = Array.from((t = (n = e.clipboardData) == null ? void 0 : n.files) == null ? [] : t);
									r.length && (e.preventDefault(), G(r));
								} : void 0,
								onKeyDown: (e) => {
									e.key === "Escape" && W.state === "recording" ? (e.preventDefault(), W.cancel()) : e.key === "Enter" && !e.shiftKey && (e.preventDefault(), q());
								}
							}),
							_ && /* @__PURE__ */ B("button", {
								type: "button",
								className: "nb-mic",
								"data-state": W.state,
								"aria-pressed": W.state === "recording",
								"aria-label": r(W.state === "recording" ? "voice.stop" : W.state === "transcribing" ? "voice.transcribing" : "voice.dictate"),
								title: r(W.state === "recording" ? "voice.stop" : W.state === "transcribing" ? "voice.transcribing" : "voice.dictate"),
								style: { "--nb-mic-level": W.level.toFixed(2) },
								onClick: () => {
									xi(), W.toggle();
								},
								disabled: y || W.state === "transcribing" || W.state === "idle" && (o || F),
								children: W.state === "recording" ? /* @__PURE__ */ B(Fe, { size: 16 }) : W.state === "transcribing" ? /* @__PURE__ */ B(X, {
									size: 20,
									className: "nb-spin"
								}) : /* @__PURE__ */ B(Te, { size: 20 })
							}),
							v && /* @__PURE__ */ B("button", {
								type: "button",
								className: "nb-handsfree",
								"data-mode": v.mode,
								"aria-pressed": y,
								"aria-label": r(y ? "voice.handsFreeOff" : "voice.handsFree"),
								title: r(y ? "voice.handsFreeOff" : "voice.handsFree"),
								onClick: v.toggle,
								disabled: !y && (W.state !== "idle" || F),
								children: /* @__PURE__ */ B(ye, { size: 20 })
							}),
							/* @__PURE__ */ B("button", {
								type: "submit",
								className: "nb-send",
								"aria-label": r("chat.send"),
								title: r("chat.send"),
								disabled: !b.trim() || o || F || D.length > 0,
								children: /* @__PURE__ */ B(je, { size: 20 })
							}),
							a && /* @__PURE__ */ B("button", {
								type: "button",
								className: "nb-new",
								"aria-label": r("chat.newConversation"),
								title: r("chat.newConversation"),
								onClick: a,
								disabled: o,
								children: /* @__PURE__ */ B(ke, { size: 20 })
							})
						]
					})
				]
			}),
			/* @__PURE__ */ B("p", {
				className: "nb-disclaimer",
				children: r("chat.aiDisclaimer")
			})
		]
	});
});
// src/chat/FormContextChip.tsx
function La(e) {
	var t;
	let n = ((t = e.label) == null ? void 0 : t.trim()) || (e.id != null && e.id !== "" ? `#${e.id}` : "");
	return n ? `${e.entity} · ${n}` : e.entity;
}
function Ra({ form: e, on: t, onToggle: n }) {
	let { t: r } = C(), i = La(e);
	return /* @__PURE__ */ B("div", {
		className: "nb-form-context",
		"data-on": t ? "true" : "false",
		children: /* @__PURE__ */ V("button", {
			type: "button",
			className: "nb-form-context-btn",
			"aria-pressed": t,
			title: r(t ? "chat.formContextOn" : "chat.formContextOff", { what: i }),
			onClick: () => n(!t),
			children: [
				/* @__PURE__ */ B(ve, {
					size: 14,
					"aria-hidden": "true"
				}),
				/* @__PURE__ */ B("span", {
					className: "nb-form-context-label",
					children: i
				}),
				t ? /* @__PURE__ */ B(Ve, {
					size: 12,
					"aria-hidden": "true",
					className: "nb-form-context-x"
				}) : /* @__PURE__ */ B("span", {
					className: "nb-form-context-state",
					children: r("chat.formContextDisabled")
				})
			]
		})
	});
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/typeof.js
function za(e) {
	"@babel/helpers - typeof";
	return za = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, za(e);
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/toPrimitive.js
function Ba(e, t) {
	if (za(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (za(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/toPropertyKey.js
function Va(e) {
	var t = Ba(e, "string");
	return za(t) == "symbol" ? t : t + "";
}
// \0@oxc-project+runtime@0.155.0/helpers/esm/defineProperty.js
function Ha(e, t, n) {
	return (t = Va(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
// src/voice/handsFree.ts
function Ua(e, t) {
	if (t === "exit") return "off";
	switch (e) {
		case "off": return t === "start" ? "listening" : e;
		case "listening": return t === "speech" ? "hearing" : t === "idle" ? "off" : e;
		case "hearing": return t === "silence" ? "transcribing" : e;
		case "transcribing": return t === "transcribed" ? "waiting" : t === "empty" || t === "failed" ? "listening" : e;
		case "waiting": return t === "answered" ? "speaking" : t === "failed" ? "listening" : e;
		case "speaking": return t === "speech" ? "hearing" : t === "spoken" || t === "failed" ? "listening" : e;
	}
}
var Wa = {
	threshold: .12,
	bargeThreshold: .35,
	attackMs: 250,
	silenceMs: 1200,
	restartMs: 1e4,
	idleMs: 3e4,
	maxUtteranceMs: 55e3
}, Ga = class {
	constructor(e = Wa) {
		Ha(this, "o", void 0), Ha(this, "loudSince", null), Ha(this, "lastLoud", 0), Ha(this, "recordingFrom", 0), Ha(this, "idleFrom", 0), this.o = e;
	}
	reset(e, t = !0) {
		this.loudSince = null, this.recordingFrom = e, t && (this.idleFrom = e);
	}
	feed(e, t, n) {
		if (n === "listening" || n === "speaking") {
			if (e >= (n === "speaking" ? this.o.bargeThreshold : this.o.threshold)) {
				if (this.loudSince != null || (this.loudSince = t), t - this.loudSince >= this.o.attackMs) return this.lastLoud = t, "speech";
			} else this.loudSince = null;
			return n === "listening" && t - this.idleFrom >= this.o.idleMs ? "idle" : t - this.recordingFrom >= this.o.restartMs ? "restart" : null;
		}
		return n === "hearing" && (e >= this.o.threshold && (this.lastLoud = t), t - this.lastLoud >= this.o.silenceMs || t - this.recordingFrom >= this.o.maxUtteranceMs) ? "silence" : null;
	}
}, Ka = 50;
function qa(e) {
	let [t, n] = R("off"), [r, i] = R(null), a = L("off"), o = () => a.current, s = L(e);
	s.current = e;
	let c = L(null), l = L(new Ga()), u = L(void 0), d = L(0), f = A((e) => {
		let t = Ua(a.current, e);
		return t !== a.current && (a.current = t, n(t)), t;
	}, []), p = () => {
		var e;
		(e = c.current) == null || e.cancel(), c.current = null;
	}, m = A(async (e) => {
		p();
		let t = d.current;
		try {
			let n = await Ta();
			return t === d.current ? (c.current = n, l.current.reset(Date.now(), e), !0) : (n.cancel(), !1);
		} catch (e) {
			let t = e == null ? void 0 : e.name;
			return i(t === "NotFoundError" ? "noMicrophone" : t === "NotAllowedError" ? "denied" : "failed"), !1;
		}
	}, []), h = A(() => {
		d.current++, clearInterval(u.current), u.current = void 0, p(), s.current.stopSpeaking(), f("exit");
	}, [f]), g = A(async () => {
		let e = c.current;
		if (c.current = null, !e) return;
		let t = s.current, n = "", r;
		try {
			var a;
			let i = await t.transcribe(await ka(await e.stop()));
			n = i.text.trim(), r = (a = i.usageId) == null ? void 0 : a;
		} catch (e) {
			if (o() !== "transcribing") return;
			if ((e == null ? void 0 : e.code) === "limit_exceeded") {
				i("limit"), h();
				return;
			}
			i("failed");
		}
		if (o() !== "transcribing") return;
		if (!n) {
			f("empty"), !await m(!1) && o() !== "off" && h();
			return;
		}
		i(null), f("transcribed"), Ci("sent");
		let u = await t.send(n, r).catch(() => void 0);
		o() === "waiting" && (u ? await m(!0) ? (f("answered"), await t.speak(u), o() === "speaking" && (f("spoken"), l.current.reset(Date.now(), !0), Ci("listening"))) : o() === "waiting" && h() : (f("failed"), !await m(!0) && o() !== "off" && h()));
	}, [
		f,
		m,
		h
	]), _ = A(() => {
		let e = c.current;
		if (!e) return;
		let t = a.current, n = l.current.feed(e.level(), Date.now(), t);
		n === "speech" ? (t === "speaking" && s.current.stopSpeaking(), f("speech")) : n === "silence" ? (f("silence"), g()) : n === "idle" ? h() : n === "restart" && m(!1);
	}, [
		f,
		g,
		m,
		h
	]), v = A(async () => {
		o() === "off" && (xi(), i(null), await m(!0) && (f("start"), Ci("listening"), u.current = setInterval(_, Ka)));
	}, [
		f,
		_,
		m
	]);
	M(() => {
		u.current && (clearInterval(u.current), u.current = setInterval(_, Ka));
	}, [_]), M(() => {
		if (t === "off") return;
		let e = (e) => {
			e.key === "Escape" && h();
		}, n = () => {
			document.visibilityState === "hidden" && h();
		};
		return document.addEventListener("keydown", e), document.addEventListener("visibilitychange", n), () => {
			document.removeEventListener("keydown", e), document.removeEventListener("visibilitychange", n);
		};
	}, [t, h]), M(() => () => {
		var e;
		clearInterval(u.current), (e = c.current) == null || e.cancel();
	}, []);
	let y = A(() => o() === "off" ? void v() : h(), [v, h]);
	return {
		mode: t,
		active: t !== "off",
		error: r,
		toggle: y,
		stop: h
	};
}
// src/chat/NyceBuddyChat.tsx
var Ja = "thinking", Ya = "draft";
function Xa(e) {
	let { report: t, data: n, ...r } = e;
	return r;
}
function Za({ initialSessionId: e, handleRef: t, onOverrides: n }) {
	var r, i, a, o;
	let { t: s } = C(), c = Pi(), { client: l, storage: u, prefs: d, features: f, debug: p, language: m, timezone: h, context: g, formContext: _, emit: v, layout: y, roles: b } = c, S = x(), w = Tt({
		client: l,
		storage: u,
		initialSessionId: e
	}), [T, E] = R([]), D = yt({
		client: l,
		onEvent: (e) => {
			e.event === "log" && E((t) => [...t, e.data.message].slice(-500));
		}
	}), O = kt({
		client: l,
		storage: d,
		enabled: f.settings
	}), [k, j] = R(() => d.get(Ja) || "normal"), [P, I] = R((r = c.limitStatus) != null && r.isExceeded ? c.limitStatus : null);
	M(() => {
		c.limitStatus && I(c.limitStatus.isExceeded ? c.limitStatus : null);
	}, [c.limitStatus]);
	let [H, U] = R(() => {
		var e;
		return {
			text: (e = u.get(`${Ya}:${w.sessionId}`)) == null ? "" : e,
			key: 1
		};
	}), [W, G] = R(null), [K, q] = R(0), [J, ee] = R(null), [Y, te] = R(null), [ne, re] = R(() => /* @__PURE__ */ new Set()), [ie, ae] = R(null), [oe, se] = R(() => /* @__PURE__ */ new Set()), ce = !!f.responseAgents && b.canCreateAgent, [le, ue] = R(0);
	M(() => {
		f.feedback && l.feedback.mine().then((e) => ue(ii(e))).catch(() => {});
	}, [l, f.feedback]);
	let de = L(null), fe = L(null), pe = O.settings.useFormContext !== !1, me = F(() => _ && pe ? {
		...g == null ? {} : g,
		form: _
	} : g, [
		g,
		_,
		pe
	]), he = c.userCode || b.userCode, ge = F(() => he && typeof l.login == "function" ? async (e) => {
		var t;
		return (await l.login({
			system: (t = l.system) == null ? "" : t,
			username: he,
			password: e,
			client: (g == null ? void 0 : g.clientId) == null ? void 0 : String(g.clientId),
			warehouse: (g == null ? void 0 : g.warehouseId) == null ? void 0 : String(g.warehouseId)
		})).refresh_token;
	} : void 0, [
		l,
		he,
		g
	]), _e = A((e) => {
		O.update({ useFormContext: e }), v({
			type: "form-context",
			enabled: e
		});
	}, [O, v]), [ve, ye] = R(void 0);
	M(() => ye(void 0), [c.theme]);
	let be = A((e) => {
		var t;
		ye(e), (t = c.onThemeChange) == null || t.call(c, e);
	}, [c]);
	M(() => {
		let e = O.settings;
		n({
			fontSize: e.fontSize,
			language: e.language,
			showRawData: e.showRawData,
			theme: ve
		}), !d.get(Ja) && e.defaultThinking && j(e.defaultThinking);
	}, [
		O.settings,
		n,
		d,
		ve
	]);
	let { messagesContainerRef: xe, messagesEndRef: Se, scrollToBottom: X, enableAutoScroll: Ce } = Et({
		isStreaming: D.busy,
		contentKey: [
			w.messages.length,
			D.state.status,
			D.state.answerText.length,
			D.state.activities.length
		].join(":")
	}), we = A((e) => {
		j(e), d.set(Ja, e);
	}, [d]), Te = A((e) => {
		let t = `${Ya}:${w.sessionId}`;
		e ? u.set(t, e) : u.remove(t);
	}, [u, w.sessionId]), Ee = A((e, t) => {
		var n, r;
		e.limitStatus && I(e.limitStatus.isExceeded ? e.limitStatus : null), e.awaitingClarification && (de.current = { messageId: e.messageId });
		let i = !e.report.heading && !((n = e.report.answer) != null && n.trim()) && !((r = e.report.rows) != null && r.length);
		w.addMessage({
			id: e.messageId || Ct(),
			role: "assistant",
			text: i ? s("chat.emptyAnswer") : "",
			report: e.report,
			result: Xa(e),
			timestamp: (/* @__PURE__ */ new Date()).toISOString(),
			thinking: e.thinking
		}), v({
			type: "answer",
			result: e,
			sessionId: t
		}), q((e) => e + 1);
	}, [
		w,
		v,
		s
	]), Z = A(async (e, t = {}) => {
		var n, r, i;
		let a = e.trim();
		if (!a || D.busy) return;
		let o = w.sessionId, s = (n = t.clarification) == null ? de.current ? {
			messageId: de.current.messageId,
			answers: { answer: a },
			text: a
		} : void 0 : n;
		de.current = null, Ce();
		let c = (/* @__PURE__ */ new Date()).toISOString(), l = (r = t.thinking) == null ? k : r;
		t.silent ? w.addMessage({
			id: Ct(),
			role: "user",
			text: a,
			timestamp: c,
			isClarificationResponse: !0,
			clarification: s
		}) : w.addMessage({
			id: Ct(),
			role: "user",
			text: a,
			timestamp: c,
			thinking: l,
			replaySavedQueryId: t.replaySavedQueryId,
			attachments: (i = t.attachmentInfo) != null && i.length ? t.attachmentInfo : void 0
		}), v({
			type: "ask",
			question: a,
			sessionId: o
		}), E([]);
		let u = {
			message: a,
			sessionId: o,
			thinkingLevel: l,
			language: m,
			timezone: h,
			debug: p || void 0,
			context: me,
			attachments: t.attachments,
			voice: t.voice,
			clarification: s,
			replaySavedQueryId: t.replaySavedQueryId,
			format: t.replaySavedQueryId ? t.format : void 0
		}, d = await D.start(u);
		if (Ce(), d) return Ee(d, o), d.messageId || void 0;
	}, [
		D.busy,
		D.start,
		w.sessionId,
		w.addMessage,
		k,
		m,
		h,
		p,
		me,
		v,
		Ce,
		Ee
	]), De = L(!1), Oe = A(async (e) => {
		if (De.current || D.busy || !l.activeTurn) return;
		De.current = !0;
		let t = w.sessionId;
		try {
			let n = e === void 0 ? await l.activeTurn(t).catch(() => null) : e;
			if (!n || n.sessionId !== t || n.status !== "running" && n.status !== "done" || w.messages.some((e) => e.id === n.turnId)) return;
			let r = w.messages[w.messages.length - 1];
			n.question && ((r == null ? void 0 : r.role) !== "user" || r.text !== n.question) && w.addMessage({
				id: Ct(),
				role: "user",
				text: n.question,
				timestamp: n.startedAt || (/* @__PURE__ */ new Date()).toISOString()
			}), Ce();
			let i = await D.attach(n.turnId);
			Ce(), i && Ee(i, t);
		} finally {
			De.current = !1;
		}
	}, [
		l,
		w,
		D,
		Ce,
		Ee
	]), ke = L(Oe);
	ke.current = Oe, M(() => {
		if (typeof document > "u") return;
		let e = () => {
			document.visibilityState === "visible" && ke.current();
		}, t = () => void ke.current();
		return document.addEventListener("visibilitychange", e), window.addEventListener("online", t), () => {
			document.removeEventListener("visibilitychange", e), window.removeEventListener("online", t);
		};
	}, []);
	let Ae = L(null);
	M(() => {
		var e, t, n;
		let r = D.state;
		if (r.status !== "error" && r.status !== "cancelled") return;
		let i = `${r.status}:${r.endedAt}`;
		if (Ae.current === i) return;
		Ae.current = i;
		let a = r.status === "cancelled", o = (e = r.error) == null ? void 0 : e.code, c = a ? s("chat.requestCancelled") : o === "auth_expired" ? s("errors.sessionExpired") : s("chat.errorPrefix", { message: ((t = r.error) == null ? void 0 : t.message) || s("errors.unknownError") });
		if (w.addMessage({
			id: Ct(),
			role: "assistant",
			text: a ? c : "",
			error: a ? void 0 : c,
			cancelled: a,
			timestamp: (/* @__PURE__ */ new Date()).toISOString()
		}), v(a ? { type: "cancel" } : {
			type: "error",
			error: ((n = r.error) == null ? void 0 : n.message) || "error",
			code: o
		}), o === "limit_exceeded") {
			var l, u;
			let e = (l = (u = r.error) == null ? void 0 : u.limitStatus) == null ? {
				isExceeded: !0,
				remainingTokens: 0,
				daysUntilReset: 0,
				resetDate: ""
			} : l;
			I({
				...e,
				isExceeded: !0
			}), v({
				type: "limit",
				status: {
					...e,
					isExceeded: !0
				}
			});
		}
	}, [
		D.state,
		w,
		v,
		s
	]);
	let je = A(async () => {
		D.cancel(), de.current = null;
		let e = await w.newConversation();
		U({
			text: "",
			key: Date.now()
		}), v({
			type: "new-conversation",
			sessionId: e
		}), requestAnimationFrame(() => X(!1));
	}, [
		D,
		w,
		v,
		X
	]), Me = A(async (e) => {
		var t;
		D.cancel(), de.current = null;
		let n;
		try {
			let t = await l.conversations.getBySession(e);
			n = t == null ? void 0 : t.messages;
		} catch {
			n = void 0;
		}
		w.loadConversation(e, n), U({
			text: (t = u.get(`${Ya}:${e}`)) == null ? "" : t,
			key: Date.now()
		}), v({
			type: "load-conversation",
			sessionId: e
		}), requestAnimationFrame(() => X(!1));
	}, [
		D,
		l,
		w,
		u,
		v,
		X
	]), Ne = L(!1);
	M(() => {
		if (Ne.current) return;
		Ne.current = !0;
		let e = w.sessionId, t = f.history ? l.conversations.getBySession(e).catch(() => null) : Promise.resolve(null), n = l.activeTurn ? l.activeTurn(e).catch(() => null) : Promise.resolve(null);
		Promise.all([t, n]).then(([e, t]) => {
			e != null && e.messages.length && !w.messages.length && w.loadConversation(e.sessionId, e.messages), t && setTimeout(() => void ke.current(t), 0);
		});
	}, []);
	let Pe = A((e, t) => {
		let n = t.id;
		Z(e.text, {
			silent: !0,
			clarification: {
				messageId: n,
				answers: e.answers,
				text: e.text
			}
		});
	}, [Z]), Fe = A((e) => {
		e.type === "open" && (e.panel === "history" && f.history && G("history"), e.panel === "settings" && f.settings && G("settings"), e.panel === "usage" && f.usage && G("usage"), e.panel === "feedback" && f.feedback && G("feedback"), e.panel === "adminFeedback" && f.adminFeedback && G("adminFeedback"), e.panel === "customerDocs" && f.customerDocsAdmin && G("customerDocs"), e.panel === "saved" && f.savedResponses && G("saved"));
	}, [f]), Ie = A(async (e, t, n) => {
		let r = w.messages.filter((e) => !e.isClarificationResponse).slice(-6).map((e) => {
			var t, n;
			return {
				role: e.role,
				text: e.role === "user" ? e.text : ((t = e.report) == null ? void 0 : t.heading) || ((n = e.report) == null ? void 0 : n.answer) || e.text
			};
		});
		try {
			await l.feedback.submit({
				messageId: e.id,
				feedback: t,
				comment: n,
				sessionId: w.sessionId,
				history: r
			}), w.updateMessage(e.id, { feedback: t }), v({
				type: "feedback",
				messageId: e.id,
				vote: t
			}), S(s("feedback.thanks"), "success");
		} catch (e) {
			S(e.message || s("feedback.failed"), "error");
		}
	}, [
		l,
		w,
		v,
		S,
		s
	]), Le = A(async (e) => {
		if (!J) return;
		let t = await l.saved.create({
			messageId: J.id,
			...e
		});
		v({
			type: "saved",
			id: t.id,
			messageId: J.id
		}), S(s("saved.saved"), "success");
	}, [
		J,
		l,
		v,
		S,
		s
	]), Re = A((e, t) => {
		G(null), S(s("saved.replaying", { title: e.title })), Z(e.userQuestion || e.title, {
			replaySavedQueryId: e.id,
			format: t.refresh ? "refresh" : void 0
		});
	}, [
		Z,
		S,
		s
	]), ze = A(async (e) => {
		let t = await l.pdf.export(e);
		return v({
			type: "pdf",
			messageId: e
		}), t;
	}, [l, v]), [Be, Ve] = R(!1), He = A(async () => {
		if (!Be) {
			Ve(!0);
			try {
				let e = w.sessionId;
				It(await l.pdf.exportConversation(e), Oi()), v({
					type: "pdf",
					sessionId: e
				}), S(s("pdf.exported"), "success");
			} catch (e) {
				S(e.message || s("pdf.failed"), "error");
			} finally {
				Ve(!1);
			}
		}
	}, [
		Be,
		w.sessionId,
		l,
		v,
		S,
		s
	]), Ue = !!f.voice && y === "app", We = Ue && wa(), Ge = A((e) => l.transcribe(e, m), [l, m]), Ke = L(w.messages);
	Ke.current = w.messages;
	let { updateMessage: qe } = w, Je = wi(A(async (e, t) => {
		let n = await l.speak(e, m, t), r = Ke.current.find((t) => t.id === e);
		return n.messageTokens != null && r != null && r.result && qe(e, { result: {
			...r.result,
			weightedTokens: n.messageTokens,
			nyceTokens: r.result.nyceTokens ? {
				...r.result.nyceTokens,
				total: n.messageTokens
			} : void 0
		} }), n.audio;
	}, [
		l,
		m,
		qe
	]));
	M(() => {
		Je.error && S(s(`voice.${Je.error}`), "error");
	}, [
		Je.error,
		S,
		s
	]);
	let Ye = (i = O.settings.readAloud) == null ? "dictated" : i, Xe = (e) => Ue && (Ye === "always" || Ye === "dictated" && e), Ze = qa({
		transcribe: Ge,
		send: (e, t) => Z(e, { voice: { usageId: t } }),
		speak: Je.speak,
		stopSpeaking: Je.stop
	}), Qe = A((e) => l.uploadAttachments(e, w.sessionId), [l, w.sessionId]), $e = A((e) => {
		O.update(e).then((t) => {
			t || v({
				type: "settings-change",
				settings: {
					...O.settings,
					...e
				}
			});
		}), e.fontSize && d.set("ui_font_size", e.fontSize), e.language && d.set("language", e.language);
	}, [
		O,
		v,
		d
	]), [et, tt] = R(!1), nt = A((e) => {
		tt(!0), O.update(e).then((t) => {
			var n, r;
			if (tt(!1), t) {
				let e = t.code;
				S(e === "client_not_allowed" ? s("chat.clientNotAllowed") : e === "warehouse_not_allowed" ? s("chat.warehouseNotAllowed") : t.message, "error");
				return;
			}
			let i = {
				...O.settings,
				...e
			};
			v({
				type: "settings-change",
				settings: i
			}), v({
				type: "scope-changed",
				clientId: (n = i.selectedClientId) == null ? null : n,
				warehouseId: (r = i.selectedWarehouseId) == null ? null : r
			});
		});
	}, [
		O,
		v,
		S,
		s
	]), rt = F(() => y === "app" ? {
		clientId: O.settings.selectedClientId,
		warehouseId: O.settings.selectedWarehouseId,
		onChange: nt,
		busy: et
	} : void 0, [
		y,
		O.settings.selectedClientId,
		O.settings.selectedWarehouseId,
		nt,
		et
	]);
	N(t, () => ({
		ask: (e, t) => void Z(e, t),
		newConversation: () => void je(),
		loadConversation: (e) => void Me(e),
		cancel: () => D.cancel(),
		focus: () => {
			var e;
			return (e = fe.current) == null ? void 0 : e.focus();
		}
	}), [
		Z,
		je,
		Me,
		D
	]);
	let it = D.busy;
	return /* @__PURE__ */ V("div", {
		className: "nb-shell",
		children: [
			/* @__PURE__ */ B(Hi, {
				onLogout: y === "app" && c.onLogoutRequested ? c.onLogoutRequested : void 0,
				onOpen: Fe,
				feedbackBadge: le,
				scope: rt,
				onExportConversation: () => void He(),
				canExportConversation: w.messages.some((e) => e.role === "assistant"),
				exportingConversation: Be
			}),
			/* @__PURE__ */ V("div", {
				className: "nb-messages",
				ref: xe,
				children: [
					/* @__PURE__ */ B(Ei, {
						speaker: Ue ? Je : null,
						children: /* @__PURE__ */ B(pa, {
							messages: w.messages,
							onReuse: (e) => U((t) => ({
								text: e,
								key: t.key + 1
							})),
							onClarificationSubmit: Pe,
							onSaveResponse: f.savedResponses ? (e) => ee(e) : void 0,
							onFeedback: f.feedback ? Ie : void 0,
							exportPdf: f.pdfExport ? ze : void 0,
							onSchedule: f.scheduledReports ? (e) => te(e) : void 0,
							scheduledIds: ne,
							onCreateAgent: ce ? (e) => ae(e) : void 0,
							agentIds: oe
						})
					}),
					/* @__PURE__ */ B(Sa, {
						state: {
							...D.state,
							log: p ? T : D.state.log
						},
						onCancel: it ? D.cancel : void 0,
						allowHtml: f.htmlRows
					}),
					/* @__PURE__ */ B("div", { ref: Se })
				]
			}),
			/* @__PURE__ */ B(Ia, {
				ref: fe,
				onSend: (e, t, n, r) => void Z(e, {
					thinking: t,
					voice: r,
					attachments: n.length ? n.map((e) => e.id) : void 0,
					attachmentInfo: n.map(Xi)
				}).then((e) => {
					e && Xe(!!r) && Je.speak(e);
				}),
				onNewConversation: je,
				busy: it,
				limitStatus: P,
				showThinkingPicker: f.thinkingPicker,
				thinking: k,
				onThinkingChange: we,
				draft: H.text,
				draftKey: H.key,
				onDraftChange: Te,
				onUpload: f.fileUpload ? Qe : void 0,
				onTranscribe: We ? Ge : void 0,
				handsFree: We ? {
					mode: Ze.mode,
					error: Ze.error,
					toggle: Ze.toggle
				} : void 0,
				contextChip: _ ? /* @__PURE__ */ B(Ra, {
					form: _,
					on: pe,
					onToggle: _e
				}) : void 0
			}),
			f.history && /* @__PURE__ */ B(jt, {
				open: W === "history",
				onClose: () => G(null),
				client: l,
				currentSessionId: w.sessionId,
				refreshKey: K,
				onContinue: (e) => {
					G(null), Me(e.sessionId);
				},
				onNewConversation: () => {
					G(null), je();
				}
			}),
			f.settings && /* @__PURE__ */ B(fn, {
				open: W === "settings",
				onClose: () => G(null),
				settings: O.settings,
				onChange: $e,
				client: l,
				showMemory: f.memory,
				showSchedules: f.scheduledReports || ce,
				showFormContext: !!_,
				showReadAloud: Ue,
				showMcpKeys: f.mcp && b.scopes.some((e) => e === "nycebuddy:mcp" || e === "nycebuddy:ask" || e === "nycebuddy:*"),
				userName: c.userName,
				userCode: c.userCode || b.userCode || void 0,
				loginContext: g,
				scheduleSignIn: ge,
				theme: (a = ve == null ? c.theme : ve) == null ? "dark" : a,
				onThemeChange: be,
				error: O.error
			}),
			f.usage && /* @__PURE__ */ B(yn, {
				open: W === "usage",
				onClose: () => G(null),
				client: l
			}),
			f.feedback && /* @__PURE__ */ B(ai, {
				open: W === "feedback",
				onClose: () => G(null),
				client: l,
				onUnreadChange: ue
			}),
			f.adminFeedback && /* @__PURE__ */ B(si, {
				open: W === "adminFeedback",
				onClose: () => G(null),
				client: l,
				canChooseScope: b.isTenantAdmin || b.isPlatformAdmin
			}),
			f.customerDocsAdmin && /* @__PURE__ */ B(mi, {
				open: W === "customerDocs",
				onClose: () => G(null),
				client: l,
				canChooseScope: b.isTenantAdmin || b.isPlatformAdmin
			}),
			f.scheduledReports && /* @__PURE__ */ B(Yt, {
				open: Y !== null,
				onClose: () => te(null),
				message: Y,
				client: l,
				timezone: h,
				defaultEmail: O.settings.email || void 0,
				canSendMail: b.canSendMail,
				signIn: ge,
				onCreated: (e, t) => {
					re((e) => new Set(e).add(t)), v({
						type: "scheduled",
						id: e.id,
						messageId: t
					});
				}
			}),
			ce && /* @__PURE__ */ B(pn, {
				open: ie !== null,
				onClose: () => ae(null),
				message: ie,
				client: l,
				timezone: h,
				defaultEmail: O.settings.email || void 0,
				canSendMail: b.canSendMail,
				signIn: ge,
				onCreated: (e, t) => {
					se((e) => new Set(e).add(t)), v({
						type: "agentCreated",
						id: e.id,
						messageId: t
					});
				}
			}),
			f.savedResponses && /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(vi, {
				open: W === "saved",
				onClose: () => G(null),
				client: l,
				onRun: Re
			}), /* @__PURE__ */ B(_i, {
				open: J !== null,
				onClose: () => ee(null),
				initial: { title: ((J == null || (o = J.report) == null ? void 0 : o.heading) || "").slice(0, 80) },
				onSave: Le
			})] })
		]
	});
}
var Qa = k(function(e, t) {
	var n, r;
	let { theme: i = "dark", fontSize: a = "medium", layout: o = "app", portalContainer: s, loadFonts: c, className: l, style: u, translations: d, initialSessionId: f } = e, [p, m] = R({}), h = F(() => {
		var t, n;
		return w((t = (n = p.language) == null ? e.language : n) == null ? "en" : t);
	}, [p.language, e.language]), g = F(() => ({
		height: "100%",
		minHeight: 0,
		...u
	}), [u]), _ = A((e) => m((t) => t.fontSize === e.fontSize && t.language === e.language && t.showRawData === e.showRawData && t.theme === e.theme ? t : e), []);
	return /* @__PURE__ */ B(Li, {
		...e,
		language: h,
		layout: o,
		showRawData: p.showRawData,
		children: /* @__PURE__ */ B(b, {
			theme: (n = p.theme) == null ? i : n,
			fontSize: (r = p.fontSize) == null ? a : r,
			layout: o,
			portalContainer: s,
			loadFonts: c,
			className: l,
			style: g,
			children: /* @__PURE__ */ B($a, {
				language: h,
				translations: d,
				children: /* @__PURE__ */ B(y, { children: /* @__PURE__ */ B(Za, {
					initialSessionId: f,
					handleRef: t,
					onOverrides: _
				}) })
			})
		})
	});
});
function $a({ language: e, translations: t, children: n }) {
	let { client: r } = Pi(), i = A((e) => r.translations(e), [r]);
	return /* @__PURE__ */ B(S, {
		language: e,
		bundle: t,
		loader: i,
		children: n
	});
}
// src/report/PdfReport.tsx
var eo = (e) => {
	let t = e ? new Date(e) : null;
	return t && !Number.isNaN(t.getTime()) ? t : null;
}, to = (e) => {
	var t, n;
	return (t = (n = eo(e)) == null ? void 0 : n.toLocaleString()) == null ? "" : t;
};
function no(e, t) {
	var n, r;
	let i = eo(e), a = eo(t);
	return !i || !a ? (n = (r = i == null ? a : i) == null ? void 0 : r.toLocaleString()) == null ? "" : n : i.getTime() === a.getTime() ? i.toLocaleString() : i.toDateString() === a.toDateString() ? `${i.toLocaleDateString()}, ${i.toLocaleTimeString()} – ${a.toLocaleTimeString()}` : `${i.toLocaleString()} – ${a.toLocaleString()}`;
}
function ro({ meta: e, subtitle: t, ready: n = !0, children: r }) {
	var i;
	let a = L(null);
	M(() => {
		var e;
		(e = a.current) == null || e.querySelectorAll("details").forEach((e) => e.open = !0);
	});
	let o = In(), [s, c] = R(!1);
	return M(() => c(!0), []), /* @__PURE__ */ B(b, {
		theme: "light",
		layout: "app",
		className: "nb-pdf",
		style: { background: "#fff" },
		children: /* @__PURE__ */ V("div", {
			className: "pdf-content",
			"data-ready": n && s && o === 0 ? "true" : "false",
			"data-print": "true",
			ref: a,
			children: [/* @__PURE__ */ V("header", {
				className: "nb-pdf-head",
				children: [/* @__PURE__ */ B("img", {
					src: zi.logoBlack,
					alt: "nyceBuddy",
					style: { width: 160 }
				}), /* @__PURE__ */ V("div", {
					className: "nb-pdf-meta",
					children: [
						[
							(i = e.organizationName) == null ? e.tenantName : i,
							e.systemName,
							e.userName
						].filter(Boolean).join(" · "),
						/* @__PURE__ */ B("br", {}),
						t
					]
				})]
			}), r]
		})
	});
}
function io({ data: e, ready: t = !0 }) {
	var n;
	let r = (n = e.meta) == null ? {} : n;
	return /* @__PURE__ */ B(ro, {
		meta: r,
		subtitle: to(r.createdAt) || to((/* @__PURE__ */ new Date()).toISOString()),
		ready: t,
		children: /* @__PURE__ */ B(ni, {
			report: e.report,
			allowHtml: !0,
			clarificationDisabled: !0
		})
	});
}
function ao({ data: e, ready: t = !0 }) {
	var n;
	let { t: r } = C(), { conversation: i } = e;
	return /* @__PURE__ */ V(ro, {
		meta: (n = e.meta) == null ? {} : n,
		subtitle: no(i.startedAt, i.endedAt),
		ready: t,
		children: [
			i.title && /* @__PURE__ */ B("h1", {
				className: "nb-pdf-title",
				children: i.title
			}),
			i.entries.map((e, t) => e.role === "question" ? /* @__PURE__ */ B("div", {
				className: "nb-pdf-ask",
				children: /* @__PURE__ */ B("div", {
					className: "nb-pdf-question",
					children: e.text
				})
			}, t) : /* @__PURE__ */ V("div", {
				className: "nb-pdf-answer",
				children: [e.report ? /* @__PURE__ */ B(ni, {
					report: e.report,
					allowHtml: !0,
					clarificationDisabled: !0
				}) : /* @__PURE__ */ B("div", {
					className: "nb-pdf-plain",
					children: e.text
				}), e.error && /* @__PURE__ */ B("div", {
					className: "nb-pdf-failed",
					children: e.error
				})]
			}, t)),
			i.omittedEntries > 0 && /* @__PURE__ */ B("div", {
				className: "nb-pdf-omitted",
				children: r("pdf.truncated", {
					shown: i.entries.length,
					total: i.messageCount
				})
			})
		]
	});
}
// src/styles/index.css?inline
var oo = ".nb-root{--nb-font:\"Poppins\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;--nb-mono:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Ubuntu Mono\", monospace;--nb-font-scale:1;--nb-accent:#c2417f;--nb-accent-2:#8e5ee3;--nb-accent-soft:#8b5cf61a;--nb-user-gradient:linear-gradient(90deg, #d5549b, #8e5ee3);--nb-radius-card:14px;--nb-radius-bubble:18px;--nb-chart-1:#c2417f;--nb-chart-2:#4c93c4;--nb-chart-3:#b0741f;--nb-chart-4:#2f9e8f;--nb-chart-5:#5857c9;--nb-chart-6:#6b8f2e;--nb-good:#238653;--nb-warning:#c48a00;--nb-critical:#b42318;--nb-bg:#1f2227;--nb-fg:#e4e6ea;--nb-fg-muted:#9ca3af;--nb-shell-border:1px solid #fff3;--nb-shell-shadow:0 20px 40px #764ba24d;--nb-header-bg:#fff;--nb-header-fg:#000;--nb-header-muted:#4b5563;--nb-header-border:transparent;--nb-header-shadow:none;--nb-bot-bubble:#f5f0ff;--nb-bot-fg:#374151;--nb-bot-border:#e5e7eb;--nb-card:#fff;--nb-card-fg:#1f2227;--nb-line:#e5e7eb;--nb-muted:#6b7280;--nb-code:#f0f2f5;--nb-track:#ece9ef;--nb-err:#b42318;--nb-card-shadow:0 1px 3px #0000000a;--nb-input-bg:#1f2227;--nb-input-fg:#fff;--nb-input-border:#fff;--nb-input-placeholder:#9ca3af;--nb-picker-bg:#1a1a2ef2;--nb-dialog-bg:#1a1a2e;--nb-dialog-fg:#e4e6ea;--nb-dialog-line:#ffffff1f;--nb-panel-bg:#fff;--nb-panel-fg:#1e293b;--nb-scrollbar:#8b5cf64d;--nb-focus:0 0 0 3px #8b5cf640;--nb-z-overlay:1300}.nb-root[data-theme=light]{--nb-bg:#fff;--nb-fg:#1c1e21;--nb-fg-muted:#6b7280;--nb-shell-border:1px solid #e5e7eb;--nb-shell-shadow:0 8px 24px #00000014;--nb-header-border:#e5e7eb;--nb-header-shadow:0 2px 10px #0000000f;--nb-input-bg:#fff;--nb-input-fg:#1c1e21;--nb-input-border:#d1d5db;--nb-picker-bg:#fffffffa;--nb-dialog-bg:#fff;--nb-dialog-fg:#1c1e21;--nb-dialog-line:#e5e7eb}.nb-root[data-font-size=small]{--nb-font-scale:.85}.nb-root[data-font-size=large]{--nb-font-scale:1.18}.nb-root,.nb-root *,.nb-root :before,.nb-root :after{box-sizing:border-box}.nb-root{font-family:var(--nb-font);font-size:calc(14px * var(--nb-font-scale));color:var(--nb-fg);background:var(--nb-bg);-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-text-size-adjust:100%;text-align:left;line-height:1.45}.nb-root :where(h1){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(h2){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(h3){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(h4){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(h5){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(p){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(ul){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(ol){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(pre){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(figure){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(table){font-size:inherit;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}.nb-root :where(ul){list-style:none}.nb-root :where(ol){list-style:none}.nb-root :where(button){font:inherit;color:inherit;background:0 0;border:0;border-radius:0;margin:0}.nb-root :where(input){font:inherit;color:inherit;background:0 0;border:0;border-radius:0;margin:0}.nb-root :where(select){font:inherit;color:inherit;background:0 0;border:0;border-radius:0;margin:0}.nb-root :where(textarea){font:inherit;color:inherit;background:0 0;border:0;border-radius:0;margin:0}.nb-root :where(button){cursor:pointer;line-height:inherit;text-transform:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;color:inherit;font:inherit;background:0 0;padding:0}.nb-root :where(button:disabled){cursor:not-allowed}.nb-root :where(a){color:var(--nb-accent);text-decoration:none}.nb-root :where(a:hover){text-decoration:underline}.nb-root :where(img){vertical-align:middle;max-width:100%;display:block}.nb-root :where(svg){vertical-align:middle;max-width:100%;display:block}.nb-root :where(table){border-collapse:collapse;border-spacing:0}.nb-root :where(th){text-align:left;vertical-align:top;padding:0}.nb-root :where(td){text-align:left;vertical-align:top;padding:0}.nb-root :where(code){font-family:var(--nb-mono);font-size:.92em}.nb-root :where(pre){font-family:var(--nb-mono);font-size:.92em}.nb-root :where(kbd){font-family:var(--nb-mono);font-size:.92em}.nb-root :where([hidden]){display:none!important}.nb-root :where(:focus-visible){outline:2px solid var(--nb-accent-2);outline-offset:2px}.nb-root .nb-composer-input:focus-visible{outline:none}.nb-root :where(details>summary){cursor:pointer;list-style:none}.nb-root :where(details>summary)::-webkit-details-marker{display:none}.nb-btn{min-height:36px;font-weight:600;font-size:calc(14px * var(--nb-font-scale));white-space:nowrap;border:1px solid #0000;border-radius:10px;justify-content:center;align-items:center;gap:6px;padding:0 16px;transition:transform .15s,background .15s,opacity .15s;display:inline-flex}.nb-btn:hover:not(:disabled){transform:translateY(-1px)}.nb-btn:active:not(:disabled){transform:scale(.98)}.nb-btn:disabled{opacity:.5}.nb-btn-primary{background:var(--nb-user-gradient);color:#fff}.nb-btn-secondary{color:#fff;background:#a35d7f}.nb-btn-ghost{color:inherit;opacity:.85;background:0 0;border-color:currentColor}.nb-btn-danger{color:#fff;background:#ef4444}.nb-btn-sm{min-height:28px;font-size:calc(12px * var(--nb-font-scale));border-radius:8px;padding:0 10px}.nb-iconbtn{color:#666;background:0 0;border-radius:50%;justify-content:center;align-items:center;width:36px;height:36px;transition:color .2s,transform .2s,background .2s;display:inline-flex;position:relative}.nb-iconbtn:hover:not(:disabled){color:#000;background:#0000000d;transform:scale(1.1)}.nb-iconbtn:disabled{opacity:.3}.nb-iconbtn.nb-active{color:#b15f84}.nb-iconbtn .nb-badge{background:var(--nb-user-gradient);color:#fff;border-radius:9px;justify-content:center;align-items:center;min-width:18px;height:18px;padding:0 4px;font-size:11px;font-weight:600;display:flex;position:absolute;top:0;right:0}.nb-chip{height:30px;font-size:calc(13px * var(--nb-font-scale));border:1px solid var(--nb-line);background:var(--nb-card);color:var(--nb-card-fg);white-space:nowrap;border-radius:15px;align-items:center;gap:6px;max-width:100%;padding:0 12px;display:inline-flex}.nb-chip.nb-clickable{cursor:pointer}.nb-chip.nb-clickable:hover:not(:disabled){border-color:var(--nb-accent-2);background:var(--nb-accent-soft)}.nb-chip.nb-selected{background:var(--nb-user-gradient);color:#fff;border-color:#0000}.nb-chip.nb-chip-sm{height:22px;font-size:calc(11px * var(--nb-font-scale));padding:0 8px}.nb-chip:disabled{opacity:.6}.nb-field{font-size:calc(14px * var(--nb-font-scale));flex-direction:column;gap:6px;display:flex}.nb-field>span{font-weight:500}.nb-input,.nb-select,.nb-textarea{border:1px solid var(--nb-line);background:var(--nb-card);width:100%;min-height:40px;color:var(--nb-card-fg);font-size:calc(14px * var(--nb-font-scale));border-radius:10px;padding:8px 12px}.nb-textarea{resize:vertical;min-height:80px}.nb-input:focus,.nb-select:focus,.nb-textarea:focus{border-color:var(--nb-accent-2);box-shadow:var(--nb-focus);outline:none}.nb-input:disabled,.nb-select:disabled{color:#6b7280;background:#f9fafb}.nb-select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");background-position:right 12px center;background-repeat:no-repeat;padding-right:32px}.nb-input-error{color:#b91c1c;font-size:calc(13px * var(--nb-font-scale))}.nb-switch{cursor:pointer;align-items:center;gap:10px;display:inline-flex}.nb-switch-track{background:#d1d5db;border-radius:11px;flex-shrink:0;width:40px;height:22px;transition:background .2s;position:relative}.nb-switch-track:after{content:\"\";background:#fff;border-radius:50%;width:18px;height:18px;transition:transform .2s;position:absolute;top:2px;left:2px}.nb-switch[aria-checked=true] .nb-switch-track{background:var(--nb-accent-2)}.nb-switch[aria-checked=true] .nb-switch-track:after{transform:translate(18px)}.nb-spinner{opacity:.8;border:2px solid;border-right-color:#0000;border-radius:50%;width:18px;height:18px;animation:.8s linear infinite nb-spin;display:inline-block}@keyframes nb-spin{to{transform:rotate(360deg)}}.nb-tip{display:inline-flex;position:relative}.nb-tip:after{content:attr(data-tip);color:#fff;white-space:nowrap;opacity:0;pointer-events:none;z-index:10;background:#111827;border-radius:6px;padding:4px 8px;font-size:11px;transition:opacity .15s;position:absolute;bottom:calc(100% + 6px);left:50%;transform:translate(-50%)}.nb-tip:hover:after,.nb-tip:focus-within:after{opacity:1}.nb-backdrop{z-index:var(--nb-z-overlay);background:#00000073;justify-content:center;align-items:center;padding:16px;animation:.15s ease-out nb-fade;display:flex;position:fixed;top:0;bottom:0;left:0;right:0}@keyframes nb-fade{0%{opacity:0}}.nb-dialog{background:var(--nb-dialog-bg);color:var(--nb-dialog-fg);width:100%;max-width:var(--nb-dialog-max,560px);border:1px solid var(--nb-dialog-line);border-radius:16px;flex-direction:column;max-height:calc(100vh - 32px);display:flex;box-shadow:0 24px 64px #0006}.nb-dialog-head,.nb-drawer-head{border-bottom:1px solid var(--nb-dialog-line);font-weight:600;font-size:calc(18px * var(--nb-font-scale));justify-content:space-between;align-items:center;gap:12px;padding:16px 20px;display:flex}.nb-dialog-body,.nb-drawer-body{flex:1;padding:16px 20px;overflow:auto}.nb-dialog-foot{border-top:1px solid var(--nb-dialog-line);flex-wrap:wrap;justify-content:flex-end;align-items:center;gap:8px;padding:12px 20px;display:flex}@media (max-width:720px){.nb-backdrop{align-items:stretch;padding:0}.nb-dialog{max-width:none;height:100%;max-height:100vh;border:0;border-radius:0;max-height:100dvh}.nb-dialog-body{padding:14px 16px}.nb-dialog-head,.nb-dialog-foot{padding-left:16px;padding-right:16px}.nb-dialog-foot .nb-btn{flex:calc(50% - 4px);min-height:44px}.nb-dialog .nb-btn-sm,.nb-drawer .nb-btn-sm{min-height:40px;font-size:calc(14px * var(--nb-font-scale));border-radius:10px;padding:0 14px}}@media (max-width:768px){.nb-input,.nb-select,.nb-textarea{font-size:max(16px, calc(14px * var(--nb-font-scale)))}}.nb-drawer-backdrop{z-index:var(--nb-z-overlay);background:#00000059;animation:.15s ease-out nb-fade;position:fixed;top:0;bottom:0;left:0;right:0}.nb-drawer{background:var(--nb-panel-bg);width:450px;max-width:100vw;color:var(--nb-panel-fg);flex-direction:column;animation:.2s ease-out nb-slide;display:flex;position:fixed;top:0;bottom:0;box-shadow:0 8px 32px #0003}.nb-drawer-right{right:0}.nb-drawer-left{left:0}@keyframes nb-slide{0%{opacity:0;transform:translate(20px)}}.nb-drawer-head{color:#334155;background:#f1f5f9;border-bottom:1px solid #e2e8f0}.nb-toasts{z-index:calc(var(--nb-z-overlay) + 10);flex-direction:column;gap:8px;display:flex;position:fixed;bottom:16px;left:50%;transform:translate(-50%)}.nb-toast{color:#fff;background:#111827;border-radius:10px;padding:10px 16px;font-size:13px;box-shadow:0 8px 24px #0000004d}.nb-toast-error{background:#b42318}.nb-toast-success{background:#238653}.nb-tablewrap{-webkit-overflow-scrolling:touch;max-height:50vh;overflow:auto}.nb-table{width:100%;font-size:calc(13px * var(--nb-font-scale));color:var(--nb-card-fg)}.nb-table th,.nb-table td{border-bottom:1px solid var(--nb-line);white-space:nowrap;padding:6px 10px}.nb-table th{background:var(--nb-card);letter-spacing:.08em;text-transform:uppercase;color:var(--nb-muted);cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;z-index:1;font-size:11px;font-weight:600;position:-webkit-sticky;position:sticky;top:0}.nb-table th.nb-sorted:after{content:\" ▲\";font-size:9px}.nb-table th.nb-sorted.nb-desc:after{content:\" ▼\"}.nb-table td.nb-num,.nb-table th.nb-num{text-align:right;font-variant-numeric:tabular-nums}.nb-table td.nb-null{color:var(--nb-muted);font-style:italic}.nb-table tbody tr:hover{background:#8b5cf60d}.nb-table td.nb-link{color:var(--nb-accent);cursor:pointer}.nb-shell{background:var(--nb-bg);height:100%;min-height:0;color:var(--nb-fg);flex-direction:column;display:flex;overflow:hidden;container:nb-shell/inline-size}.nb-root[data-layout=app] .nb-shell{border:var(--nb-shell-border);box-shadow:var(--nb-shell-shadow);border-radius:20px}@media (max-width:768px){.nb-root[data-layout=app] .nb-shell{box-shadow:none;border:0;border-radius:0}}.nb-header{background:var(--nb-header-bg);color:var(--nb-header-fg);border-bottom:1px solid var(--nb-header-border);z-index:1;min-height:72px;box-shadow:var(--nb-header-shadow);flex-wrap:wrap;flex-shrink:0;justify-content:space-between;align-items:center;gap:15px;padding:12px 16px 6px;display:flex;position:relative}.nb-header:after{content:\"\";background:var(--nb-user-gradient);opacity:.9;height:3px;position:absolute;bottom:-1px;left:0;right:0}.nb-header-main{align-items:center;gap:15px;min-width:0;display:flex}.nb-logo{flex-direction:column;justify-content:center;align-items:flex-start;width:200px;height:60px;display:flex}.nb-logo img{width:200px;height:auto}.nb-tagline{font-size:calc(14px * var(--nb-font-scale));opacity:.9;color:var(--nb-header-fg)}.nb-context{flex-wrap:wrap;gap:6px;display:flex}.nb-scope{flex-wrap:wrap;align-items:center;gap:10px;min-width:0;display:flex}.nb-scope-field{align-items:center;gap:6px;min-width:0;display:inline-flex}.nb-scope-label{font-size:calc(12px * var(--nb-font-scale));color:var(--nb-header-muted);white-space:nowrap}.nb-scope .nb-scope-select{width:auto;min-width:120px;max-width:220px;min-height:30px;font-size:calc(12px * var(--nb-font-scale));background-color:var(--nb-card);color:var(--nb-card-fg);text-overflow:ellipsis;background-position:right 8px center;border-radius:8px;padding:4px 28px 4px 10px}.nb-header-actions{flex-shrink:0;align-items:center;gap:4px;display:flex}.nb-header-user{font-size:calc(12px * var(--nb-font-scale));color:var(--nb-header-muted);white-space:nowrap;margin-right:8px}.nb-root[data-layout=panel] .nb-logo{width:auto;height:auto}.nb-root[data-layout=panel] .nb-logo img{width:120px}.nb-root[data-layout=panel] .nb-tagline{display:none}@media (max-width:768px){.nb-header{padding:12px 16px;padding-top:max(12px, env(safe-area-inset-top));gap:8px;min-height:60px}.nb-logo{width:auto;max-width:150px}.nb-logo img{max-width:120px}.nb-tagline{font-size:11px}.nb-header-user{display:none}.nb-header-main{flex-wrap:wrap;gap:8px}.nb-scope{flex-basis:100%;gap:8px}}@media (max-width:480px){.nb-scope-field{flex:1 1 0}.nb-scope .nb-scope-select{flex:auto;min-width:0;max-width:none}}.nb-messages{scrollbar-width:thin;scrollbar-color:var(--nb-scrollbar) transparent;flex-direction:column;flex:1;min-height:0;padding:12px 14px;display:flex;overflow:auto}.nb-messages::-webkit-scrollbar{width:6px}.nb-messages::-webkit-scrollbar-thumb{background:var(--nb-scrollbar);border-radius:3px}.nb-message-list{overflow-anchor:none;flex-direction:column;gap:16px;padding-bottom:8px;display:flex}.nb-welcome{color:var(--nb-fg);font-size:calc(26px * var(--nb-font-scale));text-align:center;flex-direction:column;flex:1;justify-content:center;align-items:center;gap:12px;padding:24px;display:flex}.nb-welcome img{width:min(500px,80%)}.nb-root[data-theme=light] .nb-welcome-logo-dark,.nb-root[data-theme=dark] .nb-welcome-logo-light{display:none}.nb-message{gap:12px;display:flex}.nb-message-user{flex-direction:row-reverse;align-self:flex-end;max-width:90%}.nb-message-bot{align-self:flex-start;width:100%}.nb-avatar{border-radius:50%;flex-shrink:0;justify-content:center;align-items:center;width:36px;height:36px;font-size:14px;font-weight:700;display:flex}.nb-message-user .nb-avatar{background:var(--nb-user-gradient);color:#fff}.nb-message-bot .nb-avatar{color:#6b7280;background:#f5f0ff}.nb-message-content{flex:1;min-width:0;max-width:100%}.nb-bubble{border-radius:var(--nb-radius-bubble);overflow-wrap:anywhere;line-height:1.4;font-size:calc(15px * var(--nb-font-scale));padding:10px 14px}.nb-message-user .nb-bubble{background:var(--nb-user-gradient);color:#fff;white-space:pre-wrap;cursor:pointer;border-bottom-right-radius:6px}.nb-message-bot .nb-bubble{background:var(--nb-bot-bubble);color:var(--nb-bot-fg);border:1px solid var(--nb-bot-border);border-bottom-left-radius:6px}.nb-bubble-error{color:#b42318}.nb-time{color:var(--nb-fg-muted);font-size:calc(12px * var(--nb-font-scale));margin-top:4px;padding:0 4px}.nb-message-user .nb-time{text-align:right}.nb-message-meta{font-size:calc(12px * var(--nb-font-scale));color:var(--nb-fg-muted);flex-wrap:wrap;align-items:center;gap:4px 12px;margin-top:4px;padding:0 4px;display:flex}.nb-message-scope{color:var(--nb-fg-muted);opacity:.85}.nb-message-nyce{font-variant-numeric:tabular-nums}.nb-message-details{font-size:calc(11.5px * var(--nb-font-scale));color:var(--nb-fg-muted);margin:2px 4px 0}.nb-message-meta .nb-iconbtn{width:28px;height:28px;color:var(--nb-fg-muted)}.nb-root[data-theme=dark] .nb-message-meta .nb-iconbtn:hover:not(:disabled){color:#fff;background:#ffffff1a}@media (max-width:480px){.nb-messages{padding:12px}.nb-message{gap:8px}.nb-message-user{max-width:95%}.nb-message-bot{width:100%}.nb-bubble{font-size:calc(14px * var(--nb-font-scale));border-radius:14px;padding:10px 12px}.nb-welcome{font-size:calc(14px * var(--nb-font-scale))}}.nb-typing .nb-bubble{width:100%}.nb-logo-pulse{filter:drop-shadow(0 0 10px #d5549b);width:24px;height:24px;animation:2s ease-in-out infinite nb-glow,3s ease-in-out infinite nb-think}@keyframes nb-glow{0%,to{filter:drop-shadow(0 0 6px #d5549b)drop-shadow(0 0 12px #d5549b)}50%{filter:drop-shadow(0 0 12px #8e5ee3)drop-shadow(0 0 24px #8e5ee3)}}@keyframes nb-think{0%,to{transform:scale(1)}50%{transform:scale(1.35)}}.nb-typing-dots{align-items:center;gap:4px;padding:4px 0;display:inline-flex}.nb-typing-dots span{background:#9ca3af;border-radius:50%;width:8px;height:8px;animation:1.4s ease-in-out infinite nb-typing}.nb-typing-dots span:nth-child(2){animation-delay:.2s}.nb-typing-dots span:nth-child(3){animation-delay:.4s}@keyframes nb-typing{0%,60%,to{opacity:.4;transform:translateY(0)}30%{opacity:1;transform:translateY(-6px)}}.nb-status{color:var(--nb-fg-muted);font-size:calc(13px * var(--nb-font-scale));flex-wrap:wrap;align-items:center;gap:8px;margin:4px 0 0 4px;display:flex}.nb-status .nb-elapsed{font-variant-numeric:tabular-nums;opacity:.8}.nb-cancel{color:#f87171;font-size:calc(12px * var(--nb-font-scale));align-items:center;gap:4px;font-weight:500;display:inline-flex}.nb-cancel:hover{color:#ef4444}.nb-activity{font-size:calc(12.5px * var(--nb-font-scale));color:var(--nb-card-fg);margin:2px 0 6px}.nb-steps{max-height:320px;margin:0;padding:0;list-style:none;overflow:auto}.nb-step{grid-template-columns:16px minmax(0,1fr);align-items:start;gap:4px;padding:1px 0;display:grid}.nb-step-mark{border:2px solid var(--nb-line);box-sizing:border-box;border-radius:50%;width:8px;height:8px;margin:6px 0 0 4px}.nb-step.nb-running .nb-step-mark{border-color:var(--nb-accent);border-top-color:#0000;animation:1s linear infinite nb-spin}.nb-icon-spin{animation:1s linear infinite nb-spin}.nb-step.nb-completed .nb-step-mark{border-color:var(--nb-good);background:var(--nb-good)}.nb-step.nb-failed .nb-step-mark{border-color:var(--nb-err);background:var(--nb-err)}.nb-step.nb-interrupted .nb-step-mark{border-color:var(--nb-muted)}.nb-step-toggle{width:16px;height:20px;color:var(--nb-muted);justify-content:center;align-items:center;display:inline-flex}.nb-step.nb-failed .nb-step-toggle{color:var(--nb-err)}.nb-step.nb-running .nb-step-toggle{color:var(--nb-accent)}.nb-step-chevron{transition:transform .15s}.nb-step-toggle[aria-expanded=true] .nb-step-chevron{transform:rotate(90deg)}.nb-step-body{min-width:0}.nb-step-line{text-align:left;width:100%;min-width:0;color:inherit;line-height:1.5;font:inherit;align-items:baseline;gap:8px;display:flex}button.nb-step-line{cursor:pointer}.nb-step-title{white-space:nowrap;flex-shrink:0}.nb-step.nb-running .nb-step-title{animation:1.6s ease-in-out infinite nb-status-pulse}.nb-step-time{font-size:calc(11.5px * var(--nb-font-scale));color:var(--nb-muted);font-variant-numeric:tabular-nums;flex-shrink:0}.nb-step-count{font-size:calc(11.5px * var(--nb-font-scale));color:var(--nb-muted);flex-shrink:0}.nb-step-group>.nb-step-body>.nb-step-group-items{border-left:1px solid var(--nb-line);max-height:none;margin:0 0 2px;padding-left:10px;overflow:visible}.nb-step-detail{min-width:0;font-size:calc(11.5px * var(--nb-font-scale));color:var(--nb-muted);white-space:nowrap;text-overflow:ellipsis;flex:1;overflow:hidden}.nb-step-detail-full{font-size:calc(12px * var(--nb-font-scale));color:var(--nb-muted);white-space:pre-wrap;overflow-wrap:anywhere}.nb-step-data{font-size:calc(12px * var(--nb-font-scale));margin:2px 0 4px}.nb-step pre{background:var(--nb-code);white-space:pre-wrap;word-break:break-word;border-radius:8px;max-height:160px;margin:4px 0;padding:6px 8px;font-size:11px;overflow:auto}.nb-activity-foot{font-size:calc(11.5px * var(--nb-font-scale));color:var(--nb-muted);flex-wrap:wrap;align-items:center;gap:10px;margin-top:4px;padding-left:20px;display:flex}.nb-activity-meta,.nb-activity-elapsed{font-variant-numeric:tabular-nums}@keyframes nb-status-pulse{0%,to{opacity:1}50%{opacity:.6}}.nb-step .nb-tablewrap{max-height:180px;margin-top:6px}@media (prefers-reduced-motion:reduce){.nb-step.nb-running .nb-step-mark,.nb-icon-spin,.nb-step.nb-running .nb-step-title,.nb-logo-pulse,.nb-typing-dots span{animation:none}}.nb-composer{background:var(--nb-bg);flex-shrink:0;padding:8px 14px 12px}.nb-root[data-layout=panel] .nb-composer{padding:10px 12px}.nb-input-container{background:var(--nb-input-bg);border:2px solid var(--nb-input-border);color:var(--nb-input-fg);border-radius:24px;align-items:flex-end;gap:12px;padding:8px 8px 8px 20px;transition:box-shadow .2s;display:flex}.nb-input-container:focus-within{box-shadow:var(--nb-focus)}.nb-composer-input{resize:none;min-height:20px;max-height:120px;color:var(--nb-input-fg);line-height:1.4;font-size:calc(16px * var(--nb-font-scale));background:0 0;border:0;outline:none;flex:1;padding:8px 0;overflow-y:hidden}.nb-composer-input::placeholder{color:var(--nb-input-placeholder)}.nb-composer-input:disabled{opacity:.6}.nb-send,.nb-new{border-radius:50%;flex-shrink:0;justify-content:center;align-items:center;width:40px;height:40px;transition:all .2s;display:flex}.nb-send{background:var(--nb-user-gradient);color:#fff}.nb-new{color:#000;background:#fff;border:1px solid #e5e7eb}.nb-send:hover:not(:disabled),.nb-new:hover:not(:disabled){transform:scale(1.05);box-shadow:0 4px 12px #8b5cf666}.nb-send:disabled,.nb-new:disabled{opacity:.4}.nb-form-context{margin:0 0 8px;display:flex}.nb-form-context-btn{border:1px solid var(--nb-accent);background:var(--nb-accent-soft);max-width:100%;color:var(--nb-fg);font-size:calc(12px * var(--nb-font-scale));cursor:pointer;border-radius:999px;align-items:center;gap:6px;padding:3px 10px;display:inline-flex}.nb-form-context[data-on=false] .nb-form-context-btn{border-style:dashed;border-color:var(--nb-input-border);color:var(--nb-fg-muted);background:0 0}.nb-form-context-label{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.nb-form-context-state{color:var(--nb-fg-muted);white-space:nowrap}.nb-form-context-x{opacity:.6;flex:none}.nb-form-context-btn:hover .nb-form-context-x{opacity:1}.nb-attachments{flex-wrap:wrap;gap:6px;margin:0 0 8px;padding:0;list-style:none;display:flex}.nb-attachment{border:1px solid var(--nb-input-border);background:var(--nb-input-bg);max-width:260px;color:var(--nb-input-fg);font-size:calc(12px * var(--nb-font-scale));border-radius:999px;align-items:center;gap:6px;padding:4px 8px 4px 10px;display:inline-flex}.nb-attachment-name{text-overflow:ellipsis;white-space:nowrap;max-width:180px;overflow:hidden}.nb-attachment-meta{color:var(--nb-fg-muted);white-space:nowrap}.nb-attachment-pending{opacity:.6;animation:1.2s ease-in-out infinite nb-attachment-pulse}@keyframes nb-attachment-pulse{50%{opacity:.35}}.nb-attachment-remove{width:18px;height:18px;color:inherit;opacity:.7;border-radius:50%;justify-content:center;align-items:center;display:inline-flex}.nb-attachment-remove:hover{opacity:1;background:#8b5cf626}.nb-attach{width:40px;height:40px;color:var(--nb-fg-muted);border-radius:50%;flex-shrink:0;justify-content:center;align-items:center;transition:all .2s;display:flex}.nb-attach:hover:not(:disabled){color:var(--nb-input-fg);background:#8b5cf61f}.nb-attach:disabled{opacity:.4}.nb-file-input{display:none}.nb-mic{width:40px;height:40px;color:var(--nb-fg-muted);border-radius:50%;flex-shrink:0;justify-content:center;align-items:center;transition:color .2s,background .2s;display:flex}.nb-mic:hover:not(:disabled){color:var(--nb-input-fg);background:#8b5cf61f}.nb-mic[data-state=recording]{color:#fff;box-shadow:0 0 0 calc(2px + var(--nb-mic-level,0) * 8px) #dc26264d;background:#dc2626}.nb-mic:disabled{opacity:.4}.nb-mic .nb-spin{animation:.8s linear infinite nb-spin}.nb-handsfree{width:40px;height:40px;color:var(--nb-fg-muted);border-radius:50%;flex-shrink:0;justify-content:center;align-items:center;transition:color .2s,background .2s;display:flex}.nb-handsfree:hover:not(:disabled){color:var(--nb-input-fg);background:#8b5cf61f}.nb-handsfree[aria-pressed=true]{color:#fff;background:#7c3aed}.nb-handsfree:disabled{opacity:.4}.nb-handsfree-status{color:var(--nb-fg-muted);font-size:calc(13px * var(--nb-font-scale));align-items:center;gap:8px;margin:0 0 8px;display:flex}.nb-handsfree-dot{background:#7c3aed;border-radius:50%;width:8px;height:8px}.nb-handsfree-status[data-mode=hearing] .nb-handsfree-dot{background:#dc2626}.nb-handsfree-status[data-mode=listening] .nb-handsfree-dot,.nb-handsfree-status[data-mode=hearing] .nb-handsfree-dot,.nb-handsfree-status[data-mode=speaking] .nb-handsfree-dot{animation:1.2s ease-in-out infinite nb-attachment-pulse}.nb-speak[data-state=playing]{color:#7c3aed}.nb-speak .nb-spin{animation:.8s linear infinite nb-spin}.nb-composer-file-error{color:#b42318;font-size:calc(12px * var(--nb-font-scale));margin:0 0 6px 4px}.nb-composer-form{position:relative}.nb-composer-form[data-dragging=true] .nb-input-container{border-style:dashed;border-color:var(--nb-accent-2)}.nb-drop-hint{z-index:1;color:var(--nb-input-fg);font-size:calc(14px * var(--nb-font-scale));pointer-events:none;background:#8b5cf61f;border-radius:24px;justify-content:center;align-items:center;display:flex;position:absolute;top:0;bottom:0;left:0;right:0}.nb-message-attachments{justify-content:flex-end;margin:6px 0 0}.nb-disclaimer{text-align:center;font-size:calc(11px * var(--nb-font-scale));color:#6b7280;margin:6px 0 0}.nb-limit-banner{color:#fff;font-size:calc(14px * var(--nb-font-scale));background:linear-gradient(135deg,#ff6b35 0%,#f7931e 100%);border-radius:12px;justify-content:center;align-items:center;gap:8px;margin-bottom:12px;padding:12px 16px;font-weight:500;display:flex;box-shadow:0 2px 8px #ff6b354d}.nb-thinking{flex-shrink:0;position:relative}.nb-thinking-btn,.nb-thinking-opt{width:36px;height:36px;color:var(--nb-input-placeholder);background:0 0;border:2px solid #8b5cf64d;border-radius:50%;justify-content:center;align-items:center;transition:all .15s;display:flex}.nb-thinking-btn:hover:not(:disabled),.nb-thinking-opt:hover{background:var(--nb-accent-soft);color:var(--nb-input-fg);border-color:#8b5cf699}.nb-thinking-btn.nb-high,.nb-thinking-opt.nb-high.nb-selected,.nb-thinking-opt.nb-high:hover{color:#d5549b;background:linear-gradient(135deg,#8e5ee333,#d5549b33);border-color:#8e5ee3;box-shadow:0 0 12px #d5549b4d}.nb-thinking-btn.nb-expert,.nb-thinking-opt.nb-expert.nb-selected,.nb-thinking-opt.nb-expert:hover{color:#f59e0b;background:linear-gradient(135deg,#f59e0b33,#ef444426);border-color:#f59e0b;box-shadow:0 0 12px #f59e0b66}.nb-thinking-btn:disabled{opacity:.4}.nb-thinking-picker{background:var(--nb-picker-bg);z-index:100;border:1px solid #8b5cf64d;border-radius:24px;flex-direction:column-reverse;gap:6px;padding:8px;animation:.15s ease-out nb-fadeup;display:flex;position:absolute;bottom:calc(100% + 8px);left:50%;transform:translate(-50%);box-shadow:0 4px 20px #0006}@keyframes nb-fadeup{0%{opacity:0;transform:translate(-50%)translateY(8px)}}.nb-thinking-opt.nb-selected{transform:scale(1.1)}@media (max-width:480px){.nb-composer{padding:8px 12px;padding-bottom:max(8px, env(safe-area-inset-bottom))}.nb-input-container{border-radius:20px;padding:6px 6px 6px 14px}.nb-send,.nb-new,.nb-thinking-btn,.nb-thinking-opt{width:32px;height:32px}.nb-composer-input{font-size:16px}}.nb-login{color:#1f2227;background:#fffffff2;border-radius:16px;width:100%;max-width:420px;overflow:hidden}.nb-login .nb-header{flex-direction:column;align-items:flex-start;gap:4px;min-height:0;padding:20px 20px 8px}.nb-login-form{flex-direction:column;gap:12px;padding:16px;display:flex}.nb-login-error{color:#b91c1c;font-size:calc(13px * var(--nb-font-scale))}.nb-login-error.nb-connection{color:#991b1b;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:10px 12px}.nb-login-fixed{color:#374151;background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:10px 12px;font-weight:500}.nb-update-banner{z-index:9999;background:var(--nb-user-gradient);color:#fff;justify-content:center;align-items:center;gap:12px;padding:10px 16px;font-size:14px;font-weight:500;display:flex;position:fixed;top:0;left:0;right:0;box-shadow:0 2px 12px #0000004d}.nb-update-banner button{color:#fff;background:#fff3;border:1px solid #fff6;border-radius:6px;padding:4px 14px;font-size:13px;font-weight:600}.nb-list-controls{font-size:calc(13px * var(--nb-font-scale));color:#64748b;justify-content:space-between;align-items:center;margin-bottom:10px;display:flex}.nb-switch-label{cursor:pointer;align-items:center;gap:6px;display:inline-flex}.nb-empty-state{text-align:center;color:#64748b;padding:32px 16px}.nb-hint{font-size:calc(12px * var(--nb-font-scale));color:#9ca3af;margin-top:6px}.nb-list{flex-direction:column;gap:8px;display:flex}.nb-list-item{background:#fff;border:1px solid #e2e8f0;border-radius:8px;padding:14px 16px;transition:box-shadow .2s}.nb-list-item:hover{box-shadow:0 2px 8px #0000001a}.nb-list-item.nb-current{background:#faf5ff;border-color:#8b5cf6}.nb-list-head{justify-content:space-between;align-items:flex-start;gap:8px;margin-bottom:6px;display:flex}.nb-list-title{font-size:calc(15px * var(--nb-font-scale));color:#1e293b;overflow-wrap:anywhere;flex:1;align-items:center;gap:8px;min-width:0;font-weight:600;display:flex}.nb-list-title.nb-editing .nb-input{min-height:32px;padding:4px 8px}.nb-badge-current{color:#fff;text-transform:uppercase;background:#8b5cf6;border-radius:4px;padding:2px 6px;font-size:10px;font-weight:500}.nb-list-date,.nb-list-meta{font-size:calc(12px * var(--nb-font-scale));color:#9ca3af;white-space:nowrap}.nb-list-preview{color:#64748b;font-size:calc(13px * var(--nb-font-scale));-webkit-line-clamp:2;-webkit-box-orient:vertical;margin:0 0 8px;display:-webkit-box;overflow:hidden}.nb-list-actions{align-items:center;gap:4px;margin-top:8px;display:flex}.nb-list-actions .nb-iconbtn{width:30px;height:30px}@media (max-width:720px){.nb-list-actions{gap:8px;margin-top:12px}.nb-list-actions .nb-btn{flex:auto}.nb-list-actions .nb-iconbtn{width:40px;height:40px}.nb-mcp-actions .nb-btn{flex:auto}}.nb-settings-section+.nb-settings-section{border-top:1px solid var(--nb-dialog-line);margin-top:20px;padding-top:16px}.nb-settings-section h3{letter-spacing:.08em;text-transform:uppercase;opacity:.7;margin-bottom:10px;font-size:11px;font-weight:600}.nb-settings-head{justify-content:space-between;align-items:center;display:flex}.nb-settings-row{border-bottom:1px solid var(--nb-dialog-line);grid-template-columns:minmax(0,1fr) minmax(160px,220px);align-items:center;gap:12px 16px;padding:10px 0;display:grid}.nb-settings-row:last-child{border-bottom:0}.nb-settings-label{font-weight:500}.nb-settings-desc{font-size:calc(12px * var(--nb-font-scale));opacity:.7}.nb-settings-row .nb-input,.nb-settings-row .nb-select{background:var(--nb-card);color:var(--nb-card-fg)}.nb-segment{border:1px solid var(--nb-dialog-line);border-radius:10px;display:inline-flex;overflow:hidden}.nb-segment-btn{font-size:calc(13px * var(--nb-font-scale));color:inherit;opacity:.75;padding:6px 12px}.nb-segment-btn+.nb-segment-btn{border-left:1px solid var(--nb-dialog-line)}.nb-segment-btn.nb-selected{background:var(--nb-user-gradient);color:#fff;opacity:1}.nb-memory-list{flex-direction:column;gap:6px;display:flex}.nb-memory-item{font-size:calc(13px * var(--nb-font-scale));grid-template-columns:auto minmax(0,1fr) auto;align-items:center;gap:8px;display:grid}.nb-memory-kind{color:inherit;border-color:var(--nb-dialog-line);background:0 0}.nb-memory-text{overflow-wrap:anywhere}.nb-mcp-list{flex-direction:column;gap:6px;display:flex}.nb-mcp-key{border-bottom:1px solid var(--nb-dialog-line);font-size:calc(13px * var(--nb-font-scale));grid-template-columns:minmax(0,1fr) auto auto;align-items:center;gap:4px 10px;padding:6px 0;display:grid}.nb-mcp-key:last-child{border-bottom:0}.nb-mcp-name{overflow-wrap:anywhere;font-weight:500}.nb-mcp-meta{font-size:calc(12px * var(--nb-font-scale));opacity:.7;grid-column:1/-1}.nb-mcp-prefix{font-family:ui-monospace,Menlo,monospace}.nb-mcp-status{color:inherit;border-color:var(--nb-dialog-line);background:0 0}.nb-mcp-status-active{color:#047857;border-color:#047857}.nb-mcp-status-revoked{opacity:.6;text-decoration:line-through}.nb-mcp-status-expired{opacity:.6}.nb-mcp-status-broken{color:#b42318;border-color:#b42318}.nb-cdoc-intro{margin:0 0 10px}.nb-cdoc-upload{border-bottom:1px solid var(--nb-dialog-line);flex-direction:column;gap:8px;margin-bottom:12px;padding-bottom:12px;display:flex}.nb-cdoc-file{padding:6px}.nb-cdoc-upload-row{justify-content:space-between;align-items:center;gap:8px;display:flex}.nb-cdoc-upload-row .nb-hint{margin-top:0}.nb-cdoc-status{color:inherit;border-color:var(--nb-dialog-line);white-space:nowrap;background:0 0;gap:4px}.nb-cdoc-status-ready{color:#047857;border-color:#047857}.nb-cdoc-status-failed{color:#b42318;border-color:#b42318}.nb-cdoc-error{color:#b42318;font-size:calc(12px * var(--nb-font-scale));overflow-wrap:anywhere;margin:4px 0 0}.nb-cdoc-confirm{flex-wrap:wrap}.nb-cdoc-confirm-text{font-size:calc(13px * var(--nb-font-scale));flex:100%}.nb-mcp-error{color:#b42318}.nb-mcp-form{flex-direction:column;gap:10px;margin-top:10px;display:flex}.nb-mcp-form .nb-input,.nb-mcp-form .nb-select{background:var(--nb-card);color:var(--nb-card-fg)}.nb-mcp-actions{justify-content:flex-end;gap:8px;display:flex}.nb-mcp-secret{border:1px solid var(--nb-accent-2);font-size:calc(13px * var(--nb-font-scale));border-radius:12px;flex-direction:column;gap:8px;margin-top:10px;padding:12px;display:flex}.nb-mcp-warning{color:#b45309;font-weight:500}.nb-mcp-copy{align-items:center;gap:6px;display:flex}.nb-mcp-copy .nb-input{min-width:0;font-family:ui-monospace,Menlo,monospace;font-size:calc(12px * var(--nb-font-scale));background:var(--nb-card);color:var(--nb-card-fg);flex:1}.nb-mcp-snippet{background:var(--nb-card);color:var(--nb-card-fg);font-family:ui-monospace,Menlo,monospace;font-size:calc(11px * var(--nb-font-scale));white-space:pre-wrap;overflow-wrap:anywhere;border-radius:8px;margin:0;padding:8px 10px}@media (max-width:480px){.nb-settings-row{grid-template-columns:1fr}.nb-segment{display:flex}.nb-segment-btn{flex:1 1 0;min-height:40px}}.nb-debug-panel{font-size:calc(12px * var(--nb-font-scale));color:var(--nb-muted);margin-top:10px}.nb-debug-panel>summary{padding:4px 0}.nb-debug-meta{opacity:.8}.nb-debug-table{font-size:12px}.nb-debug-nyce{font-variant-numeric:tabular-nums;padding:6px 0 2px;font-size:12px}.nb-debug-table th{position:static}.nb-debug-total td{border-top:2px solid var(--nb-line);font-weight:600}.nb-context{margin-top:10px}.nb-context-bar{background:var(--nb-track);border-radius:6px;height:12px;margin:6px 0;display:flex;overflow:hidden}.nb-context-part{height:100%;display:block}.nb-context-notes,i.nb-context-notes{background:var(--nb-chart-1)}.nb-context-summary,i.nb-context-summary{background:var(--nb-chart-2)}.nb-context-digests,i.nb-context-digests{background:var(--nb-chart-3)}.nb-context-frames,i.nb-context-frames{background:var(--nb-chart-4)}.nb-frame .nb-actions{gap:8px;margin-top:12px}.nb-usage-head{align-items:center;gap:12px;margin-bottom:14px;display:flex}.nb-usage-head .nb-select{background:var(--nb-card);width:auto;min-width:180px;color:var(--nb-card-fg)}.nb-usage-grid{grid-template-columns:1fr 1fr;gap:12px;display:grid}.nb-usage-card{border:1px solid var(--nb-dialog-line);border-radius:var(--nb-radius-card);padding:12px 16px}.nb-usage-list div{border-bottom:1px solid var(--nb-dialog-line);font-size:calc(13px * var(--nb-font-scale));justify-content:space-between;gap:8px;padding:4px 0;display:flex}.nb-usage-list div:last-child{border-bottom:0}.nb-usage-list dt{opacity:.75}.nb-usage-list dd{font-variant-numeric:tabular-nums;font-weight:600}.nb-usage-list .nb-usage-total dt,.nb-usage-list .nb-usage-total dd{opacity:1;font-weight:700}.nb-usage-limit{margin-top:16px}.nb-usage-track{border-radius:7px;height:14px}.nb-usage-scope{margin-top:10px}.nb-usage-scope-head{font-size:calc(13px * var(--nb-font-scale));flex-wrap:wrap;justify-content:space-between;gap:8px;margin-bottom:4px;display:flex}.nb-usage-scope.nb-exceeded .nb-usage-scope-flag{color:var(--nb-critical)}.nb-usage-scope.nb-warn .nb-usage-scope-flag{color:var(--nb-warning)}.nb-fill-warning{background:var(--nb-warning)}.nb-fill-critical{background:var(--nb-critical)}@media (max-width:560px){.nb-usage-grid{grid-template-columns:1fr}}.nb-feedback{align-items:center;gap:2px;display:inline-flex}.nb-feedback .nb-iconbtn.nb-active{color:var(--nb-accent)}.nb-filters{flex-direction:column;gap:10px;margin-bottom:12px;display:flex}.nb-reply{font-size:calc(13px * var(--nb-font-scale));color:#334155;background:#f8fafc;border-radius:8px;margin:6px 0;padding:8px 10px}.nb-saved-question{font-size:calc(13px * var(--nb-font-scale));color:#fff;background:var(--nb-user-gradient);border-radius:8px;margin:6px 0 8px;padding:8px 10px}.nb-form{flex-direction:column;gap:12px;display:flex}.nb-form .nb-input,.nb-form .nb-textarea{background:var(--nb-card);color:var(--nb-card-fg)}.nb-preview{background:var(--nb-bot-bubble);color:var(--nb-bot-fg);border-radius:12px;padding:12px 16px}.nb-schedule-form{flex-direction:column;gap:12px;display:flex}.nb-schedule-form .nb-input{background:var(--nb-card);color:var(--nb-card-fg)}.nb-schedule-preview{min-height:20px;font-size:calc(13px * var(--nb-font-scale));align-items:center;gap:6px;margin-top:-6px;display:flex}.nb-schedule-preview-ok{color:#047857;font-weight:500}.nb-schedule-preview-error{color:#b91c1c}.nb-schedule-hint{opacity:.6}.nb-schedule-chips{flex-wrap:wrap;align-items:center;gap:6px;display:flex}.nb-schedule-chip{color:inherit;border-color:var(--nb-dialog-line);background:0 0;align-items:center;gap:4px;display:inline-flex}.nb-chip-remove{width:16px;height:16px;color:inherit;opacity:.7;border-radius:50%;justify-content:center;align-items:center;display:inline-flex}.nb-chip-remove:hover{opacity:1;background:#7f7f7f33}.nb-schedule-recipient-input{min-width:120px;font-size:calc(13px * var(--nb-font-scale));flex:160px;padding:4px 8px}.nb-schedule-row{justify-content:space-between;align-items:center;gap:12px;padding:4px 0;display:flex}.nb-schedule-row-label{font-weight:500}.nb-agent-intro{margin:0}.nb-agent-loading{align-items:center;gap:6px;display:flex}.nb-agent-toggle-queries{color:var(--nb-accent,#2563eb);font-size:inherit;text-decoration:underline}.nb-agent-queries{flex-direction:column;gap:8px;max-height:220px;margin:6px 0 0;padding:0;list-style:none;display:flex;overflow:auto}.nb-agent-query{flex-direction:column;gap:2px;display:flex}.nb-agent-query-purpose{font-size:calc(12px * var(--nb-font-scale));opacity:.7}.nb-agent-query-text{font-family:var(--nb-font-mono,ui-monospace, SFMono-Regular, Menlo, monospace);font-size:calc(12px * var(--nb-font-scale));white-space:pre-wrap;overflow-wrap:anywhere;background:#7f7f7f1a;border-radius:6px;padding:6px 8px}.nb-agent-focus{resize:vertical;font-family:inherit}.nb-schedule-kind{font-size:calc(11px * var(--nb-font-scale));color:#1d4ed8;vertical-align:middle;background:#2563eb1f;border-radius:999px;margin-left:6px;padding:0 6px;font-weight:600;display:inline-block}.nb-scheduled-mark{color:#047857;align-items:center;gap:4px;font-weight:500;display:inline-flex}.nb-schedule-list{flex-direction:column;gap:6px;display:flex}.nb-schedule-item{border-bottom:1px solid var(--nb-dialog-line);font-size:calc(13px * var(--nb-font-scale));grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:2px 10px;padding:8px 0;display:grid}.nb-schedule-item:last-child{border-bottom:0}.nb-schedule-item.nb-schedule-disabled .nb-schedule-name,.nb-schedule-item.nb-schedule-disabled .nb-schedule-meta{opacity:.55}.nb-schedule-name{overflow-wrap:anywhere;font-weight:500}.nb-schedule-controls{align-items:center;gap:4px;display:inline-flex}.nb-schedule-meta,.nb-schedule-recipients-line{font-size:calc(12px * var(--nb-font-scale));opacity:.75;overflow-wrap:anywhere;grid-column:1/-1}.nb-schedule-last-error{color:#b91c1c}.nb-schedule-recipients>.nb-hint{margin-top:0;font-weight:400}.nb-menu{display:inline-flex;position:relative}.nb-menu-list{z-index:var(--nb-z-overlay);background:var(--nb-card);min-width:200px;color:var(--nb-card-fg);border:1px solid var(--nb-line);border-radius:10px;flex-direction:column;padding:4px;display:flex;position:absolute;top:calc(100% + 4px);right:0;box-shadow:0 8px 24px #0000002e}.nb-menu-item{color:inherit;font:inherit;font-size:calc(13px * var(--nb-font-scale));text-align:left;cursor:pointer;white-space:nowrap;background:0 0;border:0;border-radius:8px;align-items:center;gap:10px;padding:8px 10px;display:flex}.nb-menu-item:hover:not(:disabled){background:var(--nb-accent-soft)}.nb-menu-item:focus-visible{background:var(--nb-accent-soft)}.nb-menu-item:disabled{opacity:.5;cursor:default}.nb-menu-icon{color:var(--nb-muted);display:inline-flex}.nb-menu-label{flex:1}.nb-menu-badge{position:static}.nb-root[data-layout=panel] .nb-avatar,.nb-root[data-layout=panel] .nb-logo{display:none}.nb-root[data-layout=panel] .nb-header{min-height:0;padding:4px 8px}.nb-report{color:var(--nb-bot-fg);min-width:0}.nb-report-heading{font-size:calc(18px * var(--nb-font-scale));color:var(--nb-card-fg);margin:0 0 8px;font-weight:700}.nb-md{font-size:calc(15px * var(--nb-font-scale));overflow-wrap:anywhere;line-height:1.5}.nb-md>*+*{margin-top:8px}.nb-md p{margin:0}.nb-md p+p{margin-top:8px}.nb-md ul,.nb-md ol{margin:4px 0 8px;padding-left:22px}.nb-md ul{list-style:outside}.nb-md ol{list-style:decimal}.nb-md li,.nb-md li>ul,.nb-md li>ol{margin:2px 0}.nb-md h1,.nb-md h2,.nb-md h3,.nb-md h4,.nb-md h5,.nb-md h6{font-weight:600;font-size:calc(15px * var(--nb-font-scale));margin:10px 0 4px}.nb-md h1,.nb-md h2{font-size:calc(16px * var(--nb-font-scale))}.nb-md strong{font-weight:600}.nb-md em{opacity:.9;font-style:italic}.nb-md code{color:#7c3aed;font-size:calc(13px * var(--nb-font-scale));background:#8b5cf61a;border-radius:4px;padding:1px 5px}.nb-md pre{color:#abb2bf;font-size:calc(13px * var(--nb-font-scale));background:#282c34;border-radius:8px;padding:12px 14px;line-height:1.5;position:relative;overflow:auto}.nb-md pre code{color:inherit;font-size:inherit;background:0 0;padding:0}.nb-md .nb-copy{color:#ffffff80;border-radius:6px;justify-content:center;align-items:center;width:28px;height:28px;display:flex;position:absolute;top:6px;right:6px}.nb-md .nb-copy:hover{color:#fff;background:#ffffff1a}.nb-md .nb-copy.nb-done{color:#4caf50}.nb-md pre[data-nb-artifact]{display:none}.nb-md pre[data-nb-artifact][data-nb-shown]{margin-top:8px;display:block}.nb-md .nb-artifact{border:1px solid var(--nb-border);background:var(--nb-surface-2,var(--nb-surface));border-radius:10px;align-items:center;gap:12px;padding:12px 14px;display:flex}.nb-md .nb-artifact-icon{width:38px;height:38px;color:var(--nb-accent);background:var(--nb-accent-soft,#0000000d);border-radius:8px;flex:none;justify-content:center;align-items:center;display:flex}.nb-md .nb-artifact-text{flex:auto;min-width:0}.nb-md .nb-artifact-title{font-weight:600;font-size:calc(13px * var(--nb-font-scale));overflow-wrap:anywhere}.nb-md .nb-artifact-detail{font-size:calc(12px * var(--nb-font-scale));color:var(--nb-text-muted)}.nb-md .nb-artifact-actions{flex-wrap:wrap;flex:none;gap:6px;display:flex}.nb-md .nb-artifact-btn{border:1px solid var(--nb-border);background:var(--nb-surface);color:var(--nb-text);font-size:calc(12px * var(--nb-font-scale));white-space:nowrap;border-radius:6px;padding:5px 10px}.nb-md .nb-artifact-btn:hover{border-color:var(--nb-accent);color:var(--nb-accent)}.nb-md .nb-artifact-primary{background:var(--nb-accent);border-color:var(--nb-accent);color:var(--nb-on-accent,#fff)}.nb-md .nb-artifact-primary:hover{color:var(--nb-on-accent,#fff);filter:brightness(1.08)}@container (width<=520px){.nb-md .nb-artifact{flex-wrap:wrap}.nb-md .nb-artifact-actions{flex:1 0 100%}}.nb-md table{width:auto;max-width:100%;font-size:calc(13px * var(--nb-font-scale));display:block;overflow-x:auto}.nb-md th,.nb-md td{border-bottom:1px solid var(--nb-line);padding:4px 10px}.nb-md th{text-align:left;font-weight:600}.nb-md blockquote{border-left:3px solid var(--nb-accent);color:var(--nb-muted);margin:8px 0;padding:4px 12px}.nb-md hr{border:0;border-top:1px solid var(--nb-line);margin:12px 0}.nb-md img{border-radius:8px;max-width:100%}.nb-md .katex{font-size:1.05em}.nb-md .katex-display{margin:8px 0;overflow-x:auto}.nb-report.nb-streaming .nb-summary:after{content:\"▍\";color:var(--nb-accent);animation:1s steps(2,end) infinite nb-blink}@keyframes nb-blink{to{opacity:0}}.nb-summary{margin-bottom:8px}.nb-insights{margin:10px 0}.nb-note{border-left:3px solid var(--nb-accent);background:var(--nb-card);font-size:calc(13px * var(--nb-font-scale));color:var(--nb-muted);border-radius:0 8px 8px 0;margin:12px 0 0;padding:10px 12px}.nb-clarification-context{flex-wrap:wrap;gap:6px;margin:0 0 10px;display:flex}.nb-viz{background:var(--nb-card);color:var(--nb-card-fg);border:1px solid var(--nb-line);border-radius:var(--nb-radius-card);box-shadow:var(--nb-card-shadow);min-width:0;margin:12px 0;padding:14px 20px 12px;overflow:hidden}.nb-viz.nb-html{background:#fff;padding:0}.nb-eyebrow{letter-spacing:.08em;text-transform:uppercase;color:var(--nb-muted);flex-wrap:wrap;justify-content:space-between;align-items:center;gap:12px;margin-bottom:10px;font-size:11px;font-weight:600;display:flex}.nb-eyebrow>span{letter-spacing:0;text-transform:none;font-weight:400}.nb-eyebrow .nb-toolbar{gap:2px;margin-left:auto;display:flex}.nb-eyebrow .nb-iconbtn{width:28px;height:28px;color:var(--nb-muted)}.nb-viz .nb-tablewrap{margin:0 -20px -12px}.nb-viz .nb-table th:first-child,.nb-viz .nb-table td:first-child{padding-left:20px}.nb-viz .nb-empty,.nb-viz .nb-error{color:var(--nb-muted);font-size:calc(13px * var(--nb-font-scale));padding:12px 0}.nb-viz .nb-error{color:var(--nb-err);white-space:pre-wrap}.nb-viz .nb-actions{border-top:1px solid var(--nb-line);color:var(--nb-muted);gap:14px;margin:0 -20px -12px;padding:6px 20px;font-size:12px;display:flex}.nb-viz .nb-tablewrap+.nb-actions{margin-top:12px}.nb-actions button{color:var(--nb-accent);font-size:12px}.nb-pair{grid-template-columns:1fr;gap:12px;margin:12px 0;display:grid}.nb-pair>.nb-viz,.nb-pair>.nb-gauge-strip{min-width:0;margin:0}@container nb-shell (width>=900px){.nb-pair{grid-template-columns:1fr 1fr}}.nb-root[data-print=true] .nb-pair{grid-template-columns:1fr}svg.nb-chart{width:100%;height:auto;font:12px var(--nb-font);display:block}svg.nb-chart .nb-grid{stroke:var(--nb-line)}svg.nb-chart .nb-axis{stroke:var(--nb-muted)}svg.nb-chart .nb-tick{fill:var(--nb-muted);font-size:12px}.nb-legend{color:var(--nb-muted);flex-wrap:wrap;gap:14px;margin-bottom:8px;font-size:12px;display:flex}.nb-legend i{vertical-align:-1px;border-radius:2px;width:10px;height:10px;margin-right:6px;display:inline-block}.nb-legend i.nb-legend-line{vertical-align:3px;border-radius:2px;height:3px}.nb-chart-wrap{max-width:820px;margin:0 auto;position:relative}svg.nb-chart .nb-crosshair{stroke:var(--nb-muted);stroke-dasharray:3 3;pointer-events:none}.nb-chart-tip{pointer-events:none;background:var(--nb-card);color:var(--nb-card-fg);border:1px solid var(--nb-line);box-shadow:var(--nb-card-shadow);white-space:nowrap;z-index:2;border-radius:8px;padding:6px 10px;font-size:12px;position:absolute;top:4px}.nb-chart-tip-label{color:var(--nb-muted);margin-bottom:2px}.nb-chart-tip-row{align-items:center;gap:6px;display:flex}.nb-chart-tip-row i{border-radius:2px;flex:none;width:8px;height:8px}.nb-chart-tip-row b{font-variant-numeric:tabular-nums;margin-left:auto}.nb-gauge-strip{margin:12px 0}.nb-gauges{flex-wrap:wrap;justify-content:center;gap:16px;display:flex}.nb-gauge{text-align:center;flex:220px;min-width:200px;max-width:360px}.nb-gauge-title{letter-spacing:.08em;text-transform:uppercase;color:var(--nb-muted);margin-bottom:4px;font-size:11px;font-weight:600}svg.nb-dial{width:100%;height:auto;display:block}svg.nb-dial .nb-track{stroke:var(--nb-track);fill:none;stroke-linecap:round}svg.nb-dial .nb-target{stroke:var(--nb-card-fg)}svg.nb-dial .nb-big{fill:var(--nb-card-fg);font-size:40px;font-weight:800;font-family:var(--nb-font)}svg.nb-dial .nb-unit,.nb-kpi .nb-unit{fill:var(--nb-muted);color:var(--nb-muted);font-size:16px;font-weight:500}svg.nb-dial .nb-tick{fill:var(--nb-muted);font-size:12px;font-family:var(--nb-font)}.nb-kpi{padding:18px 0;font-size:40px;font-weight:800}.nb-gauge-foot{color:var(--nb-muted);font-size:12px}.nb-dot{vertical-align:1px;border-radius:50%;width:8px;height:8px;margin-right:5px;display:inline-block}.nb-progress{grid-template-columns:minmax(90px,160px) 1fr auto;align-items:center;gap:8px 12px;display:grid}.nb-progress.nb-compare{grid-template-columns:minmax(90px,160px) 1fr auto auto}.nb-progress-head,.nb-progress-row{display:contents}.nb-progress-head span{color:var(--nb-muted);text-transform:uppercase;letter-spacing:.06em;font-size:11px}.nb-progress-label{overflow-wrap:anywhere;font-size:13px;font-weight:600}.nb-progress-label small,.nb-progress-value small{color:var(--nb-muted);font-size:11px;font-weight:400;display:block}.nb-track{background:var(--nb-track);border-radius:5px;height:10px;overflow:hidden}.nb-fill{background:var(--nb-accent);border-radius:5px;height:100%}.nb-progress-value{text-align:right;font-variant-numeric:tabular-nums;white-space:nowrap;font-size:13px}.nb-progress-value b{font-weight:700}.nb-progress-compare{text-align:right;color:var(--nb-muted);font-variant-numeric:tabular-nums;white-space:nowrap;font-size:13px}@container nb-shell (width<=480px){.nb-progress,.nb-progress.nb-compare{grid-template-columns:1fr;gap:2px}.nb-progress-row{margin-bottom:10px;display:block}.nb-progress-head{display:none}.nb-progress-value{text-align:left}}iframe.nb-htmlviz{border-radius:var(--nb-radius-card);background:#fff;border:0;width:100%;height:300px;display:block;overflow:hidden}.nb-log-head{flex-wrap:wrap;align-items:center;gap:8px;display:flex}.nb-log-entry{border-bottom:1px solid var(--nb-line);font-family:var(--nb-mono);grid-template-columns:auto auto 1fr;align-items:start;gap:8px;padding:4px 0;font-size:12px;display:grid}.nb-log-entry>summary{display:contents}.nb-log-ts{color:var(--nb-muted);white-space:nowrap}.nb-log-msg{white-space:pre-wrap;word-break:break-word}.nb-log-entry pre{color:#abb2bf;white-space:pre-wrap;background:#282c34;border-radius:6px;grid-column:1/-1;max-height:300px;padding:8px 10px;overflow:auto}.nb-sev{font-family:var(--nb-mono);color:#fff;background:#6b7280;border-radius:10px;align-items:center;height:20px;padding:0 6px;font-size:10px;display:inline-flex}.nb-sev-error{background:var(--nb-critical)}.nb-sev-warning{background:var(--nb-warning)}.nb-sev-info{background:var(--nb-chart-2)}.nb-evidence{color:var(--nb-muted);font-size:calc(13px * var(--nb-font-scale));margin:12px 0 0}.nb-evidence>summary{align-items:center;gap:6px;padding:6px 0;display:flex}.nb-evidence[open]>summary{color:var(--nb-card-fg)}.nb-card{background:var(--nb-card);color:var(--nb-card-fg);border:1px solid var(--nb-line);border-radius:10px;margin:10px 0;overflow:hidden}.nb-card.nb-highlight{border-color:var(--nb-accent)}.nb-card-head{border-bottom:1px solid var(--nb-line);flex-wrap:wrap;justify-content:space-between;gap:12px;padding:8px 14px;font-size:13px;font-weight:600;display:flex}.nb-card-head small{color:var(--nb-muted);white-space:nowrap;font-weight:400}.nb-card .nb-q-scope{color:var(--nb-muted);border-bottom:1px solid var(--nb-line);padding:4px 14px 6px;font-size:12px}.nb-card pre.nb-q{background:var(--nb-code);white-space:pre-wrap;word-break:break-word;border-bottom:1px solid var(--nb-line);margin:0;padding:10px 14px;font-size:12px;line-height:1.5}.nb-card pre.nb-code{color:#abb2bf;white-space:pre;border-bottom:1px solid var(--nb-line);background:#282c34;max-height:40vh;margin:0;padding:10px 14px;font-size:12px;line-height:1.5;overflow-x:auto}.nb-card pre.nb-dict{white-space:pre-wrap;margin:0;padding:10px 14px;font-size:13px;line-height:1.5}.nb-card .nb-stdout{color:var(--nb-muted);font-family:var(--nb-mono);white-space:pre-wrap;border-top:1px solid var(--nb-line);padding:6px 14px;font-size:12px}.nb-card .nb-error{color:var(--nb-err);white-space:pre-wrap;padding:10px 14px;font-size:13px}.nb-card .nb-actions{border-top:1px solid var(--nb-line);color:var(--nb-muted);gap:14px;padding:6px 14px;font-size:12px;display:flex}.nb-card .nb-tablewrap{max-height:40vh}.nb-card details>summary{color:var(--nb-muted);padding:6px 14px;font-size:12px}.nb-docs{padding:6px 14px}.nb-docs details{margin:6px 0}.nb-docs details>summary{padding:0}.nb-debug{font-family:var(--nb-mono);color:var(--nb-muted);white-space:pre-wrap;background:var(--nb-code);border-radius:8px;max-height:200px;margin-top:8px;padding:8px 10px;font-size:11px;overflow:auto}@media (max-width:719px){.nb-card-head{flex-direction:column;gap:2px}.nb-card-head small{white-space:normal}.nb-tablewrap{max-height:60vh}}.nb-md .nb-img,.nb-viz .nb-img,.nb-img{vertical-align:middle;background:var(--nb-code);border-radius:6px;max-width:100%;height:auto;display:inline-block}.nb-img-loading{background:var(--nb-code);opacity:.6;border-radius:6px;width:96px;height:64px;display:inline-block}.nb-img-thumb{object-fit:contain;max-width:96px;max-height:96px}.nb-img-cell{vertical-align:middle}.nb-img-missing{color:var(--nb-muted);background:var(--nb-code);border-radius:4px;padding:1px 6px;font-size:12px;display:inline-block}.nb-pie-wrap{flex-wrap:wrap;align-items:center;gap:16px;display:flex}.nb-pie-wrap svg.nb-pie{flex:none;width:220px;max-width:100%}svg.nb-pie .nb-slice{stroke:var(--nb-card,#fff);stroke-width:1.5px;cursor:default}svg.nb-pie .nb-pie-total{fill:var(--nb-text);font-size:22px;font-weight:600}.nb-pie-legend{flex:200px;margin:0;padding:0;font-size:13px;list-style:none}.nb-pie-legend li{border-radius:6px;grid-template-columns:14px 1fr auto auto;align-items:center;gap:8px;padding:3px 6px;display:grid}.nb-pie-legend li.nb-active{background:var(--nb-code)}.nb-pie-legend i{border-radius:2px;width:10px;height:10px;display:inline-block}.nb-pie-legend b{font-weight:600}.nb-pie-legend em{color:var(--nb-muted);text-align:right;min-width:48px;font-style:normal}.nb-radar-wrap{justify-content:center;display:flex}.nb-radar-wrap svg.nb-radar{width:100%;max-width:420px}svg.nb-radar .nb-grid{stroke:var(--nb-line)}svg.nb-hbars{width:100%;height:auto}svg.nb-hbars .nb-hbar-value{fill:var(--nb-text)}.nb-heatmap-scroll{overflow-x:auto}.nb-heatmap-grid{border-collapse:separate;border-spacing:2px;font-size:12px}.nb-heatmap-grid th{color:var(--nb-muted);white-space:nowrap;padding:2px 6px;font-weight:500}.nb-heatmap-grid th.nb-heatmap-col{text-align:center;vertical-align:bottom}.nb-heatmap-grid th.nb-heatmap-row{text-align:right}.nb-heatmap-cell{text-align:center;color:#222;font-variant-numeric:tabular-nums;border-radius:4px;min-width:36px;padding:4px 6px}.nb-heatmap-empty{background:var(--nb-code)}.nb-heatmap-scale{color:var(--nb-muted);align-items:center;gap:8px;margin-top:8px;font-size:12px;display:flex}.nb-heatmap-scale i{border-radius:4px;flex:0 160px;height:8px;display:inline-block}.nb-widget{color:var(--nb-bot-fg);margin:8px 0}.nb-widget-prompt{margin-bottom:8px}.nb-widget-prompt.nb-strong{margin-bottom:12px;font-weight:500}.nb-chips{flex-wrap:wrap;align-items:center;gap:8px;display:flex}.nb-widget-row{flex-wrap:wrap;align-items:center;gap:8px;margin-top:8px;display:flex}.nb-widget-row .nb-input,.nb-widget-row .nb-select{flex:220px;width:auto;min-width:180px;min-height:36px}.nb-widget-free{align-items:center;gap:8px;margin-top:8px;display:flex}.nb-widget-free .nb-input{min-height:36px}.nb-questionnaire-q{margin-bottom:14px}.nb-questionnaire-q+.nb-questionnaire-q{border-top:1px solid var(--nb-line);padding-top:12px}.nb-questionnaire-q .nb-widget-prompt{margin-bottom:6px}.nb-resolved{flex-direction:column;align-items:flex-start;gap:8px;display:flex}.nb-pdf{color:#1f2227;background:#fff;padding:24px}.pdf-content{color:#1f2227;--nb-font-scale:.9;width:690px;max-width:100%;margin:0 auto}.nb-pdf-head{border-bottom:2px solid #c2417f;justify-content:space-between;align-items:flex-start;margin-bottom:16px;padding-bottom:10px;display:flex}.nb-pdf-meta{text-align:right;color:#6b7280;font-size:12px}.nb-pdf-question{margin-bottom:12px;font-size:15px;font-weight:600}.nb-pdf-title{font-size:calc(20px * var(--nb-font-scale));margin:0 0 14px;font-weight:700}.nb-pdf-ask{break-after:avoid;break-inside:avoid;border-left:3px solid #c2417f;margin:18px 0 8px;padding-left:10px}.nb-pdf-ask .nb-pdf-question{margin-bottom:0}.nb-pdf-answer{margin-bottom:18px}.nb-pdf-answer+.nb-pdf-ask{border-top:1px solid #e5e7eb;margin-top:22px;padding-top:14px}.nb-pdf-plain{white-space:pre-wrap;font-size:calc(15px * var(--nb-font-scale))}.nb-pdf-failed{color:#b42318;font-size:calc(13px * var(--nb-font-scale))}.nb-pdf-omitted{color:#6b7280;font-size:calc(12px * var(--nb-font-scale));border-top:1px solid #e5e7eb;margin-top:18px;padding-top:10px}.pdf-content .nb-pair,[data-print=true] .nb-pair{grid-template-columns:1fr!important}.pdf-content .nb-toolbar,.pdf-content .nb-actions,.pdf-content .nb-artifact-actions,.pdf-content .nb-copy,.pdf-content .nb-evidence>summary,.pdf-content .nb-card details>summary{display:none!important}.pdf-content .nb-evidence{color:#1f2227}.pdf-content details>summary{display:none!important}.pdf-content .nb-card pre.nb-code,.pdf-content pre.nb-q,.pdf-content pre.nb-dict{white-space:pre-wrap;max-height:none;overflow:visible;color:#1f2227!important;background:#f0f2f5!important}.pdf-content iframe.nb-htmlviz{break-inside:avoid}.pdf-content .nb-evidence>.nb-evidence{margin:0}.pdf-content .nb-tablewrap{max-height:none;overflow:visible}.pdf-content .nb-table th{position:static}.pdf-content .nb-table th,.pdf-content .nb-table td{white-space:normal;vertical-align:top;padding:5px 7px}.pdf-content .nb-table td{overflow-wrap:anywhere}.pdf-content .nb-tablewrap,.pdf-content .nb-table{max-width:100%}.pdf-content .nb-table th{letter-spacing:.04em}.pdf-content .nb-viz,.pdf-content .nb-card{break-inside:avoid;box-shadow:none}.pdf-content pre.nb-code{white-space:pre-wrap;max-height:none}@media print{.nb-pdf{padding:0}.pdf-content{width:100%}.nb-root .nb-update-banner,.nb-root .nb-composer,.nb-root .nb-header-actions,.nb-root .nb-typing{display:none!important}}", so = !1;
function co(e) {
	if (so && !e) return;
	let t = e == null ? typeof document < "u" ? document : void 0 : e;
	if (!t) return;
	let n = t instanceof Document ? t.head : t;
	if (n.querySelector("style[data-nb-styles]")) return;
	let r = (t instanceof Document ? t : document).createElement("style");
	r.setAttribute("data-nb-styles", ""), r.textContent = oo, n.appendChild(r), e || (so = !0);
}
var lo = oo;
export { nr as ACCENT_COLOR, ba as ActivityList, si as AdminFeedbackDrawer, pn as AgentDialog, kn as ArtifactActionsProvider, fa as AssistantMessage, Qi as AttachmentChips, Li as BuddyProvider, f as Button, $ as CHART_COLORS, gr as ChartCard, Hi as ChatHeader, r as Chip, ti as ClarificationContext, Ia as Composer, mi as CustomerDocumentsDrawer, Mi as DEFAULT_FEATURES, Dt as DEFAULT_SETTINGS, Qn as DataTable, sa as DebugPanel, h as Dialog, pt as EMPTY_STATE, aa as EvidencePanel, ca as FeedbackBar, ai as FeedbackRepliesDrawer, Ra as FormContextChip, $i as FrameTable, Ar as Gauge, jr as GaugeStrip, yr as HeatmapCard, jt as HistoryDrawer, lr as HorizontalBars, zr as HtmlCard, n as IconButton, Ln as ImageSourceProvider, Pa as LimitBanner, Wr as LogTable, Nr as MAX_HTML_SIZE, Q as Markdown, bn as MathContext, rn as McpKeysSection, Zt as MemorySection, ki as MessageActions, pa as MessageList, T as NYCE_LANGUAGE_CODES, Bn as NbImage, Qa as NyceBuddyChat, Kr as OptionsWidget, ao as PdfConversation, io as PdfReport, sr as PieChart, Mr as ProgressCard, Qr as QuestionnaireWidget, cr as RadarChart, ei as ReportRows, ni as ReportView, tr as STATE_COLORS, _i as SaveResponseDialog, vi as SavedResponsesDrawer, Yt as ScheduleDialog, sn as ScheduledCardsSection, s as Select, fn as SettingsDialog, l as Spinner, Sa as StreamingIndicator, qr as StructuredInputWidget, o as Switch, $n as TableCard, u as TextField, b as ThemeRoot, Ma as ThinkingPicker, p as Tooltip, S as TranslationProvider, yn as UsageDialog, da as UserMessage, vt as askStreamReducer, zi as assets, m as cellText, Bt as copyText, St as createStorage, Qe as demath, Dn as detectArtifact, It as downloadBlob, zt as downloadCsv, Ke as fixControls, d as fmt, La as formContextText, dt as hasMath, _r as heatColor, Rn as hydrateImages, co as injectStyles, Jn as layoutRows, t as loadFonts, Je as loadKatex, E as makeTranslate, en as mcpSnippet, $t as mcpUrlOf, tt as md, Ct as newId, er as niceTicks, Or as normalizeGaugeState, w as nyceToLanguage, ft as parsePartialReport, ft as partialReport, Zr as parseQuestionnaireAnswer, Oi as pdfFileName, ut as renderMarkdown, Ye as renderMath, We as repairEscapes, kr as resolveGaugeState, lt as sanitizeHtml, Gn as splitGaugeStrips, lo as stylesText, Pt as toCsv, Ft as toTsv, ii as unreadReplies, yt as useAskStream, Pi as useBuddy, Fi as useBuddyOptional, Tt as useConversation, Fn as useImageSource, In as useImagesPending, ji as useRoles, Et as useScrollManagement, e as useTheme, C as useTranslation, Ri as useUserFilters, kt as useUserSettings };

//# sourceMappingURL=index.js.map